import React, { Fragment } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import ReactDOMServer from 'react-dom/server';

import axios from "axios";
import { Redirect } from "react-router-dom";

import {
  PanelHeader,
  FormInputs,
  CardAuthor,
  CardSocials,
  Button,
  Timeline,
  Statistics,
  BillsTable
} from "components";

import { theadcustomerscommunications, theadwebmobilerequestsmini, theadsimdeliveriesmini, widgetStories, tasks, thead, tbody, theadcontracts, theadcontracttemplates, } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { validateSpanishId } from "spain-id";
import { actions } from "react-table";
import { theadhomevisits, theadtickets } from "../../variables/general";
import moment from "moment";
import "moment/locale/es";
import { duration } from "moment";
import { faWpressr } from "@fortawesome/free-brands-svg-icons";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, AreaChart, ResponsiveContainer, Area, Legend } from 'recharts';
import { useCallback } from "react";
import { v4 as uuid } from 'uuid';
import { Select as AntdSelect, Space, DatePicker, Button as ModalButton, Modal, TimePicker } from "antd";
import { Avatar, Card as LoadingCard, Skeleton, Switch } from 'antd';
const { Meta } = Card;

const procedureType = [
  { value: "171", label: "Portabilidad" },
  { value: "172", label: "Alta" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

const previousContract = [
  { value: "196", label: "Contrato" },
  { value: "195", label: "Prepago" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var noteType = [
  { value: "59", label: "General" },
  { value: "60", label: "Incidencia" },
  { value: "62", label: "Log" },
  { value: "61", label: "Solución" },
  { value: "214", label: "Devolución" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var internetType = [
  { value: "197", label: "WiFi" },
  { value: "198", label: "Fibra óptica" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var extraExpenseType = [
  { value: "128", label: "Recurrente" },
  { value: "127", label: "Único" },
  { value: "129", label: "Fraccionado" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var mobileStatus = [
  { value: "205", label: "Activado" },
  { value: "207", label: "Bloqueado por fraude" },
  { value: "208", label: "Impago" },
  { value: "206", label: "Pre-Activado" },
  { value: "209", label: "Terminado" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var customerType = [
  { value: "91", label: "Autónomo" },
  { value: "90", label: "Empresa" },
  { value: "92", label: "Extranjero" },
  { value: "89", label: "Particular" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var documentType = [
  { value: "93", label: "DNI" },
  { value: "94", label: "NIE" },
  { value: "95", label: "NIF" },
  { value: "96", label: "Pasaporte" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});
const groupByID = groupBy("id");

const formatterCurrency = new Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR'
});

const TRAMITE = "tramite";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const ERROR_ACTIVAR_RENOVACION = "error-renovacion";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";
const ESTADO_FACTURA = "estado-factura";
const HISTORIAL_PAGOS = "historial-pagos";
const PASSWORD = "change-password";
const TV = "TV";
const EMPTY_PROCEDURE_FORM = {
  phoneNumber: "",
  ICC: "",
  selectedPlan: null
};

const PILL_GASTOS = "gastos";
const PILL_MOVILES = "moviles";
const PILL_TV = "TV";
const PILL_CONTRATOS = "contratos";
const PILL_FACTURAS = "facturas";
const PILL_CITAS = "citas";
const PILL_COMUNICACIONES = "comunicaciones";
const PILL_TICKETS = "tickets";
const PILL_SECRET = "secret";

const CONTRATO_ESPERANDO = 229;
const CONTRATO_FICHA_LISTA = 231;
const CONTRATO_FIRMADO = 230;
const CONTRATO_RELLENANDO = 238;
const EMAIL = "email";
const SMS = "sms";
const CALL = "call";
const VISIT = "visit";

const API = !window.location.host.includes("localhost") ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const GET_PAYMENT_LINK = "nadunet_billing_resources/generate_recharge_url";
var checkICC = (function(a) {
  return function(c) {
    for (var l = c.length, b = 1, s = 0, v; l; )
      (v = parseInt(c.charAt(--l), 10)), (s += (b ^= 1) ? a[v] : v);
    return s && 0 === s % 10;
  };
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

var checkIBAN = (function() {
  // use an IIFE
  // A "constant" lookup table of IBAN lengths per country
  // (the funky formatting is just to make it fit better in the answer here on CR)
  var CODE_LENGTHS = {
    AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
    FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
    HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
    LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
    MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
    RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };

  // piece-wise mod97 using 9 digit "chunks", as per Wikipedia's example:
  // http://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
  function mod97(string) {
    var checksum = string.slice(0, 2),
        fragment;

    for(var offset = 2 ; offset < string.length ; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  // return a function that does the actual work
  return function (input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),           // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;

    // check syntax and length
    if(!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    // final check
    return mod97(digits) === 1;
  };
}());

var lastUpdateCustomer = 0;
var isExterno = false;

const countStyle = {
  padding: "2px 4px",
  borderRadius: "4px",
  background: "rgba(0,0,0,0.25)"
};

const SQUARED_VIEW = "squared_view";
const ROW_VIEW = "row_view";
class CustomerProfile extends React.Component {
  constructor(props) {
    super(props);

    let currentCustomer = null;

    try {
      currentCustomer = this.props.mainState.customers[
        this.props.match.params.customerID
      ][0];      
    } catch (error) {
      console.log("Cliente no cargado... Solicitando información al servidor.");
      // this.props.searchBulkCustomer([this.props.match.params.customerID]);
    }

    this.state = {
      customer: currentCustomer,
      last_customer_update: 0,
      phoneNumber: "",
      ICC: "",
      mobileProceduresAlreadySearched: false,
      SIMDeliveriesAlreadySearched: false,
      fieldStates: [],
      fieldsToValidate: ["phoneNumber", "ICC"],
      fieldsToValidateSIMDelivery: ["ICC"],
      latestValidatedIBAN: "",
      noteType: "",
      noteTitle: "",
      noteText: "",
      iban: "",
      extraExpenseType: "",
      extraExpenseConcept: "",
      extraExpenseFees: "",
      extraExpensePrice: "",
      extraExpenseID: null,
      extraExpensesLoaded: false,
      procedureType: "",
      SIMCoverage: "",
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      editingMobileID: null,
      billsSearched: false,
      // <Campos editar usuario>
      direccion: null,
      localidad: null,
      codigo_postal: null,
      nombre: null,
      primer_apellido: null,
      segundo_apellido: null,
      nif: null,
      movil: null,
      email: null,
      currentPill: PILL_GASTOS,
      customerType: {},
      documentType: {},
      // </Campos editar usuario>
      // <Campos editar empresa - Gerente>
      nif_manager: null,
      nombre_manager: null,
      primer_apellido_manager: null,
      segundo_apellido_manager: null,
      // </Campos editar empresa - Gerente>
      alreadySearchedContracts: false,
      new_email: {},
      new_communication: [],
      noteFilter: null,
      showDisabledMobiles: false,
      showDisabledExpenses: false,
      extraExpensesView: ROW_VIEW,
      toggleTrafficChart: null,
      mobileDiscount: null,
      dataBonus: null,
      paymentLink: "",
      newBillForm: false,
      billItems: []
    };

    if (currentCustomer) {
      this.state.latestValidatedIBAN = this.validateIBAN(currentCustomer.cuenta_bancaria) ? currentCustomer.cuenta_bancaria.replace(/ /g, "") : "";
    }
    /* ////console.log(props); */
    this.createMobiles = this.createMobiles.bind(this);
    this.createMobileProcedurePopUp = this.createMobileProcedurePopUp.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.cancelProcedure = this.cancelProcedure.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createDeliveryPopUp = this.createDeliveryPopUp.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createActionButtons = this.createActionButtons.bind(this);
    this.validateField = this.validateField.bind(this);
    this.createRightColumn = this.createRightColumn.bind(this);
    this.validateNewProcedure = this.validateNewProcedure.bind(this);
    this.validateNewNote = this.validateNewNote.bind(this);
    this.newMobileProcedureConfirmation = this.newMobileProcedureConfirmation.bind(this);
    this.newNoteConfirmation = this.newNoteConfirmation.bind(this);
    this.createServicesButtons = this.createServicesButtons.bind(this);
    this.configureInternetPopUp = this.configureInternetPopUp.bind(this);
    this.disableInternet = this.disableInternet.bind(this);
    this.disableTV = this.disableTV.bind(this);
    this.errorRenovation = this.errorRenovation.bind(this);
    this.mobileNumberChange = this.mobileNumberChange.bind(this);
    this.addMobile = this.addMobile.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.showProcedurePopUpFromRequest = this.showProcedurePopUpFromRequest.bind(this);
    this.createChangePasswordPopUp = this.createChangePasswordPopUp.bind(this);
    this.devUser = this.devUser.bind(this);
    this.discardUserChanges = this.discardUserChanges.bind(this);
    this.areUserChangesToSave = this.areUserChangesToSave.bind(this);
    this.editCustomer = this.editCustomer.bind(this);
    this.createNavigationPills = this.createNavigationPills.bind(this);
    this.createSelectedPillContent = this.createSelectedPillContent.bind(this);
    this.createTvPill = this.createTvPill.bind(this);
    this.validateConfigureTV = this.validateConfigureTV.bind(this);
    this.isCompany = this.isCompany.bind(this);
    this.newContract = this.newContract.bind(this);
    this.newHomeVisit = this.newHomeVisit.bind(this);
    this.createHomeVisits = this.createHomeVisits.bind(this);
    this.customFilter = this.customFilter.bind(this);
    this.newCommunicationToCustomer = this.newCommunicationToCustomer.bind(this);
    this.updateNewEmail = this.updateNewEmail.bind(this);
    this.updateNewCommunication = this.updateNewCommunication.bind(this);
    this.create_communication = this.create_communication.bind(this);
    this.isExistingMobileNeeded = this.isExistingMobileNeeded.bind(this);
    this.isIccNeeded = this.isIccNeeded.bind(this);
    this.customerMobilesForOptions = this.customerMobilesForOptions.bind(this);
    this.getExtraExpensesCount = this.getExtraExpensesCount.bind(this);
    this.getMobilesCount = this.getMobilesCount.bind(this);
    this.getTvCount = this.getTvCount.bind(this);
    this.getContractsCount = this.getContractsCount.bind(this);
    this.getBillsCount = this.getBillsCount.bind(this);
    this.getHomeVisitsCount = this.getHomeVisitsCount.bind(this);
    this.getCommunicationsCount = this.getCommunicationsCount.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.createSIMDeliveriesTable = this.createSIMDeliveriesTable.bind(this);
    this.loadSIMDeliveryTypesOptions = this.loadSIMDeliveryTypesOptions.bind(this);
    this.filterNotes = this.filterNotes.bind(this);
    this.isReturnedBill = this.isReturnedBill.bind(this);
    this.areReturnedBills = this.areReturnedBills.bind(this);
    this.calculateReturnedBills = this.calculateReturnedBills.bind(this);
    this.buildHeaderServices = this.buildHeaderServices.bind(this);
    this.calculateMonthlyPrice = this.calculateMonthlyPrice.bind(this);
    this.newTicket = this.newTicket.bind(this);
    this.getSecretsTraffic = this.getSecretsTraffic.bind(this);
    this.toggleTrafficChart = this.toggleTrafficChart.bind(this);
    this.generateServicesContract = this.generateServicesContract.bind(this);
    this.setGeneratedProductsForNewContract = this.setGeneratedProductsForNewContract.bind(this);
    this.showBalance = this.showBalance.bind(this);
    this.getPaymentLink = this.getPaymentLink.bind(this);
    this.reloadOrder = this.reloadOrder.bind(this);
    this.createNewBillForm = this.createNewBillForm.bind(this);
    this.createCustomerBill = this.createCustomerBill.bind(this);
    this.handleSelectedBillTypeChange = this.handleSelectedBillTypeChange.bind(this);
    this.getRectificationBillItems = this.getRectificationBillItems.bind(this);
    this.generateRectificationBillItems = this.generateRectificationBillItems.bind(this);
    this.selectedRectificationBills = this.selectedRectificationBills.bind(this);
    this.setPayday = this.setPayday.bind(this);

    this.props.cleanContract();
    this.props.searchWebMobileRequests(this.props.match.params.customerID, null, null, false, false, true);
    this.props.getCustomerNotes(this.props.match.params.customerID);
    this.props.userData.getCustomerHomeVisits(this.props.match.params.customerID);
    // console.log(currentCustomer);
    if (currentCustomer) {
      this.props.searchBillsByCustomerID(currentCustomer.id, null, true);
      this.state.billsSearched = true;
    }

    let externalUsers = [
      "Oniti"
    ];
    isExterno = false;
    if (externalUsers.indexOf(this.props.mainState.user.name)  > -1) {
      isExterno = true;
    }
  }
  async setPayday(day) {
    if (this.state.changingPayday) return;
    this.setState({ changingPayday: true });
    let payday = {
      day: day,
      customer: this.state.customer.id 
    }
    this.props.userData.setPayday(payday).then(result => {
      this.setState({ changingPayday: false });
      if (result.ok) {
        this.props.searchBulkCustomer([this.props.match.params.customerID]);
        console.log("Payday changed to", day);
      } else {
        console.log("Something went wrong changing payday: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({ changingPayday: false });
      // Error 😨
      console.log("Something went wrong changing payday: " + error.message);
      // console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  handleSelectedBillTypeChange(value) {
    this.setState({ selectedBillType: value });
  }
  buildHeaderServices() {
    let result = [];
    let mobiles = null;
    
    let internetIcon = "now-ui-icons location_world";
    let internetColor = this.state.customer.internet_activo === "1" ? "#5279BF" : "#888888";
    let internetCoverageColor = "transparent";
    if (this.state.customer.internet_tarifa) {
      try {
        internetCoverageColor = this.state.customer.internet_tarifa.toLowerCase().includes("fibra") ? "#FFB236" : "#46B98A";
      } catch (error) {
        console.log("Error al comprobar el tipo de tarifa de internet:", error);
        console.log("this.state.customer.internet_tarifa", this.state.customer.internet_tarifa);
        internetCoverageColor = "#F00";
      }
    }
    let internetCoverage = [];
    let coverageStyle = {
      position: "relative",
      top: "-2px",
      left: "5px",
      width: "3px",
      height: "3px",
      borderRadius: "50%",
      background: internetCoverageColor
    }
    internetCoverage.push(<div key={"internet-coverage"} style={coverageStyle}></div>);

    let internet = (
      <div key={"internet"} style={{ display: "inline-block", marginRight: "5px" }}>
        {internetCoverage}
        <span style={{ color: internetColor }}><i className={internetIcon} /></span>
      </div>
    );
    result.push(internet);

    let tvIcon = "now-ui-icons tech_tv";
    let tvColor = this.state.customer.tv && this.state.customer.tv.isActive ? "#FFB236" : "#888888";
    let tvCoverageColor = "transparent";
    let tvCoverage = [];
    coverageStyle = {
      position: "relative",
      top: "-2px",
      left: "5px",
      width: "3px",
      height: "3px",
      borderRadius: "50%",
      background: tvCoverageColor
    }
    tvCoverage.push(<div key={"tv-coverage"} style={coverageStyle}></div>);

    let tv = (
      <div key={"tv"} style={{ display: "inline-block", marginRight: "3px" }}>
        {tvCoverage}
        <span style={{ color: tvColor }}><i className={tvIcon} /></span>
      </div>
    );
    result.push(tv);

    if (this.props.mainState.customersMobilesLoaded) {
      let mobilesQuantity = 0;
      // Comprobamos que haya móviles del cliente
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      // Si los hay, comenzamos
      if (mobilesQuantity > 0) {
        mobiles = this.props.mainState.customersMobiles[this.state.customer.id].map(
          (mobile, key) => {
            let coverageStyle = {};
            // console.log("mobile", mobile);
            if (mobile.estado && mobile.estado.toLowerCase() !== "terminado") {
              let coverage = null;
              if (mobile.cobertura && mobile.cobertura.cobertura && mobile.cobertura.cobertura.length > 0) {
                // <div style={{ coverageStyle }}></div>
                mobile.cobertura.cobertura.map((currentCoverage, key) => {
                  coverageStyle = {
                    position: "relative",
                    top: "-2px",
                    left: (parseInt(key) * 3 + 5) + "px",
                    width: "3px",
                    height: "3px",
                    borderRadius: "50%",
                    background: currentCoverage.color
                  }
                  if (!coverage) coverage = [];
                  coverage.push(<div key={key} style={coverageStyle}></div>);
                });
              }
              let color = this.defineMobileColor(mobile, true);

              return (
                <div key={key} style={{ display: "inline-block" }}>
                  {coverage}
                  <span style={{ color: color }}><i className="now-ui-icons tech_mobile" /></span>
                </div>
              );
            }
          }
        );
        mobiles = mobiles.filter(function (el) {
          return el != null;
        });
      }
    }
    if (mobiles) {
      result.push(mobiles);
    }
    return (
      <Row className="text-center">
        <Col>
          <div id="user-services-wrapper">
            {this.showBalance(this.state.customer)}
            {result}
            <span className="text-white" id="user-services-price">{this.calculateMonthlyPrice()}<span id="user-services-price-monthly">/mes</span></span>
          </div>
        </Col>
      </Row>
    );
  }
  calculateMonthlyPrice() {
    let result = 0.0;
    if (this.state.customer.internet_activo === "1") {
      if(this.state.customer.internet_precio) {
        try {
          result += parseFloat(this.state.customer.internet_precio.replace("€", "").replace(" ", "").replace(",", "."));
        } catch (error) {
          console.log("Error al sumar el precio de la tarifa de Internet", error);
        }
      }
    }
    if (this.props.mainState.customersMobilesLoaded) {
      let mobilesQuantity = 0;
      // Comprobamos que haya móviles del cliente
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      // Si los hay, comenzamos
      if (mobilesQuantity > 0) {
        this.props.mainState.customersMobiles[this.state.customer.id].map(
          (mobile, key) => {
            let coverageStyle = {};
            // console.log("mobile", mobile);
            if (mobile.estado && mobile.estado.toLowerCase() !== "terminado") {
              result += parseFloat(mobile.precio.replace("€", "").replace(" ", "").replace(",", "."));
            }
          }
        );
      }
    }
    if (this.state.customer.id in this.props.mainState.customerExtraExpenses) {
      let customerExtraExpenses = this.props.mainState.customerExtraExpenses[this.state.customer.id];
      if (!customerExtraExpenses) customerExtraExpenses = [];
      if (customerExtraExpenses.length > 0) {
        let disabledExpensesCount = 0;
        let disabledExpensesCountShowed = false;
        let activeExpenses = customerExtraExpenses.map(
          (expense, key) => {
            if (expense.vencido === "0") {
              result += parseFloat(expense.precio.replace("€", "").replace(" ", "").replace(",", "."));
            }
          }
        );
      }
    }

    let tvSubscriptions = undefined;
    let customer = this.state.customer;
    let subscriptionsQuantity = 0;
    
    if (customer.tv && customer.tv.subscriptions) {
      subscriptionsQuantity = customer.tv.subscriptions.length;
    }

    if (subscriptionsQuantity > 0) {
      customer.tv.subscriptions.map(
        (subscription, key) => {
          if (parseInt(subscription.field_estado_subscripcion_tv.und[0].tid) === 219) {
            result += parseFloat(this.calculateAndFormatTVPrice(subscription.package).replace("€", "").replace(" ", "").replace(",", "."));
          }
        }
      );
    } else {
      tvSubscriptions = (
        <Table responsive>
          <tbody>
            <tr>
              <td className="text-center">No tiene ninguna subscripción de TV...</td>
            </tr>
          </tbody>
        </Table>
      );
    }
    result = formatterCurrency.format(result);
    // console.log("calculate price", formatterCurrency.format(result));
    return result;
  }
  generateServicesContract() {
    let products = [];
    if (this.state.customer.internet_activo === "1") {
      if (this.state.customer.internet_precio) {
        if (this.state.customer.internet_tarifa) {
          try {
            // result += parseFloat(this.state.customer.internet_precio.replace("€", "").replace(" ", "").replace(",", "."));
            // Fibra -> subtype = 22
            // Wifi -> subtype = 21
            let internet_type = 22;
            if (this.state.customer.internet_tarifa.includes("▼30M") || 
                this.state.customer.internet_tarifa.includes("▼10M") || 
                this.state.customer.internet_tarifa.includes("▼15M") || 
                this.state.customer.internet_tarifa.includes("▼20M") || 
                this.state.customer.internet_tarifa.includes("▼50M") || 
                this.state.customer.internet_tarifa.includes("▼70M")) internet_type = 21;
            products.push({
              label: this.state.customer.internet_tarifa.replace(" (Internet)", ""),
              id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
              type: 2, // Internet
              subtype: internet_type, // WIFI (21) o FIBRA (22)
              price: this.state.customer.internet_precio,
              extraFields:[]
            });
          } catch (error) {
            console.log("Error al sumar el precio de la tarifa de Internet", error);
          }
        }
      }
    }
    if (this.props.mainState.customersMobilesLoaded) {
      let mobilesQuantity = 0;
      // Comprobamos que haya móviles del cliente
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      // Si los hay, comenzamos
      if (mobilesQuantity > 0) {
        this.props.mainState.customersMobiles[this.state.customer.id].map(
          (mobile, key) => {
            let coverageStyle = {};
            // console.log("mobile", mobile);
            if (mobile.estado && mobile.estado.toLowerCase() !== "terminado") {
              // result += parseFloat(mobile.precio.replace("€", "").replace(" ", "").replace(",", "."));              
              // console.log("adding mobile:", mobile);
              let coverage = mobile.cobertura;
              products.push({
                label: mobile.plan.replace("(Nueva) ", "").replace(" (Móvil)", ""),
                id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
                type: 3, // Móvil
                price: mobile.precio,
                extraFields: [
                  {
                    id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
                    label: "Móvil",
                    type: "number",
                    placeholder: "612345678",
                    value: mobile.numero
                  }
                ],
                provider: {...coverage}
              });
            }
          }
        );
      }
    }
    if (this.state.customer.id in this.props.mainState.customerExtraExpenses) {
      let customerExtraExpenses = this.props.mainState.customerExtraExpenses[this.state.customer.id];
      // console.log("customer extra expenses:", customerExtraExpenses);
      if (!customerExtraExpenses) customerExtraExpenses = [];
      if (customerExtraExpenses.length > 0) {
        let disabledExpensesCount = 0;
        let disabledExpensesCountShowed = false;
        let activeExpenses = customerExtraExpenses.map(
          (expense, key) => {
            if (expense.vencido === "0") {
              // console.log("adding extra expense:", expense);
              // result += parseFloat(expense.precio.replace("€", "").replace(" ", "").replace(",", "."));
              let price_components = expense.precio.split(" ");
              let expense_price = "";
              if (price_components.length > 2) {
                expense_price = price_components[0] + price_components[1];
                expense_price = expense_price.replace("€", "").replace(" ", "");
              } else {
                expense_price = price_components[0];
                expense_price = expense_price.replace("€", "").replace(" ", "");
              }
              products.push({
                label: expense.concepto,
                id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
                type: 4, // Otros
                price: expense_price/*expense.precio.replace(/\s+/g, '').slice(0, -2) + ' €'*/,
                onePayment: expense.tipo_gasto === "Único",
                extraFields:[]
              });
            }
          }
        );
      }
    }

    let tvSubscriptions = undefined;
    let customer = this.state.customer;
    let subscriptionsQuantity = 0;
    
    if (customer.tv && customer.tv.subscriptions) {
      subscriptionsQuantity = customer.tv.subscriptions.length;
    }

    if (subscriptionsQuantity > 0) {
      customer.tv.subscriptions.map(
        (subscription, key) => {
          if (parseInt(subscription.field_estado_subscripcion_tv.und[0].tid) === 219) {
            // result += parseFloat(this.calculateAndFormatTVPrice(subscription.package).replace("€", "").replace(" ", "").replace(",", "."));
            products.push({
              label: subscription.package.title,
              id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
              type: 4, // Otros
              price: this.calculateAndFormatTVPrice(subscription.package),
              extraFields:[]
            });
          }
        }
      );
    } else {
    }
    return products;
    // console.log("Productos generados:", products);
    // result = formatterCurrency.format(result);
    // console.log("calculate price", formatterCurrency.format(result));
    // return result;
  }
  filterNotes(note) {
    if (!this.state.noteFilter) return true;
    let note_text = note.texto;
    let noteFilter = this.state.noteFilter.toLowerCase();
    // console.log("note_text", note_text);
    try {
      let note_json = JSON.parse(note_text);
      // console.log("note_json", note_json);
      note_text = note_json.text;
    } catch (error) {
      // console.log("error", error);
      note_text = note.texto;
    }

    let subFilters = noteFilter.toLowerCase().split(" ");
    let result = true;
    if (!subFilters || subFilters.length === 0) {
      return result;
    }
    // console.log("subFilters",subFilters);
    subFilters.map(filter => {
      let localResult = false;
      // Si cualquiera de las condiciones se cumple, devuelve TRUE
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.fecha.toLowerCase().includes(filter)) localResult = true;
      if (note.tipo.toLowerCase().includes(filter)) localResult = true;
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.autor.toLowerCase().includes(filter)) localResult = true;
      if (note.titulo.toLowerCase().includes(filter)) localResult = true;

      result = result && localResult;
    });
    return result;
  }
  editCustomer() {
    let customerFields = {
      // Campos editar usuario
      client_id: this.state.customer.id,
      direccion: this.state.direccion,
      localidad: this.state.localidad,
      codigo_postal: this.state.codigo_postal,
      nombre: this.state.nombre,
      primer_apellido: this.state.primer_apellido,
      segundo_apellido: this.state.segundo_apellido,
      nif: this.state.nif,
      movil: this.state.movil,
      email: this.state.email,
      tipo_cliente: this.state.customerType.value,
      tipo_documento_identidad: this.state.documentType.value,
      nif_manager: this.state.nif_manager,
      nombre_manager: this.state.nombre_manager,
      primer_apellido_manager: this.state.primer_apellido_manager,
      segundo_apellido_manager: this.state.segundo_apellido_manager
    };
    this.props.editCustomer(customerFields);
  }
  setGeneratedProductsForNewContract() {
    let products = this.generateServicesContract();
    this.props.userData.setProductsForContract(products);
    this.newContract();
  }
  newContract() {
    let customer_id = this.props.match.params.customerID;
    let customer = null;
    if (customer_id in this.props.mainState.customers) {
      customer = this.props.mainState.customers[customer_id][0];
    }
    this.props.userData.setExistingCustomerForContract(customer_id);
    this.setState({ redirectTo: "/contratos/nuevo" });
    // this.redirectTo("/contratos/nuevo");
  }
  newTicket() {
    this.props.userData.setExistingCustomerForTicket(this.state.customer.id, this.state.customer);
    this.redirectTo("/tickets/nuevo");
  }
  newHomeVisit() {
    this.props.userData.setExistingCustomerForHomeVisit(this.state.customer.id, this.state.customer);
    this.redirectTo("/citas/nueva");
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  newCommunicationToCustomer(communication) {
    this.setState({
      writingCommunication: true,
      communicationType: communication
    });
  }
  discardUserChanges() {
    this.setState({
      // Campos editar usuario
      direccion: null,
      localidad: null,
      codigo_postal: null,
      nombre: null,
      primer_apellido: null,
      segundo_apellido: null,
      nif: null,
      movil: null,
      email: null
    });
  }
  areUserChangesToSave(currentCustomer) {
    let result = false;
    
    // nif_manager: null,
    // nombre_manager: null,
    // primer_apellido_manager: null,
    // segundo_apellido_manager: null,

    if (this.state.direccion !== null && this.state.direccion !== currentCustomer.domicilio) result = true;
    if (this.state.localidad !== null && this.state.localidad !== currentCustomer.localidad) result = true;
    if (this.state.codigo_postal !== null && this.state.codigo_postal !== currentCustomer.codigo_postal) result = true;
    if (this.state.nombre !== null && this.state.nombre !== currentCustomer.nombre_completo) result = true;
    if (this.state.primer_apellido !== null && this.state.primer_apellido !== currentCustomer.primer_apellido) result = true;
    if (this.state.segundo_apellido !== null && this.state.segundo_apellido !== currentCustomer.segundo_apellido) result = true;
    if (this.state.nif !== null && this.state.nif !== currentCustomer.nif) result = true;
    if (this.state.movil !== null && this.state.movil !== currentCustomer.phone) result = true;
    if (this.state.email !== null && this.state.email !== currentCustomer.email) result = true;
    if (this.state.customerType !== null && parseInt(this.state.customerType.value) !== parseInt(currentCustomer.tipo_cliente.tid || 0)) result = true;
    if (this.state.documentType !== null && parseInt(this.state.documentType.value) !== parseInt(currentCustomer.tipo_documento.tid || 0)) result = true;
    
    // Datos gerente empresa
    if (this.state.nif_manager !== null && this.state.nif_manager !== currentCustomer.nif_manager) result = true;
    if (this.state.nombre_manager !== null && this.state.nombre_manager !== currentCustomer.nombre_manager) result = true;
    if (this.state.primer_apellido_manager !== null && this.state.primer_apellido_manager !== currentCustomer.primer_apellido_manager) result = true;
    if (this.state.segundo_apellido_manager !== null && this.state.segundo_apellido_manager !== currentCustomer.segundo_apellido_manager) result = true;

    return result;
  }
  componentWillUnmount() {
    if (this.checkSecretSpeed) clearInterval(this.checkSecretSpeed);
    if (this.intervalGetNotes) clearInterval(this.intervalGetNotes);
  }
  componentDidMount() {
    this.intervalGetNotes = setInterval(() => this.props.getCustomerNotes(this.props.match.params.customerID), 60000); // Busca notas cada 1 minuto
    this.props.getSIMDeliveryTypes();
    if (this.state.customer) {
      if (this.state.customer.cuenta_bancaria !== "") {
        let newIBAN = this.formatIBAN(this.state.customer.cuenta_bancaria);
        let oldIBAN = this.formatIBAN(this.state.iban);
        if (newIBAN !== oldIBAN) {
          this.setState({ iban: newIBAN });
          this.validateField("iban", newIBAN);
        }
      }
      if (!this.state.extraExpensesLoaded) {
        this.props.getCustomerExtraExpenses(this.state.customer.id);
        this.setState({
          extraExpensesLoaded: true
        });
      }
      if (!this.state.billsSearched) {
        this.props.searchBillsByCustomerID(this.props.match.params.customerID, null, true);
        // this.props.searchBillsByCustomerID(this.props.match.params.customerID);
        this.setState({
          billsSearched: true
        });
      }
      if (this.state.customer.tipo_cliente && this.state.customer.tipo_cliente.tid) {
        customerType.map(currentType => {
          if (parseInt(currentType.value) === parseInt(this.state.customer.tipo_cliente.tid)) {
            this.setState({ customerType: currentType});
          }
        })
      }
      if (this.state.customer.tipo_documento && this.state.customer.tipo_documento.tid) {
        documentType.map(currentType => {
          if (parseInt(currentType.value) === parseInt(this.state.customer.tipo_documento.tid)) {
            this.setState({ documentType: currentType});
          }
        })
      }
    } else {
      if (this.props.match.params.customerID in this.props.mainState.customers) {
        this.setState({
          customer: this.props.mainState.customers[this.props.match.params.customerID][0]
        });
      }
    }
    this.props.searchBulkCustomer([this.props.match.params.customerID]);
    this.props.userData.get_communication_templates();
    this.props.userData.get_customer_communications(this.props.match.params.customerID);
    this.props.searchCustomerContracts(this.props.match.params.customerID);
    this.props.list_support_tickets(this.props.match.params.customerID);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log("######## PROPS EN CUSTOMER PROFILE #######");
    // console.log(this.props);
    let now = moment.now();
    if (now > (lastUpdateCustomer + 5000)) {
      lastUpdateCustomer = now;
      if (this.props.match.params.customerID in this.props.mainState.customers) {
        this.setState({ customer: this.props.mainState.customers[this.props.match.params.customerID][0] });
      }
    }
    // if (!(this.props.match.params.customerID in this.props.mainState.customerNotes)) {
    //   this.props.getCustomerNotes(this.props.match.params.customerID);
    // }
    if (this.state.customer) {
      // if (this.state.customer.cuenta_bancaria !== "") {
      //   let newIBAN = this.formatIBAN(this.state.customer.cuenta_bancaria);
      //   let oldIBAN = this.formatIBAN(this.state.iban);
      //   if (newIBAN !== oldIBAN) {
      //     this.setState({ iban: newIBAN });
      //     this.validateField("iban", newIBAN);
      //   }
      // }
      if (!this.state.extraExpensesLoaded) {
        this.props.getCustomerExtraExpenses(this.state.customer.id);
        this.setState({
          extraExpensesLoaded: true
        });
      }
      if (!this.state.billsSearched) {
        this.props.searchBillsByCustomerID(this.props.match.params.customerID, null, true);
        this.setState({
          billsSearched: true
        });
      }
    } else {
      if (this.props.match.params.customerID in this.props.mainState.customers) {
        this.setState({
          customer: this.props.mainState.customers[this.props.match.params.customerID][0]
        });
      }
    }
    if (prevProps.mainState.refreshingSession && !this.props.mainState.refreshingSession && !this.state.customer) {
      if (!(this.props.match.params.customerID in this.props.mainState.customers)) {
        console.log("Cliente no cargado... Solicitando información al servidor de nuevo tras refrescar la sesión.");
        this.props.searchBulkCustomer([this.props.match.params.customerID]);
        this.props.getCustomerNotes(this.props.match.params.customerID);
      }
    }
    if (this.state.customer && !prevState.customer) {      
      if (this.state.customer.tipo_cliente && this.state.customer.tipo_cliente.tid) {
        customerType.map(currentType => {
          if (parseInt(currentType.value) === parseInt(this.state.customer.tipo_cliente.tid)) {
            this.setState({ customerType: currentType});
          }
        })
      }
      if (this.state.customer.tipo_documento && this.state.customer.tipo_documento.tid) {
        documentType.map(currentType => {
          if (parseInt(currentType.value) === parseInt(this.state.customer.tipo_documento.tid)) {
            this.setState({ documentType: currentType});
          }
        })
      }
      if (this.state.customer.cuenta_bancaria !== "") {
        let newIBAN = this.formatIBAN(this.state.customer.cuenta_bancaria);
        let oldIBAN = this.formatIBAN(this.state.iban);
        if (newIBAN !== oldIBAN) {
          this.setState({ iban: newIBAN });
          // this.validateField("iban", newIBAN);
        }
      }
    }
    if (this.state.currentPill === PILL_CONTRATOS && !this.state.alreadySearchedContracts) {
      this.props.searchCustomerContracts(this.state.customer.id);
      this.setState({ alreadySearchedContracts: true });
    }
    if ((this.props.match.params.customerID in this.props.mainState.last_customer_update) && this.props.mainState.last_customer_update[this.props.match.params.customerID] > this.state.last_customer_update) {
      let currentCustomer = this.props.mainState.customers[
        this.props.match.params.customerID
      ][0];
      if (currentCustomer) {
        this.setState({
          customer: currentCustomer,
          last_customer_update: Date.now()
        });
      }
    }
  }
  checkRequestCustomerStatus(request) {
    if (request.ya_es_cliente === "si") {
      return true;
    } else {
      return false;
    }
  }
  createActionButtons() {
    if (isExterno) return null;

    if (this.props.mainState.user.field_tipo_distribuidor.und &&
        this.props.mainState.user.field_tipo_distribuidor.und[0].tid === 180)
      return null;
    let actionButtons = null;
    //console.log("######################## TIPO DE DISTRIBUIDOR ###########################");

    let createProcedureButton = null;
    //if(this.props.mainState.user.field_tipo_distribuidor.und[0].tid != 180) {
    createProcedureButton = (
      <Button
        round
        key={"createProcedureButton"}
        color="primary"
        onClick={() => {
          this.showPopUp(TRAMITE);
        }}
        leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingMobileProcedure? "arrows-1_refresh-69 spin" : "ui-1_simple-add")}
      >
        Crear trámite
      </Button>
    );
    //}

    let createSendSIMButton = null;
    //if(this.props.mainState.user.field_tipo_distribuidor.und[0].tid != 180) {
    createSendSIMButton =
      <Button
        round
        key={"createSendSIMButton"}
        color="info"
        onClick={() => {this.showPopUp(ENVIO)}}
        leftLabel="now-ui-icons ui-1_send">
          Enviar SIM
      </Button>;
    //}

    actionButtons = [createProcedureButton, "  ", createSendSIMButton];

    return actionButtons;
  }
  createRequestStatus(request) {
    let button = null;
    if (request.ya_es_cliente === "si") {
      button = 
        <Button
          color="warning"
          size="sm"
          icon
          // onClick={() => this.openRequestDocuments(request)}
        >
          {/* <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </div> */}
        </Button>;
    } else {
      button = 
        <Button
          color="danger"
          size="sm"
          icon
          // onClick={() => this.openRequestDocuments(request)}
        >
          {/* <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </div> */}
        </Button>;
    }
    return button;
  }
  showProcedurePopUpFromRequest(request) {
    this.showPopUp(TRAMITE);
    let _previousContract = { value: "196", label: "Contrato" };
    try {
      if (request.icc_sim_previa != null && request.icc_sim_previa.replace(/\s/g, '').length > 0) {
        _previousContract = { value: "195", label: "Prepago" };
      } else {
        _previousContract = { value: "196", label: "Contrato" };
      }
    } catch (error) {
      _previousContract = { value: "196", label: "Contrato" };
    }

    let _procedureType = null;
    if (request.tipo_tramite_solicitud.includes("portabilidad")) {
      _procedureType = { value: "171", label: "Portabilidad" };
    } else {
      _procedureType = { value: "172", label: "Alta" };
    }

    let _selectedPlan = null;
    this.props.mainState.mobilePlans.raw.map((item, key) => {
      if (item.referencia_solicitud === request.tarifa_movil) {
        _selectedPlan = {
          value: item.id, 
          label: item.titulo.replace("(Nueva) ", "").replace(" (Móvil)", "") + " (" + item.precio + ")"
        };
      }
    });

    this.setState({
      previousContract: _previousContract,
      previousICC: request.icc_sim_previa,
      procedureType: _procedureType,
      phoneNumber: request.numero_solicitud,
      selectedPlan: _selectedPlan
    });
  }
  showSIMDeliveryPopUpFromRequest(request) {
    this.showPopUp(ENVIO);

    this.setState({
      ICC: "",
      procedureId: request.id,
      phoneNumber: request.numero_solicitud,
      SIMCoverage: request.tarifa_movil
    });
  }
  createLaunchRequest(request) {
    let button = null;
    if (this.checkRequestCustomerStatus(request)){
      button =
        <Button
          round
          color="primary"
          size="sm"
          onClick={() => this.showProcedurePopUpFromRequest(request)}
        >
          <div>
            <i className="now-ui-icons objects_spaceship" /> Tramitar
          </div>
        </Button>;
    }
    return button;
  }
  confirmSIMDelivery(SIMDelivery) {
    this.props.confirmSIMDelivery(SIMDelivery);
  }
  createConfirmDeliveryButton(SIMDelivery) {
    // console.log("SIMDelivery", SIMDelivery);
    let button = null;
    let isDisabled = false;
    let isConfirming = false;
    if (this.props.mainState.isConfirmingDelivery) isConfirming = this.props.mainState.isConfirmingDelivery[SIMDelivery.id];
    if (isConfirming || parseInt(SIMDelivery.estado_envio.id) === 329) isDisabled = true;
    button =
      <Button
        round
        color="primary"
        size="sm"
        disabled={isDisabled}
        onClick={() => this.confirmSIMDelivery(SIMDelivery)}
        leftLabel={"now-ui-icons " + (isConfirming ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_check")}
      >
        {parseInt(SIMDelivery.estado_envio.id) === 329 ? "Confirmado" : isConfirming ? "Confirmando" : "Confirmar"}
      </Button>;
    if (SIMDelivery.is_old) {
      button =
        <Button
          round
          color="default"
          size="sm"
          disabled
          // onClick={() => this.confirmSIMDelivery(SIMDelivery)}
          leftLabel={"now-ui-icons travel_info"}
        >
          {"Es viejo"}
        </Button>;
    }
    return button;
  }
  createDeliverRequestSIM(request) {
    let button = null;

    button =
      <Button
        round
        color="info"
        size="sm"
        onClick={() => this.showSIMDeliveryPopUpFromRequest(request)}
      >
        <div>
          <i className="now-ui-icons ui-1_send" /> Enviar SIM
        </div>
      </Button>;

    return button;
  }
  createRightColumn() {
    let rightColumn = [];
    if (!(this.props.mainState.user.field_tipo_distribuidor.und && 
          this.props.mainState.user.field_tipo_distribuidor.und[0].tid === 180)) {
      rightColumn.push(
        <Card size={12} key="buttonsCard">
          <CardBody>{this.createActionButtons()}</CardBody>
        </Card>
      );
    }

    let notesCardHeader = (
        <CardHeader className="txt-black">
          <h5>
            <i className="now-ui-icons design-2_ruler-pencil" /> Notas{"  "}
            <Button
              icon
              round
              key={"createNoteButton"}
              color="info"
              onClick={() => {
                this.showPopUp(NOTA);
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
            />
          </h5>
        </CardHeader>
    );

    let notesCard = null;
    let notesCardBody = null;
    let currentCustomerID = parseInt(this.state.customer.id);
    if (currentCustomerID in this.props.mainState.customerNotes) {
      let customerNotes = this.props.mainState.customerNotes[currentCustomerID];
      if (!customerNotes) customerNotes = [];
      if (customerNotes.length > 0) {
        customerNotes = customerNotes.map((note, key) => {
          if (this.filterNotes(note)) {
            let badgeStyle = 
            {
              color: "default",
              icon: "travel_info"
            };
            if (note.tipo === "Incidencia") {
              badgeStyle.color = "danger";
              badgeStyle.icon = "ui-2_settings-90";
            }
            if (note.tipo === "Solución") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "ui-2_like";
            }
            if (note.tipo === "Log") {
              badgeStyle.color = "warning";
              badgeStyle.icon = "ui-1_bell-53";
            }
            if (note.tipo === "Pago") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "business_money-coins";
            }
  
            let note_text = note.texto;
            // console.log("note_text", note_text);
            try {
              let note_json = JSON.parse(note_text);
              // console.log("note_json", note_json);
              note_text = note_json.text;
            } catch (error) {
              // console.log("error", error);
              note_text = note.texto;
            }
  
            note = {
              inverted: true,
              badgeColor: badgeStyle.color,
              badgeIcon: "now-ui-icons " + badgeStyle.icon,
              title: note.autor + (note.titulo !== "" ? ": " + note.titulo : ""),
              titleColor: "danger",
              body: <div dangerouslySetInnerHTML={{ __html: note_text }} />,
              footerTitle: <div dangerouslySetInnerHTML={{ __html: note.fecha }} />
            };
            return note;
          }
        });
        customerNotes = customerNotes.filter(function (el) {
          return el != null;
        });
        notesCardBody =
          <CardBody>
            <Row>
              <Col xs={12}>
                <FormGroup>
                    <Input
                      type="text"
                      className="note-filter"
                      placeholder="Filtrar notas..."
                      value={this.state.noteFilter || ""}
                      // onChange={e => this.handleChange("searchQuery", e)}
                      onChange={e => this.setState({ noteFilter: e.target.value })}
                      // onKeyDown={this.handleKeyDown}
                      // disabled={this.props.mainState.isSearchingBuildings}
                      // onKeyDown={e => {
                      //   //console.log(e.keyCode);
                      //   if (e.keyCode == 13) {
                      //     console.log("ola k ase?");
                      //     //Enter is key code 13
                      //     // this.searchCustomer();
                      //     // put the login here
                      //   }
                      // }}
                      // style={{ marginRight: "10px" }}
                    />
                </FormGroup>
              </Col>
            </Row>
            {this.state.showNotes && <Timeline stories={customerNotes} simple />}
            <Row>
              <Col xs={12}>
                <Card 
                  onClick={() => this.setState({ showNotes: !this.state.showNotes }) }
                  color="default" 
                  style={{ overflow: "hidden" }}
                  className="text-center building-card">
                  {customerNotes.length > 0 && <CardHeader className="txt-black">
                    <i className={this.state.showNotes ? "now-ui-icons ui-1_simple-delete" : "now-ui-icons ui-1_simple-add"} /> {
                    this.state.showNotes ? "Ocultar todas" : "Mostrar todas"
                  }
                  </CardHeader>}
                  <CardBody className="text-center txt-white h3 h-nomargin">
                    {customerNotes.length + (customerNotes.length === 1 ? " nota" : " notas")}
                  </CardBody>
                  <CardFooter className="text-right txt-black">
                    <Row>
                      <Col xs={6} className="text-left txt-black">
                        {/* Pulsa para mostrar todos */}
                      </Col>
                      <Col xs={6} className="text-right txt-black">
                        {/* {mobile.precio} */}
                      </Col>
                    </Row>
                  </CardFooter>
                  {/* {coverage} */}
                </Card>
              </Col>
            </Row>
          </CardBody>;
      } else {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay notas
            </div>
          </CardBody>;
      }
    } else if(currentCustomerID in this.props.mainState.isSearchingCustomerNotes) {
      if (this.props.mainState.isSearchingCustomerNotes[this.state.customer.id]) {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
            </div>
          </CardBody>;
      }
    }
    notesCard = (
      <Card key="notesCard" className="card-plain card-timeline">
        {notesCardHeader}
        {notesCardBody}
      </Card>
    );
    rightColumn.push(notesCard);

    let webRequestsCardHeader = (
      <CardHeader className="txt-black">
        <h5>
          <i className="now-ui-icons arrows-1_cloud-upload-94" /> Solicitudes web{"  "}
          {/* <Button
            icon
            round
            key={"createNoteButton"}
            color="info"
            onClick={() => {
              this.showPopUp(NOTA);
            }}
            leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
          /> */}
        </h5>
      </CardHeader>
    );

    let webMobileRequestsToDisplay = this.props.mainState.webMobileRequestsByCustomerID;
    // console.log("##### WEB MOBILE REQUESTS IN PROFILE");
    // console.log(webMobileRequestsToDisplay);

    if (
      this.props.mainState.webMobileRequestsLoaded &&
      Object.keys(this.props.mainState.webMobileRequests).length > 0
    ) {

      if (this.state.customer.id in webMobileRequestsToDisplay) {
        webMobileRequestsToDisplay = webMobileRequestsToDisplay[this.state.customer.id];
      } else {
        webMobileRequestsToDisplay = [];
      }
    }
    let webRequestsCard = null;
    let webRequestsCardBody = null;

    webRequestsCardBody =
      <CardBody>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              {theadwebmobilerequestsmini.map((prop, key) => {
                if (key === theadwebmobilerequestsmini.length - 1)
                  return (
                    <th key={key} className="text-center">
                      {prop}
                    </th>
                  );
                return (
                  <th key={key} className="text-center">
                    {prop}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {webMobileRequestsToDisplay
              .map((webMobileRequest, key) => {
                // let servicesButtons = this.createServicesButtons(
                //   customer
                // );
                // let activeCustomerButton = this.createActiveCustomerButton(
                //   webMobileRequest
                // );
                // let formattedNumber = "";
                // if (webMobileRequest.phone) {
                //   formattedNumber =
                //     webMobileRequest.phone.substring(0, 3) +
                //     " " +
                //     webMobileRequest.phone.substring(3, 6) +
                //     " " +
                //     webMobileRequest.phone.substring(6, 9);
                // }
                // let URL_front_DNI = "https://cdn.nadunet.es/cdn/" + webMobileRequest.dni_frontal_solicitud.uri.replace("public://", "");
                // let URL_back_DNI = "https://cdn-2.nadunet.es/cdn/" + webMobileRequest.dni_trasero_solicitud.uri.replace("public://", "");
                let tipo_tramite_solicitud = "";
                if(webMobileRequest.tipo_tramite_solicitud) {
                  try {
                    tipo_tramite_solicitud = webMobileRequest.tipo_tramite_solicitud.charAt(0).toUpperCase() + webMobileRequest.tipo_tramite_solicitud.slice(1);  
                  } catch (error) {
                    tipo_tramite_solicitud = "error";
                  }
                }
                return (
                  <tr key={webMobileRequest.id}>
                    {/* <td className="text-center">
                      {activeCustomerButton}
                    </td> */}
                    <td className="text-center">{this.createRequestStatus(webMobileRequest)}</td>
                    <td className="text-center">{webMobileRequest.creacion}</td>
                    <td className="text-center">{this.createCoverageNetworkButton(webMobileRequest.tarifa_movil)}</td>         
                    <td className="text-center">{webMobileRequest.numero_contacto_solicitud}</td>               
                    <td className="text-center">{tipo_tramite_solicitud}</td>
                    <td className="text-center">{webMobileRequest.numero_solicitud}</td>
                    {/* <td className="text-center">{webMobileRequest.tipo_cliente_solicitud.charAt(0).toUpperCase() + webMobileRequest.tipo_cliente_solicitud.slice(1)}</td> */}
                    {/* <td className="text-center">{webMobileRequest.dni_solicitud}</td> */}
                    {/* <td className="text-center">*/}
                      {/* <Link to={"/clientes/fichas/".concat(webMobileRequest.id)}> */}
                        {/* {webMobileRequest.nombre_completo_solicitud}{" "} */}
                        {/* {webMobileRequest.primer_apellido_solicitud}{" "} */}
                        {/* {webMobileRequest.segundo_apellido_solicitud} */}
                      {/* </Link> */}
                    {/* </td>  */}
                    {/*<td className="text-left">{customer.email}</td>*/}
                    {/* <td className="text-center">{webMobileRequest.numero_contacto_solicitud}</td> */}
                    <td className="text-center">{webMobileRequest.observaciones_solicitud}</td>
                    <td className="text-left">
                      {this.createLaunchRequest(webMobileRequest)}
                    </td>
                    <td className="text-left">
                      {this.createDeliverRequestSIM(webMobileRequest)}
                    </td>
                    {/* <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={URL_front_DNI} /></td>
                    <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={URL_back_DNI} /></td>
                    <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={webMobileRequest.firma_solicitud_base64} /></td> */}
                    {/* order.data.map((prop, key) => {
                      if (key === thead.length - 1)
                        return (
                          <td key={key} className="text-right">
                            {prop}
                          </td>
                        );
                      return <td key={key}>{prop}</td>;
                    }) */}
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </CardBody>;

    webRequestsCard = (
      <Card key="webRequestsCard">
        {webRequestsCardHeader}
        {webRequestsCardBody}
      </Card>
    );
    if (webMobileRequestsToDisplay.length > 0) rightColumn.push(webRequestsCard);

    if (rightColumn.length > 0) {
      return (
        <Col md={4} xs={12}>
          {rightColumn}
        </Col>
      );
    } else {
      return null;
    }
  }
  handleDoubleClick(type, input) {
    let mobilePlan = null;
    switch (type) {
      case GASTO_EXTRA: 
        if (this.props.userData.isBillingDepartment()) {
          this.showPopUp(GASTO_EXTRA);
          this.setState({
            extraExpenseType: 
              extraExpenseType.find((element) => {
                return element.label === input.tipo_gasto;
              }),
            extraExpenseConcept: input.concepto,
            extraExpenseFees: input.cuotas,
            extraExpensePrice: input.precio.replace(" €", "").replace(",", ".").replace(" ", "").replace(" ", ""),
            extraExpenseID: input.id
          });
        }
        break;
      case AGREGAR_MOVIL: 
        console.log("##### EDITAR MOVIL ######");
        // console.log("##### this.props.mainState.mobilePlans.forOptions ######");
        // console.log(this.props.mainState.mobilePlans.forOptions);
        console.log("##### input ######");
        console.log(input);
        this.showPopUp(AGREGAR_MOVIL);
        mobilePlan = this.props.mainState.mobilePlans.forOptions.find((element) => {
            return element.value === input.plan_id;
          });
        if (!mobilePlan) {
          mobilePlan = { label: input.plan, value: input.plan_id };
        }
        this.setState({
          mobilePlan: mobilePlan,
          mobileNumber: input.numero,
          editingMobileID: input.mobile_id,
          mobileStatus:
            mobileStatus.find((element) => {
              return element.value === input.estado_id;
            }),
        });
        break;
      default:;
    }
  }
  formatExtraExpense(expense) {
    let expenseCard = null;
    let footerText = expense.tipo_gasto;
    if (expense.tipo_gasto === "Fraccionado") {
      footerText = footerText + " (" + expense.cuotas_pagadas + "/" + expense.cuotas + ")";
    }
    switch (this.state.extraExpensesView) {
      case SQUARED_VIEW:
        expenseCard = (
          <Card 
            onContextMenu={e => {
              e.preventDefault();
              this.handleDoubleClick(GASTO_EXTRA, expense)
            }}
            onClick={() => {
              this.setState({historial_pagos: expense.historial_pagos});
              this.showPopUp(HISTORIAL_PAGOS);
            }}
            color={expense.vencido === "0" ? "primary" : "default"} 
            className="text-center">
            <CardHeader className="txt-black">
              <i className="now-ui-icons business_money-coins" /> {expense.concepto}
            </CardHeader>
            <CardBody className="text-center txt-white h3 h-nomargin">
              {expense.precio}
            </CardBody>
            <CardFooter className="text-right txt-black">
              {footerText}
            </CardFooter>
          </Card>
        );
        return (
          <Col xs={12} sm={6} lg={3} key={expense.id}>
            {expenseCard}
          </Col>
        );
        break;
      case ROW_VIEW:
        expenseCard = (
          <tr key={expense.id}>
            <td>
              <Button 
                round 
                icon 
                color={expense.vencido === "0" ? "primary" : "default"} 
                
                onContextMenu={e => {
                  e.preventDefault();
                  this.handleDoubleClick(GASTO_EXTRA, expense)
                }}
                onClick={() => {
                  this.setState({historial_pagos: expense.historial_pagos});
                  this.showPopUp(HISTORIAL_PAGOS);
                }}/>
            </td>
            <td>
              <i className="now-ui-icons business_money-coins" /> {expense.concepto}
            </td>
            <td>
              {footerText}
            </td>
            <td>
              {expense.precio}
            </td>
          </tr>
        );
        return expenseCard;
        break;
    
      default:
        break;
    }
  }
  createExtraExpenses() {
    let extraExpensesCardHeader = (
        <CardHeader className="txt-black">
          <h5>
            <i className="now-ui-icons business_money-coins" /> Gastos extra{"  "}
            {this.props.userData.isBillingDepartment() && <Button
              icon
              round
              key={"createExtraExpenseButton"}
              color="info"
              onClick={() => {
                this.showPopUp(GASTO_EXTRA);
              }}
              // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              leftLabel={"now-ui-icons ui-1_simple-add"}
            />}
            <span> Vista </span>
            <Button
              icon
              round
              key={"extraExpenseRowView"}
              color={this.state.extraExpensesView === ROW_VIEW ? "primary" : "default"}
              onClick={() => {
                this.setState({ extraExpensesView: ROW_VIEW });
              }}
              // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              leftLabel={"now-ui-icons design_bullet-list-67"}
            />
            <Button
              icon
              round
              key={"extraExpenseSquaredView"}
              color={this.state.extraExpensesView === SQUARED_VIEW ? "primary" : "default"}
              onClick={() => {
                this.setState({ extraExpensesView: SQUARED_VIEW });
              }}
              // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              leftLabel={"now-ui-icons design_app"}
            />
          </h5>
        </CardHeader>
    );

    let extraExpenses = null;
    let extraExpensesCard = null;
    let extraExpensesCardBody = null;
    if (this.state.customer.id in this.props.mainState.customerExtraExpenses) {
      let customerExtraExpenses = this.props.mainState.customerExtraExpenses[this.state.customer.id];
      if (!customerExtraExpenses) customerExtraExpenses = [];
      if (customerExtraExpenses.length > 0) {
        let disabledExpensesCount = 0;
        let disabledExpensesCountShowed = false;
        let activeExpenses = customerExtraExpenses.map(
          (expense, key) => {
            if (expense.vencido !== "0") {
              disabledExpensesCount++;
              return null;
            }
            let formattedExpense = this.formatExtraExpense(expense);
            return formattedExpense;
          }
        );
        let disabledExpenses = customerExtraExpenses.map(
          (expense, key) => {
            if (expense.vencido === "0") return null;
            if (disabledExpensesCountShowed) return null;
            if (!this.state.showDisabledExpenses) return null;

            let footerText = expense.tipo_gasto;
            if (expense.tipo_gasto === "Fraccionado") {
              footerText = footerText + " (" + expense.cuotas_pagadas + "/" + expense.cuotas + ")";
            }
            // let expenseCard = (
            //   <Card 
            //     onContextMenu={e => {
            //       e.preventDefault();
            //       this.handleDoubleClick(GASTO_EXTRA, expense)
            //     }}
            //     onClick={() => {
            //       this.setState({historial_pagos: expense.historial_pagos});
            //       this.showPopUp(HISTORIAL_PAGOS);
            //     }}
            //     color={expense.vencido === "0" ? "primary" : "default"} 
            //     className="text-center">
            //     <CardHeader className="txt-black">
            //       <i className="now-ui-icons tech_mobile" /> {expense.concepto}
            //     </CardHeader>
            //     <CardBody className="text-center txt-white h3 h-nomargin">
            //       {expense.precio}
            //     </CardBody>
            //     <CardFooter className="text-right txt-black">
            //       {footerText}
            //     </CardFooter>
            //   </Card>
            // );
            let formattedExpense = this.formatExtraExpense(expense);
            return formattedExpense;
        });
        if (activeExpenses) activeExpenses = activeExpenses.filter(el => el !== null);
        if (disabledExpenses) disabledExpenses = disabledExpenses.filter(el => el !== null);
        if (this.state.extraExpensesView === ROW_VIEW && (activeExpenses.length > 0 || disabledExpenses.length > 0)) {
          // console.log("activeExpenses", activeExpenses);
          // console.log("disabledExpenses", disabledExpenses);
          activeExpenses = (
            <Col xs={12}>
              <table style={{ width: "100%" }}>
                <thead><tr><th></th><th>Concepto</th><th>Tipo</th><th>Importe</th></tr></thead>
                <tbody>{activeExpenses}{disabledExpenses}</tbody>
              </table>
            </Col>
          );
        } else {
          activeExpenses = [activeExpenses, disabledExpenses];
        }
        extraExpensesCardBody = (
          <Row>
            {activeExpenses}
            {disabledExpensesCount > 0 && 
              <Col xs={12} sm={6} lg={3}>
                <Link to="#">
                  <Card 
                    onClick={() => this.setState({ showDisabledExpenses: !this.state.showDisabledExpenses }) }
                    color="default" 
                    style={{ overflow: "hidden" }}
                    className="text-center">
                    <CardHeader className="txt-black">
                      <i className={this.state.showDisabledExpenses ? "now-ui-icons ui-1_simple-delete" : "now-ui-icons ui-1_simple-add"} /> {
                      this.state.showDisabledExpenses ? "Ocultar todos" : "Mostrar todos"
                    }
                    </CardHeader>
                    <CardBody className="text-center txt-white h3 h-nomargin">
                      {disabledExpensesCount + (disabledExpensesCount > 1 ? " caducados" : " caducado")}
                    </CardBody>
                    <CardFooter className="text-right txt-black">
                      <Row>
                        <Col xs={6} className="text-left txt-black">
                          {/* Pulsa para mostrar todos */}
                        </Col>
                        <Col xs={6} className="text-right txt-black">
                          {/* {mobile.precio} */}
                        </Col>
                      </Row>
                    </CardFooter>
                    {/* {coverage} */}
                  </Card>
                </Link>
              </Col>
            }
          </Row>
        );
      } else {
        /*mobiles = 
        <Row>
          <Col xs={12} sm={6} lg={3} >
              <Card
              color="default"
              className="text-center">
                <CardHeader 
                className="txt-black">
                  <i className="now-ui-icons tech_mobile" />
                </CardHeader>
                <CardBody 
                className="text-center h5 h-nomargin">
                No tiene ningún móvil
                </CardBody>
                <CardFooter
                className="text-right txt-black">
                </CardFooter>
              </Card>
          </Col>
        </Row>*/
        extraExpensesCardBody = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene ningún gasto extra...</td>
              </tr>
            </tbody>
          </Table>
        );
      }
    } else {
      extraExpensesCardBody = 
        <CardBody>
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        </CardBody>;
    }
    extraExpensesCard = (
      <Card key="extraExpensesCard">
        {extraExpensesCardHeader}
        {extraExpensesCardBody}
      </Card>
    );
    return extraExpensesCard;
  }
  defineMobileColor(mobile, hex) {
    let color = "default";
    let hexColor = "#CCC";
    switch (mobile.estado) {
      case "Activado": 
        color = "primary";
        hexColor = "#46B98A";
        break;
      case "Terminado":
        color = "default";
        hexColor = "#888888";
        break;
      case "Impago":
        color = "warning";
        hexColor = "#FFB236";
        break;
      case "Bloqueado por fraude":
        color = "danger";
        hexColor = "#ff5252";
        break;
      case "Sin estado":
        color = "danger";
        break;
      default:
        break;
    }

    return hex ? hexColor : color;
  }
  createMobiles() {
    let mobiles = undefined;

    if (!this.props.mainState.customersMobilesLoaded) {
      mobiles = (
        <Button
          color="default"
          size="lg"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      // console.log("######## TEST PERFIL MOVILES #######");
      // console.log(this.props.mainState);
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      if (mobilesQuantity > 0) {
        let disabledMobilesCount = 0;
        let disabledMobilesCountShowed = false;
        mobiles = (
          <Row>
            {this.props.mainState.customersMobiles[this.state.customer.id].map(
              (mobile, key) => {
                if (mobile.estado === "Terminado") {
                  disabledMobilesCount++;
                  return null;
                }
                let mobilePlan = "";
                if (mobile.plan) {
                  mobilePlan = mobile.plan
                    .replace("(Nueva) ", "")
                    .replace(" (Móvil)", "");
                }
                if (mobile.plan === "") mobile.plan = "Error tarifa";
                let formattedNumber = "";
                if (mobile.numero) {
                  formattedNumber =
                    mobile.numero.substring(0, 3) +
                    " " +
                    mobile.numero.substring(3, 6) +
                    " " +
                    mobile.numero.substring(6, 9);
                }
                if (mobile.numero === "") formattedNumber = "Error número";

                let coverageStyle = {};
                let coverage = null;
                if (mobile.cobertura && mobile.cobertura.cobertura && mobile.cobertura.cobertura.length > 0) {
                  // <div style={{ coverageStyle }}></div>
                  mobile.cobertura.cobertura.map((currentCoverage, key) => {
                    coverageStyle = {
                      position: "absolute",
                      top: "0",
                      left: (parseInt(key) * 5) + "px",
                      width: "5px",
                      height: "100%",
                      background: currentCoverage.color
                    }
                    if (!coverage) coverage = [];
                    coverage.push(<div key={key} style={coverageStyle}></div>);
                  });
                }
                let mobileCard = (
                  <Card 
                    onContextMenu={e => {
                      e.preventDefault();
                      this.handleDoubleClick(AGREGAR_MOVIL, mobile);
                    }}  
                    color={this.defineMobileColor(mobile)} 
                    style={{ overflow: "hidden" }}
                    className="text-center">
                    <CardHeader className="txt-black">
                      <i className="now-ui-icons tech_mobile" /> {mobilePlan}
                    </CardHeader>
                    <CardBody className="text-center txt-white h3 h-nomargin">
                      {formattedNumber}
                    </CardBody>
                    <CardFooter className="text-right txt-black">
                      <Row>
                        <Col xs={6} className="text-left txt-black">
                          {mobile.estado ? mobile.estado.replace("Bloqueado por ", "").replace("f","F") : "Sin estado"}
                        </Col>
                        <Col xs={6} className="text-right txt-black">
                          {mobile.precio}
                        </Col>
                      </Row>
                    </CardFooter>
                    {coverage}
                  </Card>
                );

                // if (
                //   this.props.mainState.user.field_tipo_distribuidor.und &&
                //   this.props.mainState.user.field_tipo_distribuidor.und[0]
                //     .tid !== 180
                // ) {
                  mobileCard = (
                    <Link
                      to={
                        "/clientes/fichas/".concat(this.state.customer.id) +
                        "/movil/" +
                        mobile.numero
                      }
                    >
                      {mobileCard}
                    </Link>
                  );
                // }
                return (
                  <Col xs={12} sm={6} lg={3} key={key}>
                    {mobileCard}
                  </Col>
                );
              }
            )}
            {this.props.mainState.customersMobiles[this.state.customer.id].map(
              (mobile, key) => {
                if (mobile.estado !== "Terminado") return null;
                if (!this.state.showDisabledMobiles) return null;

                let mobilePlan = "";
                if (mobile.plan) {
                  mobilePlan = mobile.plan
                    .replace("(Nueva) ", "")
                    .replace(" (Móvil)", "");
                }
                if (mobile.plan === "") mobile.plan = "Error tarifa";
                let formattedNumber = "";
                if (mobile.numero) {
                  formattedNumber =
                    mobile.numero.substring(0, 3) +
                    " " +
                    mobile.numero.substring(3, 6) +
                    " " +
                    mobile.numero.substring(6, 9);
                }
                if (mobile.numero === "") formattedNumber = "Error número";

                let coverageStyle = {};
                let coverage = null;
                if (mobile.cobertura && mobile.cobertura.cobertura && mobile.cobertura.cobertura.length > 0) {
                  // <div style={{ coverageStyle }}></div>
                  mobile.cobertura.cobertura.map((currentCoverage, key) => {
                    coverageStyle = {
                      position: "absolute",
                      top: "0",
                      left: (parseInt(key) * 5) + "px",
                      width: "5px",
                      height: "100%",
                      background: currentCoverage.color
                    }
                    if (!coverage) coverage = [];
                    coverage.push(<div key={key} style={coverageStyle}></div>);
                  });
                }
                let mobileCard = (
                  <Card 
                    onContextMenu={e => {
                      e.preventDefault();
                      this.handleDoubleClick(AGREGAR_MOVIL, mobile);
                    }}  
                    color={this.defineMobileColor(mobile)} 
                    style={{ overflow: "hidden" }}
                    className="text-center">
                    <CardHeader className="txt-black">
                      <i className="now-ui-icons tech_mobile" /> {mobilePlan}
                    </CardHeader>
                    <CardBody className="text-center txt-white h3 h-nomargin">
                      {formattedNumber}
                    </CardBody>
                    <CardFooter className="text-right txt-black">
                      <Row>
                        <Col xs={6} className="text-left txt-black">
                          {mobile.estado ? mobile.estado.replace("Bloqueado por ", "").replace("f","F") : "Sin estado"}
                        </Col>
                        <Col xs={6} className="text-right txt-black">
                          {mobile.precio}
                        </Col>
                      </Row>
                    </CardFooter>
                    {coverage}
                  </Card>
                );

                // if (
                //   this.props.mainState.user.field_tipo_distribuidor.und &&
                //   this.props.mainState.user.field_tipo_distribuidor.und[0]
                //     .tid !== 180
                // ) {
                  mobileCard = (
                    <Link
                      to={
                        "/clientes/fichas/".concat(this.state.customer.id) +
                        "/movil/" +
                        mobile.numero
                      }
                    >
                      {mobileCard}
                    </Link>
                  );
                // }
                return (
                  <Col xs={12} sm={6} lg={3} key={key}>
                    {mobileCard}
                  </Col>
                );
              }
            )}
            {disabledMobilesCount > 0 && 
              <Col xs={12} sm={6} lg={3}>
                <Link to="#">
                  <Card 
                    onClick={() => this.setState({ showDisabledMobiles: !this.state.showDisabledMobiles }) }
                    color="default" 
                    style={{ overflow: "hidden" }}
                    className="text-center">
                    <CardHeader className="txt-black">
                      <i className={this.state.showDisabledMobiles ? "now-ui-icons ui-1_simple-delete" : "now-ui-icons ui-1_simple-add"} /> {
                      this.state.showDisabledMobiles ? "Ocultar todos" : "Mostrar todos"
                    }
                    </CardHeader>
                    <CardBody className="text-center txt-white h3 h-nomargin">
                      {disabledMobilesCount + (disabledMobilesCount > 1 ? " terminados" : " terminado")}
                    </CardBody>
                    <CardFooter className="text-right txt-black">
                      <Row>
                        <Col xs={6} className="text-left txt-black">
                          {/* Pulsa para mostrar todos */}
                        </Col>
                        <Col xs={6} className="text-right txt-black">
                          {/* {mobile.precio} */}
                        </Col>
                      </Row>
                    </CardFooter>
                    {/* {coverage} */}
                  </Card>
                </Link>
              </Col>
            }
          </Row>
        );
      } else {
        /*mobiles = 
        <Row>
          <Col xs={12} sm={6} lg={3} >
              <Card
              color="default"
              className="text-center">
                <CardHeader 
                className="txt-black">
                  <i className="now-ui-icons tech_mobile" />
                </CardHeader>
                <CardBody 
                className="text-center h5 h-nomargin">
                No tiene ningún móvil
                </CardBody>
                <CardFooter
                className="text-right txt-black">
                </CardFooter>
              </Card>
          </Col>
        </Row>*/
        mobiles = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene ningún móvil...</td>
              </tr>
            </tbody>
          </Table>
        );
      }

      return mobiles;
    }

    return mobiles;
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case TRAMITE:
        return this.createMobileProcedurePopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case HISTORIAL_PAGOS: // Historial de pagos del gasto extra
        return this.createPaymentHistoryPopUp();
      case PASSWORD: // Change client password
        return this.createChangePasswordPopUp();
      case TV:
        return this.configureTVPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createChangePasswordPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-150px" }}
        title="Cambiar contraseña"
        onConfirm={() => this.showPopUpConfirmation(PASSWORD)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Cambiar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Col md={12} className="text-center">Nueva contraseña</Col>
            <Col xs={12}>
              <FormGroup className={this.state.fieldStates["newPassword"]}>
                <Input
                  type="text"
                  name="newPassword"
                  placeholder="Contraseña"
                  value={this.state.newPassword}
                  onChange={event => {
                    let password = event.target.value.replace(/\s/g, "");
                    this.setState({ newPassword: password });
                    this.validateField("newPassword", password);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  createPaymentHistoryPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Historial de pagos"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="default"
        // cancelBtnBsStyle="default"
        confirmBtnText="Cerrar"
        // cancelBtnText="Cancelar"
        // showCancel
      >
        <Form className="form-horizontal">
          <Row>
            {/* <Label md={3}>Estado</Label> */}
            <Col xs={12} md={9}>
              <div dangerouslySetInnerHTML={{ __html: this.state.historial_pagos }} />
              {/* <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup> */}
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateICC(icc) {
    return checkICC(icc) && (icc.length === 19 || icc.length === 20);
  }
  validateIBAN(iban) {
    return checkIBAN(iban) && iban.replace(/ /g, "").length === 24;
  }
  isNewIBAN(iban) {
    return iban.replace(/ /g, "") !== this.state.latestValidatedIBAN;
  }
  validateNombre(nombre) {
    let result = false;
    if (nombre && nombre.length > 1) result = true;
    return result;
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "movil":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "newPassword":
        if (this.validateNewPassword(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombre":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "primer_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "segundo_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "email":
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nif":
        var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
        var validPassport = regPassport.test(value);
        if (validateSpanishId(value) || validPassport) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "direccion":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "localidad":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "codigo_postal":
        if (value && value > 0 && value.length === 5) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  validateNewNote() {
    let validation = true;
    if (this.state.noteText === "") validation = false;
    return validation;
  }
  validateNewExtraExpense() {
    let validation = true;
    if (this.state.extraExpenseType === "") validation = false;
    if (this.state.extraExpensePrice === "") validation = false;
    if (this.state.extraExpenseConcept === "") validation = false;
    if (this.state.extraExpenseType.value === "129" && this.state.extraExpenseFees === "") validation = false;
    return validation;
  }
  validateConfigureInternet() {
    let validation = true;
    if (this.state.internetPlan === "") validation = false;
    return validation;
  }
  validateConfigureTV() {
    let validation = true;
    if (this.state.TVPlan === "") validation = false;
    return validation;
  }
  validateAddMobile() {
    let validation = true;
    if (this.state.mobilePlan === "") validation = false;
    if (this.state.mobileNumber === "") validation = false;
    if (this.state.mobileNumberState === " has-danger") validation = false;
    return validation;
  }
  disableInternet() {
    this.props.toggleCustomerInternetService(this.state.customer.id,false);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Desactivado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Internet desactivado.
        </SweetAlert>
      )
    });
  }
  disableTV() {
    let subscription_edit = {
      customer_id: this.state.customer.id,
      action: "BAJA"
    };
    this.props.edit_tv_subscription(subscription_edit);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Baja solicitada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Baja de TV solicitada, programada para el último día del mes.
        </SweetAlert>
      )
    });
  }
  enableTV() {
    let subscription_edit = {
      customer_id: this.state.customer.id,
      action: "ALTA",
      plan: this.state.TVPlan
    };
    this.props.edit_tv_subscription(subscription_edit);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Alta solicitada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Alta de TV solicitada, programada para ahora mismo.
        </SweetAlert>
      )
    });
  }
  validateNewProcedure() {
    let validation = true;
    // En caso de tratarse de un cambio de tarifa
    if (this.state.procedureType && parseInt(this.state.procedureType.value) === 175) {
      if (this.state.selectedPlan && this.state.existingMobile) return true;
      return false;
    }
    this.state.fieldsToValidate.map((item,key) => 
    {
      if (item === "phoneNumber" && !this.isNumberNeeded()) return;
      if (item === "previousICC" && !this.isPreviousICCNeeded()) return;
      this.validateField(item, this.state[item]);
      if (this.state.fieldStates[item] === "has-danger") validation = false;
      if (!this.state[item] || this.state[item] === "") {
        validation = false;
      }
    });
    if (!this.state.selectedPlan) validation = false;
    if (!this.state.procedureType) validation = false;
    if (!this.state.previousContract && this.isNumberNeeded()) validation = false;
    return validation;
  }
  validateNewDelivery() {
    let result = this.validateNewProcedure();
    result = result && this.state.deliveryType && this.state.deliveryType.value;
    return result;
  }
  validateNumber(e){
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validateNewPassword() {
    let validation = true;
    if (this.state.newPassword && this.state.newPassword.length < 6) validation = false;
    return validation;
  }
  isNumberNeeded() {
    let result = false;
    if(this.state.procedureType != undefined && this.state.procedureType.value == 171) result = true;
    return result;
  }
  isPreviousICCNeeded() {
    let result = false;
    if (
      this.state.previousContract != undefined &&
      this.state.previousContract.label == "Prepago"
    )
      result = true;
    return result;
  }
  customFilter(option, searchText) {
    let label = ReactDOMServer.renderToStaticMarkup(option.label).toLowerCase();
    let result = true;
    let words = searchText.split(" ");
    if (isExterno) {
      if (words.length === 0) words = [];
      words.push("TTB");
    }
    if (words.length === 0) return false;
    for (let index = 0; index < words.length; index++) {
      const element = words[index];
      element.replace(/\s/g, '');
      if (element && element !== "")
        result = result && label.includes(element.toLowerCase());
    }
    return result;
  }
  isExistingMobileNeeded() {
    return this.state.procedureType && parseInt(this.state.procedureType.value) === 175; 
  }
  isIccNeeded() {
    return this.state.procedureType && !this.isExistingMobileNeeded();
  }
  customerMobilesForOptions() {
    let mobiles = null;

    if (!this.props.mainState.customersMobilesLoaded) {
      mobiles = null;
    } else {
      let mobilesQuantity = 0;
      // console.log("######## TEST PERFIL MOVILES #######");
      // console.log(this.props.mainState);
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      if (mobilesQuantity > 0) {
        mobiles = this.props.mainState.customersMobiles[this.state.customer.id].map(
          (mobile, key) => {
            // console.log("mobile", mobile);
            if (mobile.estado && mobile.estado.toLowerCase() !== "terminado") {
              let mobilePlan = "";
              if (mobile.plan) {
                mobilePlan = mobile.plan
                  .replace("(Nueva) ", "")
                  .replace(" (Móvil)", "");
              }
              if (mobile.plan === "") mobile.plan = "Error tarifa";
              let formattedNumber = "";
              if (mobile.numero) {
                formattedNumber =
                  mobile.numero.substring(0, 3) +
                  " " +
                  mobile.numero.substring(3, 6) +
                  " " +
                  mobile.numero.substring(6, 9);
              }
              if (mobile.numero === "") formattedNumber = "Error número";

              return {
                label: formattedNumber + " | " + mobilePlan,
                value: parseInt(mobile.numero)
              };
            }
          }
        );
        mobiles = mobiles.filter(function (el) {
          return el != null;
        });
      }
    }

    return mobiles;
  }
  createMobileProcedurePopUp() {
    let numberField = undefined;
    if (this.isNumberNeeded()) {
      //Si es portabilidad
      numberField = 
      <Row>
        <Label md={3}>Número</Label>
        <Col xs={12} md={9}>
          <FormGroup className={this.state.fieldStates["phoneNumber"]}>
              <Input
                type="text"
                value={this.state.phoneNumber}
                onChange={event => {
                  this.setState({ phoneNumber: event.target.value.replace(/\s+/g, '') });
                  this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                }}
              />
          </FormGroup>
        </Col>
      </Row>;
    }
    let previousContractField = undefined;
    if (this.isNumberNeeded()) {
      //Si es portabilidad
      previousContractField = 
        <Row>
          <Label md={3}>Previa</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                placeholder="Tipo anterior"
                name="previousContract"
                value={this.state.previousContract}
                options={previousContract}
                onChange={value =>
                  this.setState({ previousContract: value })
                }
              />
            </FormGroup>
          </Col>
        </Row>;
    }
    let previousICCField = undefined;
    if (this.isPreviousICCNeeded()) {
      //Si es portabilidad
      previousICCField = 
        <Row>
          <Label md={3}>Prev. ICC</Label>
          <Col xs={12} md={9}>
            <FormGroup className={this.state.fieldStates["previousICC"]}>
              <Input
                type="text"
                value={this.state.previousICC}
                placeholder="ICC SIM prepago"
                onChange={event => {
                  this.setState({ previousICC: event.target.value.replace(/\s+/g, '') });
                  this.validateField("previousICC", event.target.value.replace(/\s+/g, ''));
                }}
            />
            </FormGroup>
          </Col>
        </Row>;
    }
    let existingMobileField = undefined;
    if (this.isExistingMobileNeeded()) {
      //Si es portabilidad
      existingMobileField = 
        <Row>
          <Label md={3}>Línea</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                placeholder="Selecciona la línea"
                name="existingMobile"
                value={this.state.existingMobile}
                options={this.customerMobilesForOptions()}
                noOptionsMessage={() => 'El cliente no tiene móviles'}
                onChange={value =>
                  this.setState({ existingMobile: value })
                }
              />
            </FormGroup>
          </Col>
        </Row>;
    }
    let iccField = undefined;
    if (this.isIccNeeded()) {
      iccField =
        <Row>
          <Label md={3}>ICC SIM</Label>
          <Col xs={12} md={9}>
            <FormGroup className={this.state.fieldStates["ICC"]}>
              <Input
                type="text"
                value={this.state.ICC}
                onChange={event => {
                  this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                  this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                }}
            />
            </FormGroup>
          </Col>
        </Row>;
    }
    
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Crear trámite"
        onConfirm={() => this.showPopUpConfirmation(TRAMITE)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Crear"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tarifa</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tarifa"
                  name="tarifa"
                  value={this.state.selectedPlan}
                  options={this.props.mainState.mobilePlans.forOptions}
                  onChange={value =>
                    this.setState({ selectedPlan: value })
                  }
                  filterOption={this.customFilter}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de trámite"
                  name="procedureType"
                  value={this.state.procedureType}
                  options={this.props.mainState.mobileProcedureTypes.forOptions}
                  onChange={value =>
                    this.setState({ procedureType: value })
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          {existingMobileField}
          {iccField}
          {numberField}
          {previousContractField}
          {previousICCField}
        </Form>
      </SweetAlert>
    );
  }
  formatPriceFromAmount(price) {
    price = parseInt(price)/100;
    price = Math.round((price + Number.EPSILON) * 100) / 100;

    return (price + " €").replace(".", ",");
  }
  loadSIMDeliveryTypesOptions() {
    let result = [];
    let options = this.props.mainState.SIMDeliveryTypes;
    // console.log("this.props",this.props);
    if (options) {
      options.map(option => {
        result.push({
          label: (<span key={option.id} className="delivery-type-option">{option.name}<span className="delivery-price">{this.formatPriceFromAmount(option.price)}</span></span>),
          value: option.value
        })
      });
    }
    return result;
  }
  createDeliveryPopUp() {
    let numberField = undefined;
    if (this.isNumberNeeded()) {
      //Si es portabilidad
      numberField = 
      <Row>
        <Label md={3}>Número</Label>
        <Col xs={12} md={9}>
          <FormGroup className={this.state.fieldStates["phoneNumber"]}>
              <Input
                type="text"
                value={this.state.phoneNumber}
                onChange={event => {
                  this.setState({ phoneNumber: event.target.value.replace(/\s+/g, '') });
                  this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                }}
              />
          </FormGroup>
        </Col>
      </Row>;
    }
    let previousContractField = undefined;
    if (this.isNumberNeeded()) {
      //Si es portabilidad
      previousContractField = 
        <Row>
          <Label md={3}>Previa</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                placeholder="Tipo anterior"
                name="previousContract"
                value={this.state.previousContract}
                options={previousContract}
                onChange={value =>
                  this.setState({ previousContract: value })
                }
              />
            </FormGroup>
          </Col>
        </Row>;
    }
    let previousICCField = undefined;
    if (this.isPreviousICCNeeded()) {
      //Si es portabilidad
      previousICCField = 
        <Row>
          <Label md={3}>Prev. ICC</Label>
          <Col xs={12} md={9}>
            <FormGroup className={this.state.fieldStates["previousICC"]}>
              <Input
                type="text"
                value={this.state.previousICC}
                placeholder="ICC SIM prepago"
                onChange={event => {
                  this.setState({ previousICC: event.target.value.replace(/\s+/g, '') });
                  this.validateField("previousICC", event.target.value.replace(/\s+/g, ''));
                }}
            />
            </FormGroup>
          </Col>
        </Row>;
    }
    let existingMobileField = undefined;
    if (this.isExistingMobileNeeded()) {
      //Si es portabilidad
      existingMobileField = 
        <Row>
          <Label md={3}>Línea</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                placeholder="Selecciona la línea"
                name="existingMobile"
                value={this.state.existingMobile}
                options={this.customerMobilesForOptions()}
                noOptionsMessage={() => 'El cliente no tiene móviles'}
                onChange={value =>
                  this.setState({ existingMobile: value })
                }
              />
            </FormGroup>
          </Col>
        </Row>;
    }
    let iccField = undefined;
    if (this.isIccNeeded()) {
      iccField =
        <Row>
          <Label md={3}>ICC SIM</Label>
          <Col xs={12} md={9}>
            <FormGroup className={this.state.fieldStates["ICC"]}>
              <Input
                type="text"
                value={this.state.ICC}
                onChange={event => {
                  this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                  this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                }}
            />
            </FormGroup>
          </Col>
        </Row>;
    }
    
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Enviar SIM"
        onConfirm={() => this.showPopUpConfirmation(ENVIO)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Enviar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Envío</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de envío"
                  name="tipo_envio"
                  value={this.state.deliveryType}
                  options={this.loadSIMDeliveryTypesOptions()}
                  onChange={value =>
                    this.setState({ deliveryType: value })
                  }
                  filterOption={this.customFilter}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Tarifa</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tarifa"
                  name="tarifa"
                  value={this.state.selectedPlan}
                  options={this.props.mainState.mobilePlans.forOptions}
                  onChange={value =>
                    this.setState({ selectedPlan: value })
                  }
                  filterOption={this.customFilter}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de trámite"
                  name="procedureType"
                  value={this.state.procedureType}
                  options={this.props.mainState.mobileProcedureTypes.forOptions}
                  onChange={value =>
                    this.setState({ procedureType: value })
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          {existingMobileField}
          {iccField}
          {numberField}
          {previousContractField}
          {previousICCField}
        </Form>
      </SweetAlert>
    );
  }
  createNotePopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Escribir nota"
        onConfirm={() => this.showPopUpConfirmation(NOTA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de nota"
                  name="noteType"
                  value={this.state.noteType}
                  options={noteType}
                  onChange={value => this.setState({ noteType: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Título</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Input
                  type="text"
                  name="noteTitle"
                  placeholder="Título de la nota"
                  value={this.state.noteTitle}
                  onChange={event => this.setState({ noteTitle: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col size={12}>
              <FormGroup>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  createExtraExpensePopUp() {
    let extraExpenseFeesField = null;
    
    if (this.state.extraExpenseType.value === "129") {
      extraExpenseFeesField =
        <Row>
          <Label md={3}>Cuotas</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Input
                type="number"
                name="extraExpenseFees"
                placeholder="Número de cuotas"
                value={this.state.extraExpenseFees}
                onChange={event => this.setState({ extraExpenseFees: event.target.value })}
              />
            </FormGroup>
          </Col>
        </Row>;
    }
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title={this.state.extraExpenseID ? "Editar gasto" : "Añadir gasto"}
        onConfirm={() => this.showPopUpConfirmation(GASTO_EXTRA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText={this.state.extraExpenseID ? "Editar" : "Añadir"}
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de gasto"
                  name="extraExpenseType"
                  value={this.state.extraExpenseType}
                  options={extraExpenseType}
                  onChange={value => this.setState({ extraExpenseType: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Concepto</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Input
                  type="text"
                  name="extraExpenseConcept"
                  placeholder="Concepto del gasto"
                  value={this.state.extraExpenseConcept}
                  onChange={event => this.setState({ extraExpenseConcept: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          {extraExpenseFeesField}
          <Row>
            <Label md={3}>Precio</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Input
                  type="number"
                  name="extraExpensePrice"
                  placeholder="Precio del gasto"
                  value={this.state.extraExpensePrice}
                  onChange={event => this.setState({ extraExpensePrice: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  configureInternetPopUp() {
    let plansToShow = [];
    let plansToFilter = this.props.mainState.internetPlans;
    // console.log("configuring internet plan, isExterno: ", isExterno);
    if (isExterno) {
      plansToFilter = [];
      plansToFilter["Fibra óptica"] = [
        {
          precio_raw: 2995,
          precio: "29,95€",
          id: 75817,
          titulo: "100Mb simétricos"
        },
        {
          precio_raw: 3995,
          precio: "39,95€",
          id: 75816,
          titulo: "600Mb simétricos"
        }
      ];
    }
    if (this.state.internetType && this.state.internetType.label in plansToFilter) {
      plansToShow = plansToFilter[this.state.internetType.label].sort(function(a, b){return a.precio_raw - b.precio_raw});
      plansToShow = plansToShow.map((plan, key) => {
        return {
          value: plan.id,
          label: plan.titulo.replace("Fibra Óptica ", "") + " (" + plan.precio + ")"
        };
      });
    }
    let activeInternet = this.state.customer.internet_activo === "1";
    let cancelButtonColor = "default";
    let cancelButtonText = "Cancelar";
    let disableInternetButton = null;
    if (activeInternet) {
      // cancelButtonColor = "danger";
      // cancelButtonText = "Desactivar";
      disableInternetButton = 
        <Row>
          <Col size={12}>
            <Button
              color="danger"
              size="xs"
              onClick={() => {
                this.disableInternet();
              }}
            >
              Desactivar
            </Button>
          </Col>
        </Row>;
    }
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Configurar Internet"
        onConfirm={() => this.showPopUpConfirmation(INTERNET)}
        onCancel={(e) => {
          this.hideAlert();
        }}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle={cancelButtonColor}
        confirmBtnText="Configurar"
        cancelBtnText={cancelButtonText}
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Modalidad"
                  name="internetType"
                  value={this.state.internetType}
                  options={internetType}
                  onChange={value => {
                    if (this.state.internetType !== value)
                      this.setState({ internetType: value, internetPlan: "" });
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Tarifa</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tarifa"
                  name="internetPlan"
                  value={this.state.internetPlan}
                  options={plansToShow}
                  onChange={value => this.setState({ internetPlan: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          {disableInternetButton}
        </Form>
      </SweetAlert>
    );
  }
  configureTVPopUp() {
    let plansToShow = [];
    plansToShow = this.props.mainState.TVPlans.forOptions;
    let activeTV = this.state.customer.tv && this.state.customer.tv.isActive ? true : false;
    let cancelButtonColor = "default";
    let cancelButtonText = "Cancelar";
    let disableTVButton = null;
    if (activeTV) {
      // cancelButtonColor = "danger";
      // cancelButtonText = "Desactivar";
      disableTVButton = 
        <Row>
          <Col size={12}>
            <Button
              color="danger"
              size="xs"
              onClick={() => {
                this.disableTV();
              }}
            >
              Dar de baja
            </Button>
          </Col>
        </Row>;
    }
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Configurar TV"
        onConfirm={() => this.showPopUpConfirmation(TV)}
        onCancel={(e) => {
          this.hideAlert();
        }}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle={cancelButtonColor}
        confirmBtnText="Configurar"
        cancelBtnText={cancelButtonText}
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Paquete</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Paquete"
                  name="TVPlan"
                  value={this.state.TVPlan}
                  options={plansToShow}
                  onChange={value => this.setState({ TVPlan: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          {disableTVButton}
        </Form>
      </SweetAlert>
    );
  }
  mobileNumberChange(e) {
    this.setState({
      mobileNumber: e.target.value
    });
    if (e.target.value.length == 9 && e.target.value >= 600000000 && e.target.value <= 999999999) {
      this.setState({
        mobileNumberState: " has-success"
      });
    } else {
      this.setState({
        mobileNumberState: " has-danger"
      });
    }
  }
  addMobilePopUp() {
    let plansToShow = this.props.mainState.mobilePlans.forOptions;
    let cancelButtonColor = "default";
    let cancelButtonText = "Cancelar";
    // console.log("################## ADD MOBILE POP UP ################");
    // console.log(this.props.mainState);
    let mobileStatusDropdown = null;

    let discount = (
      <Row>
        <Label md={3}>Desc.</Label>
        <Col xs={12} md={9}>
          <FormGroup>
            <Input
              type="number"
              name="mobileDiscount"
              placeholder="Precio del descuento"
              value={this.state.mobileDiscount}
              onChange={event => {
                let _value = event.target.value;
                let parsedValue = ((-1) * Math.abs(_value));
                if (!parsedValue) {
                  if (_value === "0") _value = null;
                  this.setState({ mobileDiscount: _value });
                } else {
                  if (parsedValue === 0) _value = null;
                  this.setState({ mobileDiscount: parsedValue });
                }
              }}
              disabled={!this.state.mobilePlan}
            />
          </FormGroup>
        </Col>
      </Row>
    );
    let dataBonus = (
      <Row>
        <Label md={3}>GB gratis</Label>
        <Col xs={12} md={9}>
          <FormGroup>
            <Input
              type="number"
              name="dataBonus"
              placeholder="Bono de GB gratis"
              value={this.state.dataBonus}
              onChange={event => {
                let _value = event.target.value;
                _value = Math.abs(_value);
                if (_value === 0) _value = null;
                this.setState({ dataBonus: _value });
              }}
              disabled={!this.state.mobilePlan}
            />
          </FormGroup>
        </Col>
      </Row>
    );

    if (this.state.editingMobileID) {
      mobileStatusDropdown =
        <Row>
          <Label md={3}>Estado</Label>
          <Col xs={12} md={9}>
            <FormGroup>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                placeholder="Estado"
                name="mobileStatus"
                value={this.state.mobileStatus}
                options={mobileStatus}
                onChange={value => this.setState({ mobileStatus: value })}
              />
            </FormGroup>
          </Col>
        </Row>;
      discount = null;
      dataBonus = null;
    }

    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Añadir móvil"
        onConfirm={() => this.showPopUpConfirmation(AGREGAR_MOVIL)}
        onCancel={(e) => {
          this.hideAlert();
        }}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle={cancelButtonColor}
        confirmBtnText={this.state.editingMobileID ? "Editar" : "Añadir"}
        cancelBtnText={cancelButtonText}
        showCancel
        disabled={!this.validateAddMobile()}        
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tarifa</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tarifa"
                  name="mobilePlan"
                  value={this.state.mobilePlan}
                  options={plansToShow}
                  onChange={value => this.setState({ mobilePlan: value })}
                  filterOption={this.customFilter}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Número</Label>
            <Col xs={12} md={9}>
              <InputGroup
                className={
                  "form-control-lg" +
                  (this.state.mobileNumberState ? this.state.mobileNumberState : "") +
                  (this.state.mobileNumberFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons tech_mobile" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  defaultValue={this.state.mobileNumber}
                  type="number"
                  placeholder="Número de móvil"
                  name="mobileNumber"
                  onFocus={e => this.setState({ mobileNumberFocus: true })}
                  onBlur={e => this.setState({ mobileNumberFocus: false })}
                  onChange={e => this.mobileNumberChange(e)}
                />
              </InputGroup>
            </Col>
          </Row>
          {mobileStatusDropdown}
          {discount}
          {dataBonus}
        </Form>
      </SweetAlert>
    );
  }
  cancelProcedure(mobileProcedure, customer) {
    this.props.cancelMobileProcedure(mobileProcedure, customer);
  }
  newNoteConfirmation() {
    if (!this.validateNewNote()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.createNote(
      this.state.noteType.value,
      this.state.noteTitle,
      this.state.noteText,
      this.state.customer.id
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Añadida!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          La nota ha sido añadida.
        </SweetAlert>
      )
    });
  }
  newExtraExpenseConfirmation() {
    if (!this.validateNewExtraExpense()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    let extraExpense = {
      type: this.state.extraExpenseType.value,
      concept: this.state.extraExpenseConcept,
      fees: this.state.extraExpenseFees,
      price: this.state.extraExpensePrice,
      id_existing_expense: this.state.extraExpenseID
    };
    this.props.createExtraExpenseWrapper(this.state.customer.id, extraExpense);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title={this.state.extraExpenseID ? "¡Editado!" : "¡Añadido!"}
          onConfirm={() => this.showPopUp(GASTO_EXTRA)}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnText="Añadir otro"
          cancelBtnText="Cerrar"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          showCancel
        >
          {this.state.extraExpenseID ? "El gasto extra ha sido editado." : "El gasto extra ha sido añadido."}
        </SweetAlert>
      )
    });
  }
  configureInternetConfirmation() {
    if (!this.validateConfigureInternet()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.setCustomerInternetPlan(
      this.state.customer.id,
      this.state.internetPlan.value
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Lista!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Tarifa de internet configurada.
        </SweetAlert>
      )
    });
  }
  configureTvConfirmation() {
    if (!this.validateConfigureTV()) {
      return;
    }
    this.enableTV();
  }
  newMobileProcedureConfirmation() {
    if (!this.validateNewProcedure()) {
      return;
    }
    this.props.createMobileProcedure(
      this.state.ICC, 
      this.state.selectedPlan, 
      this.state.customer.id, 
      this.state.procedureType,       
      null, 
      this.state.phoneNumber, 
      this.state.previousContract ? this.state.previousContract.value : "",
      this.state.previousICC,
      this.state.existingMobile);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Creada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El trámite ha sido creado.
        </SweetAlert>
      )
    });
  }
  newDeliverySIMConfirmation() {
    // console.log("delivery this.state", this.state);
    if (!this.validateNewDelivery()) {
      return;
    }
    let title = 
      this.state.customer.nif + " - " + // Título del envío
      this.state.customer.nombre_completo + " " + // Título del envío
      this.state.customer.primer_apellido + " " + // Título del envío
      this.state.customer.segundo_apellido;// Título del envío
    let delivery = {
      title: 
        "Envío SIM a " + // Título del envío
        title,// Título del envío
      icc: this.state.ICC,
      customer: this.state.customer.id,
      mobile: this.state.phoneNumber,
      type: this.state.deliveryType.value,
      procedure: {
        title: title,
        icc: this.state.ICC, 
        plan: this.state.selectedPlan.value, 
        customer: this.state.customer.id, 
        type: this.state.procedureType.value,       
        test: null, 
        mobile: this.state.phoneNumber, 
        previous_contract: this.state.previousContract ? this.state.previousContract.value : "",
        previous_icc: this.state.previousICC,
        existing_mobile: this.state.existingMobile
      }
    }
    console.log("new_delivery", delivery);
    this.props.createSIMDelivery(delivery);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block"/*, marginTop: "-250px" */}}
          title="¡Enviada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          La SIM se ha enviado.
        </SweetAlert>
      )
    });
  }
  errorRenovation() {
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          danger
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Error!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Entendido"
        >
          No se puede activar la renovación con la cuenta bancaria mal.
        </SweetAlert>
      )
    });
  }
  addMobile() {
    if (!this.validateAddMobile()) {
      return;
    }
    console.log("Create mobile state: ", this.state);
    this.props.createCustomerMobile(
      this.state.customer.id,
      this.state.mobileNumber,
      this.state.mobilePlan.value,
      this.state.editingMobileID,
      this.state.mobileStatus,
      this.state.mobileDiscount,
      this.state.dataBonus
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Listo!"
          onConfirm={() => this.showPopUp(AGREGAR_MOVIL)}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnText="Añadir otro"
          cancelBtnText="Cerrar"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          showCancel
        >
          Móvil añadido al cliente, ahora puedes añadir otro o cerrar.
        </SweetAlert>
      )
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case TRAMITE:
        this.newMobileProcedureConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case TV:
        this.configureTvConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case ERROR_ACTIVAR_RENOVACION:
        this.errorRenovation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case PASSWORD:
        this.setNewPasswordConfirmation();
        break;
      default:;
    }
  }
  setNewPasswordConfirmation() {
    if (!this.validateNewPassword()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.changeClientPassword(parseInt(this.state.customer.id), this.state.newPassword);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-150px" }}
          title={"¡Contraseña cambiada!"}
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnText="Cerrar"
          // cancelBtnText="Cerrar"
          confirmBtnBsStyle="default"
          // cancelBtnBsStyle="default"
          // showCancel
        />
      )
    });
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber,
      this.state.customer.nif
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      phoneNumber: "",
      ICC: "",
      selectedPlan: null,
      popUpToShow: tipo,
      showPopUp: true,
      procedureType: undefined,
      fieldStates: [],
      noteText: "",
      noteTitle: "",
      noteType: "",
      internetPlan: "",
      internetType: "",
      mobilePlan: "",
      mobileNumber: "",
      mobileNumberState: "",
      popUpConfirmation: null,
      extraExpenseType: "",
      extraExpenseConcept: "",
      extraExpenseFees: "",
      extraExpensePrice: "",
      extraExpenseID: null,
      previousICC: "",
      previousContract: null,
      SIMCoverage: "",
      procedureId: "",
      editingMobileID: null,
      newPassword: "",
      TVPlan: "",
      mobileDiscount: null,
      dataBonus: null
    });
  }
  createProcedureState(procedure) {
    let procedureState = null;

    let procedureStateColor = "default";
    let procedureStateIcon = "default";
    let procedureStateText = procedure.estado_tramite;
    let shortened_text = "";
    let tooMuchText = procedure.motivo_rechazo && procedure.motivo_rechazo.length > 13;

    if (tooMuchText) shortened_text = procedure.motivo_rechazo.substring(0, 13) + "...";

    switch (procedure.estado_tramite) {
      case "Pendiente": 
        procedureStateColor = "default";
        procedureStateIcon = "travel_info";
        break;
      case "Procesando": 
        procedureStateColor = "warning";
        procedureStateIcon = "loader_refresh spin";
        break;
      case "Error": 
        procedureStateColor = "danger";
        procedureStateIcon = "health_ambulance";
        break;
      case "Aceptado": 
        procedureStateColor = "info";
        procedureStateIcon = "ui-1_check";
        break;
      case "Finalizado": 
        procedureStateColor = "primary";
        procedureStateIcon = "ui-2_favourite-28";
        break;
      case "ICC previo incorrecto": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_settings-90";
        break;
      case "Rechazado": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_time-alarm";
        procedureStateText = procedureStateText + " [" + (tooMuchText ? shortened_text : procedure.motivo_rechazo) + "]"
        break;
      case "Cancelado": 
        procedureStateColor = "default";
        procedureStateIcon = "media-1_button-power";
        break;
      case "Esperando SIM": 
        procedureStateColor = "warning";
        procedureStateIcon = "shopping_delivery-fast";
        break;
      default:
    }

    procedureState = 
      <div className="btns-mr-5">
        <Button
          color={procedureStateColor}
          size="sm"
          onClick={() => {
            if (tooMuchText) alert(procedure.motivo_rechazo);
          }}
        >
          <i className={"now-ui-icons " + procedureStateIcon} />{" "}
          {procedureStateText}
        </Button>
      </div>;
    return procedureState;
  }
  createProcedures() {
    let procedures = undefined;

    if (!(this.state.customer.id in this.props.mainState.mobileProcedures)) {
      procedures = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    } else {
      let customerProcedures = this.props.mainState.mobileProcedures[
        this.state.customer.id
      ][this.state.customer.id];
      if (customerProcedures === undefined)
        customerProcedures = this.props.mainState.mobileProcedures[
          this.state.customer.id
        ];

      let proceduresQuantity = customerProcedures.length;

      //console.log("######################## customer procedures: ###########################");
      //console.log(customerProcedures);
      //console.log("######################## customer procedures quantity: ###########################");
      //console.log(proceduresQuantity);

      if (proceduresQuantity > 0) {
        procedures = (
          <Table responsive>
            <thead>
              <tr className="tex#t-primary">
                <th className="text-center">Creación</th>
                <th className="text-center">Autor</th>
                <th>Tipo</th>
                <th>Cambio</th>
                <th>Número</th>
                <th>Tarifa</th>
                <th className="text-left">Estado</th>
              </tr>
            </thead>
            <tbody>
              {customerProcedures.map((procedure, key) => {
                let mobilePlan = procedure.tarifa
                  .replace("(Nueva) ", "")
                  .replace(" (Móvil)", "");
                let formattedNumber = procedure.numero;
                  // procedure.numero.substring(0, 3) +
                  // " " +
                  // procedure.numero.substring(3, 6) +
                  // " " +
                  // procedure.numero.substring(6, 9);
                let procedureState = this.createProcedureState(procedure);
                let procedureAction = null;
                //if(this.props.mainState.user.field_tipo_distribuidor.und[0].tid != 180) {
                procedureAction = (
                  <div className="btns-mr-5">
                    <Button
                      icon
                      color="default"
                      size="sm"
                      onClick={e => {
                        e.preventDefault();
                        this.cancelProcedure(
                          procedure.id_tramite,
                          this.state.customer.id
                        );
                      }}
                    >
                      <i className="now-ui-icons ui-1_simple-remove" />
                    </Button>
                  </div>
                );
                if (
                  this.state.customer.id in
                    this.props.mainState.isCancellingMobileProcedure &&
                  procedure.id_tramite in
                    this.props.mainState.isCancellingMobileProcedure[
                      this.state.customer.id
                    ] &&
                  this.props.mainState.isCancellingMobileProcedure[
                    this.state.customer.id
                  ][procedure.id_tramite]
                ) {
                  procedureAction = (
                    <div className="btns-mr-5">
                      <Button icon color="info" size="sm">
                        <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                      </Button>
                    </div>
                  );
                }
                // if (procedure.estado_tramite !== "Pendiente" && procedure.estado_tramite !== "Error") {
                if (!(procedure.estado_tramite === "Pendiente" || procedure.estado_tramite === "Procesando" || procedure.estado_tramite === "Aceptado")) {
                  procedureAction = null;
                }
                //}
                try {
                  // console.log("###### Trámite ######");
                  // console.log(procedure);
                  return (
                    <tr key={procedure.id_tramite}>
                      <td className="text-center">{procedure.creacion}</td>
                      <td className="text-center">{procedure.autor}</td>
                      <td>{procedure.tipo_tramite}</td>
                      <td>{procedure.fecha_cambio}</td>
                      <td>{formattedNumber}</td>
                      <td>{mobilePlan}</td>
                      <td className="text-left">{procedureState}</td>
                      <td className="text-center">{procedureAction}</td>
                    </tr>
                  );
                } catch (error) {
                  console.error(error);
                  return null;
                  // expected output: ReferenceError: nonExistentFunction is not defined
                  // Note - error messages will vary depending on browser
                }
              })}
            </tbody>
          </Table>
        );
      } else {
        procedures = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene ningún trámite...</td>
              </tr>
            </tbody>
          </Table>
        );
      }

      return procedures;
    }

    return procedures;
  }
  createSIMDeliveries() {
    let deliveries = undefined;

    if (!(this.state.customer.id in this.props.mainState.SIMDeliveries)) {
      deliveries = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    } else {
      let deliveriesQuantity = 0;
      if (
        this.state.customer.id in
        this.props.mainState.SIMDeliveries[this.state.customer.id]
      ) {
        deliveriesQuantity = Object.keys(
          this.props.mainState.SIMDeliveries[this.state.customer.id][
            this.state.customer.id
          ]
        ).length;
      }
      //console.log("######################## customer SIM deliveries: ###########################");
      //console.log(this.props.mainState.SIMDeliveries[this.state.customer.id][this.state.customer.id]);
      //console.log("######################## customer SIM deliveries quantity: ###########################");
      //console.log(deliveriesQuantity);

      if (deliveriesQuantity > 0) {
        deliveries = (
          <Table responsive>
            <thead>
              <tr className="tex#t-primary">
                <th className="text-center">Salida</th>
                <th>ICC</th>
                <th>Número</th>
                <th>Tipo de envío</th>
                <th>Seguimiento</th>
                <th className="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              {this.props.mainState.mobileProcedures[this.state.customer.id][
                this.state.customer.id
              ].map((delivery, key) => {
                //console.log("################## mainState en IMPRIMIR ENVIOS SIMS ################");
                //console.log(this.props.mainState);
                let deliveryState = (
                  <div className="btns-mr-5">
                    <Button
                      color={
                        delivery.estado_envio === "En camino"
                          ? "info"
                          : "default"
                      }
                      size="sm"
                    >
                      <i className="now-ui-icons media-2_sound-wave" />{" "}
                      {delivery.estado_envio}
                    </Button>
                  </div>
                );
                return (
                  <tr key={delivery.id_envio}>
                    <td className="text-center">{delivery.fecha_envio}</td>
                    <td>{delivery.icc}</td>
                    <td>{delivery.numero_movil}</td>
                    <td>{delivery.tipo_envio}</td>
                    <td>{delivery.numero_seguimiento}</td>
                    <td className="text-center">{deliveryState}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        );
      } else {
        deliveries = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene ningún trámite...</td>
              </tr>
            </tbody>
          </Table>
        );
      }

      return deliveries;
    }

    return deliveries;
  }
  createInternetCard() {
    return null;
    /*if (this.state.customer.internet_activo === "1") {
      return (
        <Card>
          <CardHeader>
            <h5 className="title">Internet en casa</h5>
          </CardHeader>
          <CardBody>
            <Row>
              <Col size={12}>
                <Card color="primary" className="text-center">
                  <CardHeader className="txt-black">
                    <i className="now-ui-icons tech_mobile" /> {"WiFi"}
                  </CardHeader>
                  <CardBody className="text-center txt-white h3 h-nomargin">
                    {this.state.customer.internet_tarifa.replace(" (Internet)", "")}
                  </CardBody>
                  <CardFooter className="text-right txt-black">
                    {this.state.customer.internet_precio}
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    }
    return null;*/
  }
  calculateAndFormatTVPrice(_package){
    let result = "";
    if (!_package || !_package.commerce_price || !_package.commerce_price.und || !_package.commerce_price.und[0]) return "0.0";
    let price = parseInt(_package.commerce_price.und[0].amount);
    let taxRate = _package.commerce_price.und[0];

    if (price > 0) {
      price = price / 100;
    }

    result = price.toString().replace(".", ",") + " €";
    if (result.endsWith(",00 €")) result = result.replace(",00 €", " €");

    return result;
  }
  createServicesButtons(customer) { //objects_key-25
    let buttons = [];
    let passwordIcon = "now-ui-icons objects_key-25";
    // Button Password
    if (!isExterno) {
      buttons.push(
        <Button
          key={"passwordButton" + customer.id}
          round
          icon
          color="default"
          size="sm"
          onClick={() => {
            this.showPopUp(PASSWORD);
          }}
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className={passwordIcon} />
          </div>
        </Button>
      );
      buttons.push("  ");
    }
    
    if (!this.props.mainState.customersMobilesLoaded) {
      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          color="default"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      let mobilesText = null;
      let mobileDanger = false;
      if (customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = 0;
        this.props.mainState.customersMobiles[customer.id]
          .map(currentMobile => {
            if (currentMobile.estado && currentMobile.estado.toLowerCase() !== "terminado") ++mobilesQuantity;
            if (currentMobile.estado && currentMobile.estado.toLowerCase() !== "terminado" && 
            currentMobile.estado.toLowerCase() !== "activado") mobileDanger = true;
          });
        if (mobilesQuantity > 0) mobilesText = mobilesQuantity.toString();
      }

      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          icon={mobilesQuantity == 0}
          color={mobilesQuantity > 0 ? (mobileDanger? "danger" : "primary") : "default"}
          size="sm"
          onClick={() => {
            this.showPopUp(AGREGAR_MOVIL);
          }}
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons tech_mobile" /> {mobilesText}
          </div>
        </Button>
      );
    }

    let isSettingInternet = false;
    if (this.state.customer.id in this.props.mainState.settingCustomerInternet) {
      isSettingInternet = this.props.mainState.settingCustomerInternet[this.state.customer.id];
    }
    let internetIcon = "now-ui-icons ";
    if (isSettingInternet) {
      internetIcon = internetIcon + "arrows-1_refresh-69 spin reposition-spin";
    } else {
      internetIcon = internetIcon + "location_world";
    }
    let internetText = "";
    if (!isSettingInternet && customer.internet_activo === "1") {
      try {
        // console.log("this.state.customer tarifa internet -> ", this.state.customer);
        internetText = this.state.customer.internet_tarifa.replace(" (Internet)", "");
        internetText = " " + internetText + " (" + this.state.customer.internet_precio + ")";
      } catch (error) {
        internetText = "Error en la tarifa";
      }
    }

    if (buttons.length > 0) buttons.push("  ");
    buttons.push(
      <Button
        key={"internetButton" + customer.id}
        round
        icon={isSettingInternet || customer.internet_activo !== "1"}
        color={customer.internet_activo === "1" ? "info" : "default"}
        size="sm"
        onClick={() => {
          this.showPopUp(INTERNET);
        }}
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className={internetIcon} />
          {internetText}
        </div>
      </Button>
    );

    let isSettingTV = false;
    if (this.state.customer.id in this.props.mainState.settingCustomerTV) {
      isSettingTV = this.props.mainState.settingCustomerTV[this.state.customer.id];
    }
    let TVIcon = "now-ui-icons ";
    if (isSettingTV || !customer.tv) {
      TVIcon = TVIcon + "arrows-1_refresh-69 spin reposition-spin";
    } else {
      TVIcon = TVIcon + "tech_tv";
    }
    let TVText = "";
    if (!isSettingTV && customer.tv && customer.tv.isActive) {
      try {
        TVText = customer.tv.subscriptions[0].package.title.replace("nadunet TV ", "");//this.state.customer.internet_tarifa.replace(" (Internet)", "");
        TVText = " " + TVText + " (" + this.calculateAndFormatTVPrice(customer.tv.subscriptions[0].package) + ")";// + this.state.customer.internet_precio + ")";
      } catch (error) {
        TVText = "Error en la TV";
      }
    }

    if (buttons.length > 0) buttons.push("  ");
    // console.log("######### CLIENTE TEST ##########");
    // console.log(customer);
    
    // Button TV
    if (!isExterno) {
      buttons.push(
        <Button
          key={"TVButton" + customer.id}
          round
          icon={isSettingTV  || !customer.tv || (customer.tv && !customer.tv.isActive)}
          color={customer.tv && customer.tv.isActive ? "warning" : "default"}
          size="sm"
          onClick={() => {
            this.showPopUp(TV);
          }}
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className={TVIcon} />
            {TVText}
          </div>
        </Button>
      );
    }
    

    let renewalIcon = "now-ui-icons business_money-coins";
    let renewalColor = customer.renovar_activo === "1" ? (this.validateIBAN(customer.cuenta_bancaria) ? "primary" : "warning") : "danger";
    if (renewalColor === "warning" && customer.metodo_pago !== "Domiciliación bancaria") renewalColor = "primary";
    if (buttons.length > 0) buttons.push("  ");
    buttons.push(
      <Button
        key={"renewButton" + customer.id}
        round
        icon
        color={renewalColor}
        size="sm"
        onClick={() => {
          this.switchCustomerRenewal(customer.id, customer.renovar_activo !== "1");
        }}
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className={renewalIcon} />
        </div>
      </Button>
    );

    return buttons;
  }
  createCoverageNetworkButton(mobilePlan) {
    let button = undefined;
    // console.log("mobilePlan", mobilePlan);
    if(mobilePlan) {
      if (mobilePlan.cobertura) {
        if (mobilePlan.cobertura[0]) {
          if (mobilePlan.cobertura[0].nombre.toLowerCase().includes("orange")) {
            button = (
              <Button
                color="warning"
                size="sm"
                /* onClick={e =>
                this.viewOrderArticles(order.numero_pedido, e)
              } */
              >
                {"O"}
              </Button>
            );
          } else {
            button = (
              <Button
                color="info"
                size="sm"
                /* onClick={e =>
                this.viewOrderArticles(order.numero_pedido, e)
              } */
              >
                {"M"}
              </Button>
            );
          }
        }
      }
    } else {
      button = (
        <Button
          color="default"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          {"E"}
        </Button>
      );
    }

    if (!button) {
      button = (
        <Button
          color="default"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          {"E"}
        </Button>
      );
    }

    return button;
  }
  switchCustomerRenewal(customer, isActive) {
    if (!isActive || (this.state.latestValidatedIBAN && this.state.latestValidatedIBAN !== "")) {
      this.props.switchCustomerRenewal(customer, isActive);
    } else {
      this.showPopUpConfirmation(ERROR_ACTIVAR_RENOVACION);
    }
  }
  formatIBAN(iban) {
    try {
      let formattedIban = (iban.replace(/ /g, "").match(/[\s\S]{1,4}/g) || []).join(" ");
      return formattedIban;
    } catch (e) {
      return "";
    }
  }
  openBillStatusPopUpFromBill(order) {
    // console.log("################## OPEN BILL STATUS ################");
    // console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if (payment.includes("Pagada")) {
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if (payment.includes("Procesando")) {
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/ {
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =
      <Button
        color={statusButtonColor}
        size="sm"
        onClick={() => {this.openBillStatusPopUpFromBill(order)}}
      >
        <i className={statusButtonIcon} /> {payment}
      </Button>;

    return statusReady;
  }
  isReturnedBill(order){
    // console.log("is Returned. order: ", order);
    return order.devuelta;
  }
  isPendingBill(order){
    // console.log("is Returned. order: ", order);
    return order.pendiente;
  }
  areReturnedBills() {    
    if(this.props.mainState.ordersLoaded && this.state.customer.id in this.props.mainState.ordersByCustomer && Object.keys(this.props.mainState.ordersByCustomer[this.state.customer.id]).length > 0) { 
      let ordersToDisplay = this.props.mainState.ordersByCustomer[this.state.customer.id];
      let orders_ids = Object.keys(ordersToDisplay);
      for (let i = 0; i < orders_ids.length; i++) {
        const order = ordersToDisplay[orders_ids[i]];
        if(this.isPendingBill(order)) return true;        
      }
      // return ordersToDisplay.some(this.isReturnedBill);
    }
    return false;
  }
  calculateReturnedBills(isHeader) {    
    let total = 0;
    let pendingBills = [];
    let returnedBills = [];
    let result = null;

    if(this.props.mainState.ordersLoaded && this.state.customer.id in this.props.mainState.ordersByCustomer && Object.keys(this.props.mainState.ordersByCustomer[this.state.customer.id]).length > 0) { 
      let ordersToDisplay = this.props.mainState.ordersByCustomer[this.state.customer.id];
      let orders_ids = Object.keys(ordersToDisplay);
      // returnedBills = ordersToDisplay.filter(this.isReturnedBill);
      for (let i = 0; i < orders_ids.length; i++) {
        const order = ordersToDisplay[orders_ids[i]];
        if(this.isPendingBill(order)) pendingBills.push(order);
      }
      // console.log("returnedBills", returnedBills);
      pendingBills.map(bill => {
        let amount = parseInt(bill.remaining_100);
        total += amount;
        if (bill.devuelta) returnedBills.push(bill);
      });
      // console.log("total", (total.toLocaleString("es-ES")));
    }
    let total_100 = total;
    total = parseFloat(total/100).toFixed(2);
    let returnedExpenses = (returnedBills.length * 5).toLocaleString("es-ES") + "€";
    return (
      <Card color={isHeader? "": "danger"} className={"text-center text-white" + (isHeader ? " card-plain" : "")}>
        <CardBody>
          <span>Debe <b>{pendingBills.length}</b> {pendingBills.length > 1 ? "facturas" : "factura"} {returnedBills.length > 0 ? (returnedBills.length > 1 ? ("(" + returnedBills.length + " devueltas)") : "(1 devuelta)") : ""}: <b>{total.toLocaleString("es-ES")}€</b> {returnedBills.length > 0 ? <span>{"("}incluye <b>{returnedExpenses}</b> de gastos{")"}</span> : ""}</span><br />
          {/* <span>En total debe <b>{((total_100)/100).toFixed(2).toLocaleString("es-ES")}€</b>.</span> */}
        </CardBody>
      </Card>
    );
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  getViewArticlesButton(order) {
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  reloadOrder(orderId, orderReloaded) {
    this.props.userData.getOrder(orderId, this.state.customer.id, orderReloaded);
  }
  createBills() {
    let contentToDisplay = null;
    // console.log("ordersToDisplay", this.props.mainState);
    let ordersToDisplay = this.props.mainState.ordersByCustomer && this.props.mainState.ordersByCustomer[this.state.customer.id] ? this.props.mainState.ordersByCustomer[this.state.customer.id] : [];
    
    return <BillsTable bills={ordersToDisplay} userData={this.props.userData} reloadEntityCallback={this.reloadOrder} />;
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);

    if(this.props.mainState.ordersLoaded && ordersToDisplay.length > 0){
      // ordersToDisplay = this.props.mainState.orders.slice(0);
      contentToDisplay = 
        <Table responsive>
          <thead>
            <tr className="text-primary">
              {thead.map((prop, key) => {
                if (prop === "Cliente") return null;
                if (prop === "Devolución") return null;
                if (key === thead.length - 1)
                  return (
                    <th key={key} className="text-center">
                      {prop}
                    </th>
                  );
                return <th key={key} className="text-center">{prop}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {ordersToDisplay.map((order, key) => {

              let currentCustomer = null;
              // let currentCustomerLink = null;
              // if (order.cliente_id in this.props.mainState.customers) {
              //   currentCustomer = this.props.mainState.customers[order.cliente_id][0];
              //   currentCustomerLink = 
              //     <Link to={"/clientes/fichas/".concat(currentCustomer.id)}>
              //       {currentCustomer.nombre_completo} {currentCustomer.primer_apellido} {currentCustomer.segundo_apellido}
              //     </Link>;
              // } else {
              //   //if (!isSearchingCustomer) this.props.searchCustomer();
              //   //isSearchingCustomer = true;
              //   currentCustomerLink =                       
              //     <div className="btns-mr-5">
              //       <Button icon color="default" size="sm">
              //         <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
              //       </Button>
              //     </div>;
              // }
              let overcharge = "";
              if (!Array.isArray(order.fecha_devolucion)) {
                overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              }
              if (!Array.isArray(order.fecha_pago_devolucion)) {
                overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              }
              let remaining = null;
              if (order.remaining_amount && order.remaining_amount !== "") {
                remaining = 
                  <span style={{ 
                    color: "#fb8500", 
                    padding: "3px", 
                    background: "rgba(0,0,0,0.05)", 
                    borderRadius: "2px", 
                    marginLeft: "5px" 
                  }}> debe {order.remaining_amount}</span>
              }
              return (
                <tr key={order.numero_pedido}>
                  <td className="text-center">{order.fecha}</td>
                  {/* <td className="text-center">{currentCustomerLink}</td> */}
                  <td className="text-center">{order.numero_pedido}</td>
                  <td className="text-center">{order.total}{overcharge}{remaining}</td>
                  <td className="text-center">    
                  {this.paymentStatus(order)} 
                  </td>
                  <td className="text-center">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={e =>
                        this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                      }
                    >
                      {this.downloadButton(order.numero_pedido)}
                    </Button>{" "}
                    {this.getViewArticlesButton(order.numero_pedido)}                        
                  </td>
                  {/* order.data.map((prop, key) => {
                    if (key === thead.length - 1)
                      return (
                        <td key={key} className="text-right">
                          {prop}
                        </td>
                      );
                    return <td key={key}>{prop}</td>;
                  }) */}
                </tr>
              );
            })}
          </tbody>
        </Table>;
    } else if(this.props.mainState.ordersLoaded && ordersToDisplay.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay = 
        <Table responsive>
          <tbody>
              {"Todavía no tiene facturas..."}
          </tbody>
        </Table>;
    } else {
      contentToDisplay = 
        <Table responsive>
          <tbody>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
              {"  Cargando facturas..."}
          </tbody>
        </Table>;
    }
    return contentToDisplay;
  }
  createHomeVisits() {
    let contentToDisplay = null;
    let homeVisitsToDisplay = null;
    if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.byCustomer) {
      if (parseInt(this.state.customer.id) in this.props.mainState.homeVisits.byCustomer) { 
        homeVisitsToDisplay = this.props.mainState.homeVisits.byCustomer[parseInt(this.state.customer.id)];  
      }
    }
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if(homeVisitsToDisplay && homeVisitsToDisplay.length > 0){
      homeVisitsToDisplay = homeVisitsToDisplay.slice(0);
      contentToDisplay = 
        <Table responsive>
          <thead>
            <tr className="text-primary">
              {theadhomevisits.map((prop, key) => {
                return <th key={key} className="text-center">{prop}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {homeVisitsToDisplay.map((homeVisit, key) => {
              return (
                <tr key={"homevisit-" + homeVisit.id}>
                  <td className="text-center">{homeVisit.visit_date_day}</td>
                  <td className="text-center">{homeVisit.visit_date_hour}</td>
                  {/* <td className="text-center">{currentCustomerLink}</td> */}
                  <td className="text-center">{homeVisit.title}</td>
                  <td className="text-center">{this.parseVisitType(homeVisit.visit_type.tid, homeVisit.visit_type_name)}</td>
                  <td className="text-center">{this.buildHomeVisitStatus(homeVisit)}</td>
                  <td className="text-center">{homeVisit.visit_locality}</td>
                  <td className="text-center"><Link to={"/citas/" + homeVisit.id}>Ver</Link></td>
                </tr>
              );
            })}
          </tbody>
        </Table>;
    } else if(homeVisitsToDisplay && homeVisitsToDisplay.length == 0) {
      contentToDisplay = 
        <Table responsive>
          <tbody>
              {"Todavía no tiene ninguna cita..."}
          </tbody>
        </Table>;
    } else {
      contentToDisplay = 
        <Table responsive>
          <tbody>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
              {"  Cargando citas..."}
          </tbody>
        </Table>;
    }
    return contentToDisplay;
  }  
  buildTicketPriority(priority) {
    // console.log("state", state);
    let priority_id = parseInt(priority.id);
    let priority_name = priority.name;
    let priority_class = "";
    switch (priority_id) {
      case 110: // Baja
        priority_class = "baja";
        break;
      case 111: // Media
        priority_class = "media";
        break;
      case 112: // Alta
        priority_class = "alta";
        break;
      default:
        break;
    }

    let result = [];
    result.push(
      <div key={"circle-prio-" + priority.id} className={"circle-priority priority-" + priority_name.toLowerCase()}></div>
    );
    result.push(
      <span className={"priority" + " prio-" + priority_class} key={"priority-" + priority.id}>
        {priority_name}
      </span>
    );

    return result;
  }
  buildTicketDepartment(department) {
    // console.log("department", department);
    if (!department || !department.id) return;
    let department_id = parseInt(department.id);
    let department_name = department.name;
    let department_class = "";
    let department_icon = "";
    switch (department_id) {
      case 109: // Facturacion
        department_class = "facturacion";
        department_icon = "business_money-coins";
        break;
      case 120: // Marketing
        department_class = "marketing";
        department_icon = "shopping_bag-16";
        break;
      case 307: // Programación
        department_class = "programacion";
        department_icon = "education_glasses";
        break;
      case 108: // Técnico
        department_class = "tecnico";
        department_icon = "objects_support-17";
        break;
      case 308: // Redes
        department_class = "redes";
        department_icon = "media-2_sound-wave";
        break;
      case 306: // Sistemas
        department_class = "sistemas";
        department_icon = "location_world";
        break;
      default:
        break;
    }

    return (
      <span className={"ticket-department dep-" + department_class}>
        <i className={"ticket-department-icon now-ui-icons " + department_icon} />
        {department_name}
      </span>
    );
  }
  buildTicketState(state) {
    // console.log("state", state);
    let state_id = parseInt(state.id);
    let state_name = state.name;
    let state_class = "";
    switch (state_id) {
      case 117: // Abierto
        state_class = "abierto";
        break;
      case 118: // Cerrado
        state_class = "cerrado";
        break;
      case 300: // Esperando respuesta
        state_class = "esperando";
        break;
      case 299: // Pendiente
        state_class = "pendiente";
        break;
      case 321: // Esperando respuesta
        state_class = "esperando";
        break;
      case 322: // Pendiente
        state_class = "pendiente";
        break;
      default:
        return null;
    }
    let result = [];
    result.push(
      <div key={"circle"} className={"circle-state state-" + state_class}></div>
    );
    result.push(
      <span key={"state"} className={"ticket-state state-" + state_class}>
        {state_name}
      </span>
    );

    return result;
  }
  buildTicketCategory(category) {
    // console.log("category", category);
    let category_id = parseInt(category.id);
    let category_name = category.name;
    let category_class = "";
    let category_icon = "";
    switch (category_id) {
      case 106: // Consulta
        category_class = "consulta";
        category_icon = "business_bulb-63";
        break;
      case 107: // Incidencia
        category_class = "incidencia";
        category_icon = "health_ambulance";
        break;
      case 309: // Soporte
        category_class = "soporte";
        category_icon = "emoticons_satisfied";
        break;
      default:
        break;
    }

    return (
      <span className={"ticket-category cat-" + category_class}>
        <i className={"ticket-category-icon now-ui-icons " + category_icon} />
        {category_name}
      </span>
    );
  }
  buildTicketAgent(agent) {
    let result = null;

    if (agent === null) {
      result = (
        <Col className="text-center">
          <div style={{padding:"10px"}}>Sin asignar</div>
        </Col>
      );
    } else {
      result = (
        <div className="ticket-customer">
          <img className="ticket-customer-picture" src={agent.picture} alt={agent.name} />
          <span className="ticket-customer-name">{agent.name}</span>
        </div>
      );
    }

    return result;
  }
  createTickets() {
    let contentToDisplay = null;
    let ticketsToDisplay = null;
    if (this.props.mainState.customersTickets) {
      if (parseInt(this.state.customer.id) in this.props.mainState.customersTickets) {
        ticketsToDisplay = Object.keys(this.props.mainState.customersTickets[parseInt(this.state.customer.id)]);  
      }
    }

    if (ticketsToDisplay && ticketsToDisplay.length > 0) {
      ticketsToDisplay = ticketsToDisplay.slice(0);
      contentToDisplay = 
        <Table responsive>
          <thead>
            <tr className="text-primary">
              {theadtickets.map((prop, key) => {
                return <th key={key} className="text-left">{prop}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {ticketsToDisplay.map((ticket, key) => {
              ticket = this.props.mainState.customersTickets[parseInt(this.state.customer.id)][ticket];
              let substate = this.buildTicketState(ticket.substate);
              if (substate) substate = (
                <span>
                {substate} <br />
                </span>
              );
              // console.log("current ticket", ticket);
              return (
                <tr key={"ticket-" + ticket.id}>
                  <td className="text-center">{this.buildTicketPriority(ticket.priority)}</td>
                  <td className="text-center">{ticket.reference}</td>
                  {/* <td className="text-center">{currentCustomerLink}</td> */}
                  <td className="text-center">{ticket.title}</td>
                  <td className="text-center">{this.buildTicketDepartment(ticket.department)}<br />
                    <div className="wrapper-ticket-category">{this.buildTicketCategory(ticket.category)}</div>
                  </td>
                  <td className="text-center">
                    {this.buildTicketState(ticket.state)}<br />
                    {substate}
                    <span className="ticket-summup-date">{moment(ticket.last_comment).fromNow()}</span>
                  </td>
                  <td className="text-center">{this.buildTicketAgent(ticket.agent)}</td>
                  <td className="text-center">
                    <Button 
                      size="sm"
                      round 
                      color="primary"
                      onClick={e => this.redirectTo("/tickets/" + ticket.id)}
                      >
                      <i className="now-ui-icons education_glasses" /> Ver
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>;
    } else if(ticketsToDisplay && ticketsToDisplay.length == 0) {
      contentToDisplay = 
        <Table responsive>
          <tbody>
              {"Todavía no tiene ninguna cita..."}
          </tbody>
        </Table>;
    } else {
      contentToDisplay = 
        <Table responsive>
          <tbody>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
              {"  Cargando citas..."}
          </tbody>
        </Table>;
    }
    return contentToDisplay;
  }
  toggleTrafficChart(id) {
    let showTrafficChart = this.state.showTrafficChart;
    if (showTrafficChart === id) {
      this.setState({ showTrafficChart: null });
    } else {
      this.setState({ showTrafficChart: id });
    }
  }
  createTrafficChart(traffic) {
    try {
      let data = [];
      traffic.map(current => {
        data.push({
          downloadString: current.download.string,
          uploadString: current.upload.string,
          Descarga: current.download.bitrate,
          Subida: current.upload.bitrate,
          date: current.date
        }); 
      });
      if(data && data.length < 60) {
        data = [...Array(60-data.length), ...data   ] //[undefined,undefined,1,2]
        // data = [ ...data, ...Array(60-data.length)] //[1,2,undefined,undefined]
      }
      if(data && data.length > 60) {
        // Get last 60 elements
        data = data.slice(-60);
      }

      
      return (<div style={{ width: '100%', height: 120 }}>
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid />
            <XAxis dataKey="downloadString" />
            {/* <XAxis dataKey="uploadString" /> */}
            {/* <YAxis /> */}
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" isAnimationActive={false} dataKey="Descarga" stroke={"#00B081"} fill={"#59C096"} />
            <Area type="monotone" isAnimationActive={false} dataKey="Subida" stroke={"#949494"} fill={"#a3a3a3"} />
            <Legend verticalAlign="top" height={18}/>
          </AreaChart>
        </ResponsiveContainer>
      </div>);
    } catch (error) {
      return null;
    }
  }
  createSecrets() {
    // console.log("this.props.mainState", this.props.mainState);
    let contentToDisplay = null;
    let secretsToDisplay = null;
    if (this.props.mainState.secrets) {
      if (this.props.match.params.customerID in this.props.mainState.secrets) {
        secretsToDisplay = this.props.mainState.secrets[this.props.match.params.customerID];  
      }
    }

    if (secretsToDisplay && secretsToDisplay.length > 0) {
      // console.log("secretsToDisplay", secretsToDisplay);
      // secretsToDisplay = secretsToDisplay.slice(0);
      contentToDisplay = 
        <Table responsive>
          <thead>
            <tr className="text-primary">
              {/* {Object.keys(secretsToDisplay[0]).map((prop, key) => {
                return <th key={key} className="text-left">{prop}</th>;
              })} */}
              <th>Usuario</th>
              <th>Contraseña</th>
              <th>Tarifa</th>
              <th>IP</th>
              {/* <th>Activo</th> */}
              <th>Logout</th>
              <th>Router</th>
              <th>Comentario</th>
            </tr>
          </thead>
          <tbody>
            {secretsToDisplay.map((secret, key) => {
              let secretColor = "#000";
              if(!secret.disabled && secret.connected) secretColor = "#46B98A";
              if(!secret.disabled && !secret.connected) secretColor = "#ffb142";
              if(secret.disabled && !secret.connected) secretColor = "#aaa69d";
              if(secret.disabled && secret.connected) secretColor = "#ff5252";
              let traffic = null;
              let trafficDownloadChart = null;
              let trafficUploadChart = null;
              if(secret.connected) {
                if(secret.traffic && secret.traffic.length > 0) {
                  // Cogemos el último registro
                  let rawTraffic = secret.traffic[secret.traffic.length - 1];
                  let showTrafficChartClass = "open-chart";
                  let openChartIcon = "arrows-1_minimal-down";
                  if (this.state.showTrafficChart === secret[".id"]){
                    trafficDownloadChart = this.createTrafficChart(secret.traffic);
                    showTrafficChartClass = "close-chart";
                    openChartIcon = "ui-1_simple-remove";
                  }
                  // trafficUploadChart = this.createTrafficChart(secret.traffic, "upload");
                  traffic = (
                    <div>
                      <br />
                      <div className="connection-traffic">
                        <span
                          onClick={() => this.toggleTrafficChart(secret['.id'])}
                          className={"traffic toggle-chart " + showTrafficChartClass}>
                            <i className="now-ui-icons business_chart-bar-32" />{" "}
                            <i className={"now-ui-icons " + openChartIcon} />
                        </span>
                        <span className="traffic download">▼{rawTraffic.download.string}</span>
                        <span className="traffic upload">▲{rawTraffic.upload.string}</span>
                      </div>
                      <br />
                    </div>
                  );
                }
              } else {
                if(secret.disabled) {
                  traffic = (
                    <div>
                      <br />
                      <div className="connection-traffic">
                        <span className="traffic upload">Desactivado</span>
                      </div>
                    </div>
                  );
                } else {
                  traffic = (
                    <div>
                      <br />
                      <div className="connection-traffic">
                        <span className="traffic upload">Desconectado</span>
                      </div>
                    </div>
                  );
                }
              }
              // if (trafficChart) trafficChart = <td>{trafficChart}</td>;
              let localResult = [];
              let secretInfo = (
                <tr key={"secret-" + secret['.id'] + "-" + secret.name}>
                  <td style={{color: secretColor}}><b>{secret.name}</b>{traffic}</td>
                  <td>{secret.password}</td>
                  <td>{secret.profile}</td>
                  <td>{secret['remote-address']}</td>
                  {/* <td>{secret['disabled'] !== "true" ? "Sí" : "No"}</td> */}
                  <td>{secret['last-logged-out'].includes("jan/01/1970") ? "Nunca" : secret['last-logged-out']}</td>
                  <td>{secret.router.name}</td>
                  <td>{secret.comment}</td>
                </tr>
              );
              localResult[0] = secretInfo;
              if (trafficDownloadChart){ 
                localResult[localResult.length] =(
                  <tr key={"secret-" + secret['.id'] + "-" + secret.name + "-trafficDownloadChart"}>
                    <td colSpan="6">
                      {trafficDownloadChart}
                    </td>
                  </tr>
                );
              }
              if (trafficUploadChart){ 
                localResult[localResult.length] =(
                  <tr key={"secret-" + secret['.id'] + "-" + secret.name + "-trafficUploadChart"}>
                    <td colSpan="6">
                      {trafficUploadChart}
                    </td>
                  </tr>
                );
              }
              return localResult;
              // ticket = this.props.mainState.customersTickets[parseInt(this.state.customer.id)][ticket];
              // let substate = this.buildTicketState(ticket.substate);
              // if (substate) substate = (
              //   <span>
              //   {substate} <br />
              //   </span>
              // );
              // console.log("current ticket", ticket);
              // return (
              //   <tr key={"secret-" + secret['.id'] + "-" + secret['name']}>
              //     {Object.keys(secret).map((prop, key) => {
              //       return <td key={key} className="text-left">{secret[prop]}</td>;
              //     })}
              //   </tr>
              // );
            })}
          </tbody>
        </Table>;
    } else if(secretsToDisplay && secretsToDisplay.length == 0) {
      contentToDisplay = 
        <Table responsive>
          <tbody>
              {"No se han obtenido resultados..."}
          </tbody>
        </Table>;
    } else {
      if (this.props.mainState.isSearchingCustomerSecret) {
        contentToDisplay = 
          <Table responsive>
            <tbody>
              <i className="now-ui-icons arrows-1_refresh-69 spin" />
                {"  Buscando secret..."}
            </tbody>
          </Table>;
      } else {
        contentToDisplay = 
          <Table responsive>
            <tbody>
                Pulsa sobre <b>Buscar secret</b>
            </tbody>
          </Table>;
      }
    }
    return contentToDisplay;
  }
  getSecretsTraffic() {  
    // console.log("getSecretsTraffic",this.props.match.params.customerID);
    this.props.getSecretsTraffic(this.props.match.params.customerID);  
    // let secretsToDisplay = null;
    // if (this.props.mainState.secrets) {
    //   if (this.props.match.params.customerID in this.props.mainState.secrets) {
    //     secretsToDisplay = this.props.mainState.secrets[this.props.match.params.customerID];
    //     this.props.getSecretsTraffic(this.props.match.params.customerID);
    //   }
    // }
  }
  buildCommunicationType(name, type) {
    type = parseInt(type);
    let result = {
      color: "info",
      text: name,
    }
    let style = {
      padding: "5px 10px",
      color: "#FFF",
      borderRadius: "2px"
    };
    switch (type) {
      case 265: // Email
        result.color = "info";
        break;
      case 266: // Call
        result.color = "primary";
        break;
      case 264: // SMS
        result.color = "warning";
        break;
      case 267: // Visit
        result.color = "default";
        break;    
      default:
        break;
    }
    return (
      <span className={"bg-" + result.color} style={style}>
        {result.text}
      </span>
    );
  }
  createCommunicationTitleHeader(type) {
    type = parseInt(type);
    switch (type) {
      case 265:
        return "Contenido del email";
      case 266:
        return "Descripción de la llamada";
      case 264:
        return "Contenido del SMS";
      case 267:
        return "Explicación de la visita";
      default:
        return "Contenido de la comunicación";
        break;
    }
  }
  buildCommunicationContent(content, type, author) {
    let aux = null;
    type = parseInt(type);
    try{
      aux = JSON.parse(content);
      console.log("aux email JSON", aux);
      switch (type) {
        case 265: // Email
          return (
            <div>
              <b>Autor: </b> {author}<br />
              <b>Asunto: </b> {aux.subject}<br />
              <b>Remitente: </b> {aux.from.name} ({aux.from.email})<br />
              <b>Responder a: </b> {aux.reply_to} <br />
              <b>Mensaje:</b><br />
              <div dangerouslySetInnerHTML={{ __html: aux.message }} />
            </div>
          );
        case 266: // Call
          return (
            <div>
              <b>Autor: </b> {author}<br />
              <b>Teléfono: </b> {aux.mobile}<br />
              <b>Descripción:</b><br />
              <div dangerouslySetInnerHTML={{ __html: aux.body }} />
            </div>
          );
        case 264: // SMS
          return (
            <div>
              <b>Autor: </b> {author}<br />
              <b>Teléfono: </b> {aux.mobile}<br />
              <b>Descripción:</b><br />
              <div dangerouslySetInnerHTML={{ __html: aux.body }} />
            </div>
          );
        case 267: // Visit
          return (
            <div>
              <b>Autor: </b> {author}<br />
              <b>Motivo: </b> {aux.reason}<br />
              <b>Descripción:</b><br />
              <div dangerouslySetInnerHTML={{ __html: aux.body }} />
            </div>
          );  
        default:
          return (
            "Error al cargar el contenido de la comunicación"
          );  
          break;
      }
    } catch (ex) {
      aux = content;
      return <div dangerouslySetInnerHTML={{ __html: content }} />
    }
  }
  createCommunications() {
    let contentToDisplay = null;
    let communicationsToDisplay = null;
    if (this.props.mainState.customersCommunications && this.props.mainState.customersCommunications.length > 0) {
      if (this.state.customer.id in this.props.mainState.customersCommunications) { 
        communicationsToDisplay = this.props.mainState.customersCommunications[this.state.customer.id];  
      }
    }
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if(communicationsToDisplay && communicationsToDisplay.length > 0){
      communicationsToDisplay = communicationsToDisplay.slice(0);
      let isFirst = true;
      contentToDisplay = 
        <Table responsive>
          <tbody>
            {communicationsToDisplay.map((customerCommunication, key) => {
              let isViewingContent = this.state.showCommunicationBody === customerCommunication.id;
              let currentCommunication = [];
              let tableStyle = {};
              if (isViewingContent) tableStyle= { background: "#f7f7f7", width: "100%" };
              currentCommunication.push(
                <table width="100%" style={tableStyle} key={"customerCommunication-" + customerCommunication.id}>
                  {isFirst && <thead>
                    <tr className="text-primary">
                      {theadcustomerscommunications.map((prop, key) => {
                        if (prop === "Ver") return <th key={key} className="text-right">{prop}</th>;
                        return <th key={key} className="text-left">{prop}</th>;
                      })}
                    </tr>
                  </thead>}
                  <tbody>
                    <tr>
                      <td className="text-left date-td">{customerCommunication.date}</td>
                      <td className="text-left comm-type">{this.buildCommunicationType(customerCommunication.type_name, customerCommunication.type_id)}</td>
                      <td className="text-left comm-title">{customerCommunication.title}</td>
                      <td className="text-right" style={{ padding: "5px" }}>
                        <Button
                          // style={{marginTop: "25px", marginLeft: "-20px"}}
                          round
                          icon
                          key={"viewCommunicationBody"}
                          color={isViewingContent ? "default" : "primary"}
                          onClick={() => {
                            if (isViewingContent) {
                              this.setState({ showCommunicationBody: null });
                            } else {
                              this.setState({ showCommunicationBody: customerCommunication.id });
                            }
                          }}
                          leftLabel={"now-ui-icons " + (isViewingContent? "ui-1_simple-remove" : "ui-2_chat-round")}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              );
              if (isViewingContent) {
                currentCommunication.push(
                  <table width="100%" style={tableStyle} key={"customerCommunication-body-" + customerCommunication.id}>
                    <thead style={{ background: "#efefef", textAlign: "center" }}>
                      <tr><th style={{ border: "none" }}>{this.createCommunicationTitleHeader(customerCommunication.type_id)}</th></tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="100%" className="text-left">{this.buildCommunicationContent(customerCommunication.body, customerCommunication.type_id, customerCommunication.author)}</td>
                      </tr>
                    </tbody>
                  </table>
                );
              }
              isFirst = false;
              return currentCommunication;
            })}
          </tbody>
        </Table>;
    } else if(communicationsToDisplay && communicationsToDisplay.length == 0) {
      contentToDisplay = 
        <Table responsive>
          <tbody>
              {"Todavía no tiene ninguna comunicación..."}
          </tbody>
        </Table>;
    } else {
      contentToDisplay = 
        <Table responsive>
          <tbody>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
              {"  Cargando citas..."}
          </tbody>
        </Table>;
    }
    return contentToDisplay;
  }
  parseVisitType(type, name) {
    let result = null;
    let resultText = "";
    let resultStyle = "";
    type = parseInt(type);
    switch (type) {
      case 243:
        resultText = "Instalación WiFi";
        resultStyle = "btn-primary";
        break;
      case 244:
        resultText = "Incidencia";
        resultStyle = "btn-danger";
        break;
      case 245:
        resultText = "Configuración";
        resultStyle = "btn-info";
        break;
      case 246:
        resultText = "Servicio extra";
        resultStyle = "btn-info";
        break;
      case 256:
        resultText = "Instalación fibra";
        resultStyle = "btn-warning";
        break;
      default:
        resultText = "Error en el tipo";
        resultStyle = "btn-default";
        break;
    }
    resultStyle += " btn-sm btn-round btn";

    result = <span className={resultStyle}>{name}</span>;

    return result;
  }
  buildHomeVisitStatus(homeVisit) {
    let style = {
      padding: "5px 10px",
      borderRadius: "2px",
      margin: "0px 10px 0px 5px"
    };
    let durationStyle = {
      padding: "5px 10px",
      borderRadius: "2px",
      margin: "0px 10px 0px 5px",
      background: "rgba(0,0,0,0.1)",
      color: "#000"
    };
    let visit_state = null;
    if (homeVisit && homeVisit.visit_status) {
      switch (parseInt(homeVisit.visit_status.tid)) {
        // Cancelada
        case 250:
          visit_state = {
            text: homeVisit.visit_status_name,
            color: "danger",
            icon: "ui-1_simple-remove"
          };
          break;
          // Esperando
        case 247:
          visit_state = {
            text: homeVisit.visit_status_name,
            color: "info",
            icon: "ui-2_time-alarm"
          };
          break;
          // En proceso
        case 248:
          visit_state = {
            text: homeVisit.visit_status_name,
            color: "warning",
            icon: "loader_gear spin"
          };
          if (!homeVisit.start_date) {
            visit_state.duration = "Error en la duración";
          } else {
            let start = moment(homeVisit.start_date, "DD/MM/YYYY HH:mm:ss");
            let end = moment();
            let durationd = end.diff(start, "days");
            let durationh = end.diff(start, "hours") - durationd*24;
            let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
            let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
            durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
            durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
            durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
            durations = durations === 0? "" : durations + (durations > 1 ? " segs " : " seg ");
            durations = "";
            let duration = (durationd + durationh + durationm + durations);
            // console.log("######## DURATION ############");
            // console.log(durationh + durationm + durations);

            visit_state.duration = (
              <span style={durationStyle}>
                <i className={"now-ui-icons ui-2_time-alarm"} />
                {" "}{duration}
              </span>
            );
          }
          break;
          // Finalizada
        case 249:
          visit_state = {
            text: homeVisit.visit_status_name,
            color: "primary",
            icon: "ui-1_check"
          };
          if (!homeVisit.start_date) {
            visit_state.duration = "Error en la duración";
          } else {
            let start = moment(homeVisit.start_date, "DD/MM/YYYY HH:mm:ss");
            let end = moment(homeVisit.end_date, "DD/MM/YYYY HH:mm:ss");
            let durationd = end.diff(start, "days");
            let durationh = end.diff(start, "hours") - durationd*24;
            let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
            let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
            durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
            durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
            durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
            durations = durations === 0? "" : durations + (durations > 1 ? " segs" : " seg");
            let duration = (durationd + durationh + durationm + durations);
            // console.log("######## DURATION ############");
            // console.log(durationh + durationm + durations);

            visit_state.duration = (
              <span style={durationStyle}>
                <i className={"now-ui-icons ui-2_time-alarm"} />
                {" "}{duration}
              </span>
            );
          }
          break;
        default:
          visit_state = {
            text: "No se pudo cargar el estado",
            color: "default",
            icon: "ui-1_simple-remove"
          };
          break;
      }
      return (
        <div>
          <span style={style} className={"bg-" + visit_state.color}>
            <i className={"now-ui-icons " + visit_state.icon} />
            {" "}{visit_state.text}
          </span>
          {visit_state.duration}
        </div>
      );
    }
    return null;
  }
  isCompany() {
    let result = false;
    
    // if (this.state.customer.tipo_cliente && parseInt(this.state.customer.tipo_cliente.tid) === 90) 
    //   result = true;
    if (this.state.customerType && parseInt(this.state.customerType.value) === 90) 
      result = true;


    return result;

  }
  // Render user profile data to edit
  devUser() {
    // if (parseInt(this.props.mainState.user.uid) !== 469) return null;
    // let currentCustomer = this.props.mainState.customers[
    //   this.props.match.params.customerID
    // ][0];
    let currentCustomer = this.state.customer;
    let formattedNumber = "";
    if (currentCustomer.phone) {
      formattedNumber = currentCustomer.phone;
        // currentCustomer.phone.substring(0, 3) +
        // " " +
        // currentCustomer.phone.substring(3, 6) +
        // " " +
        // currentCustomer.phone.substring(6, 9);
    }
    let actionButtons = null;
    if (this.areUserChangesToSave(currentCustomer)) {
      actionButtons = 
        <Row className="text-right" style={{marginTop: "14px", alignItems: 'flex-end'}}>
          <Col xs="auto">
            <Button
              // style={{marginTop: "25px", marginLeft: "-20px"}}
              round
              disabled={this.props.mainState.isEditingCustomer}
              key={"saveCustomerChanges"}
              color="primary"
              onClick={() => {
                this.editCustomer();
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isEditingCustomer? "arrows-1_refresh-69 spin" : "ui-1_check")}
            >
              Guardar
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              // style={{marginTop: "25px", marginLeft: "-20px"}}
              icon
              round
              key={"discardCustomerChanges"}
              color="default"
              onClick={() => {
                this.discardUserChanges();
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingMobileProcedure? "arrows-1_refresh-69 spin" : "ui-1_simple-remove")}
            >
            </Button>
          </Col>
        </Row>;
    }
    let isAdmin = false;
    switch (parseInt(this.props.mainState.user.uid)) {
      case 1:
        isAdmin = true;
        break;
      case 469:
        isAdmin = true;
        break;
      case 118060:
        isAdmin = true;
        break;
    
      default:
        break;
    }
    let managerData = null;
    if (this.isCompany()) {
      managerData =        
        <Row className="justify-content-center">
          <Col xs={12} sm="12" className="text-center">
            <h5 className="info-text">Datos del gerente</h5>
          </Col>
          <Col xs={12} md={3}>
            <Label>DNI/NIF</Label>
            <FormGroup className={this.state.fieldStates["nif_gerente"]}>
              <Input
                // disabled={!isAdmin}
                type="text"
                placeholder="1234578A"
                value={this.state.nif_manager !== null ? this.state.nif_manager : currentCustomer.nif_manager}
                onChange={event => {
                  let newValue = event.target.value;
                  this.setState({ nif_manager: newValue });
                  this.validateField("nif_manager", newValue);
                }}
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={3}>
            <Label>Nombre</Label>
            <FormGroup className={this.state.fieldStates["nombre_manager"]}>
              <Input
                type="text"
                placeholder="Fulanito"
                value={this.state.nombre_manager !== null ? this.state.nombre_manager : currentCustomer.nombre_manager}
                onChange={event => {
                  let newValue = event.target.value;
                  this.setState({ nombre_manager: newValue });
                  this.validateField("nombre_manager", newValue);
                }}
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={3}>
            <Label>Primer apellido</Label>
            <FormGroup className={this.state.fieldStates["primer_apellido_manager"]}>
              <Input
                placeholder="Apellido 1"
                type="text"
                value={this.state.primer_apellido_manager !== null ? this.state.primer_apellido_manager : currentCustomer.primer_apellido_manager}
                onChange={event => {
                  let newValue = event.target.value;
                  this.setState({ primer_apellido_manager: newValue });
                  this.validateField("primer_apellido_manager", newValue);
                }}
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={3}>
                <Label>Segundo apellido</Label>
                <FormGroup className={this.state.fieldStates["segundo_apellido_manager"]}>
                  <Input
                    placeholder="Apellido 2"
                    type="text"
                    value={this.state.segundo_apellido_manager !== null ? this.state.segundo_apellido_manager : currentCustomer.segundo_apellido_manager}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ segundo_apellido_manager: newValue });
                      this.validateField("segundo_apellido_manager", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
        </Row>;
    }
    return (
      <Card>
        <CardHeader>
          <h5 className="title">
            Perfil del cliente
            {" "}
            {this.createServicesButtons(this.state.customer)}
          </h5>
        </CardHeader>
        <CardBody>
          <form>
            <Row>
              <Col xs={12} md={4}>
                <Label>Tipo de cliente</Label>
                <FormGroup>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Elige una opción"
                    name="customerType"
                    value={this.state.customerType}
                    options={customerType}
                    onChange={value =>
                      this.setState({ customerType: value })
                    }
                  />
                  <br></br>
                </FormGroup>
              </Col>
              <Col xs={12} md={4}>
                <Label>Tipo de documento</Label>
                <FormGroup>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Elige una opción"
                    name="documentType"
                    value={this.state.documentType}
                    options={documentType}
                    onChange={value =>
                      this.setState({ documentType: value })
                    }
                  />
                  <br></br>
                </FormGroup>
              </Col>
              <Col xs={12} md={4} className="text-right">
                {actionButtons}
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Label>DNI/NIF</Label>
                <FormGroup className={this.state.fieldStates["nif"]}>
                  <Input
                    disabled={!isAdmin}
                    type="text"
                    placeholder="1234578A"
                    value={this.state.nif ? this.state.nif : (currentCustomer.nif || "")}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ nif: newValue });
                      this.validateField("nif", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={4}>
                <Label>Móvil</Label>
                <FormGroup className={this.state.fieldStates["movil"]}>
                  <Input
                    placeholder="666666666"
                    type="text"
                    value={this.state.movil !== null ? this.state.movil : formattedNumber}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ movil: newValue });
                      this.validateField("movil", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={4}>
                <Label>Email</Label>
                <FormGroup className={this.state.fieldStates["email"]}>
                  <Input
                    placeholder="fulanito@menganito.es"
                    type="text"
                    value={this.state.email !== null ? this.state.email : currentCustomer.email}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ email: newValue });
                      this.validateField("email", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={this.isCompany() ? 12 : 4}>
                  <Label>{this.isCompany() ? "Denominación social" : "Nombre"}</Label>
                <FormGroup className={this.state.fieldStates["nombre"]}>
                  <Input
                    type="text"
                    placeholder="Fulanito"
                    value={this.state.nombre !== null ? this.state.nombre : currentCustomer.nombre_completo}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ nombre: newValue });
                      this.validateField("nombre", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              {!this.isCompany() && <Col xs={12} md={4}>
                <Label>Primer apellido</Label>
                <FormGroup className={this.state.fieldStates["primer_apellido"]}>
                  <Input
                    placeholder="Apellido 1"
                    type="text"
                    value={this.state.primer_apellido !== null ? this.state.primer_apellido : currentCustomer.primer_apellido}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ primer_apellido: newValue });
                      this.validateField("primer_apellido", newValue);
                    }}
                  />
                </FormGroup>
              </Col>}
              {!this.isCompany() && <Col xs={12} md={4}>
                <Label>Segundo apellido</Label>
                <FormGroup className={this.state.fieldStates["segundo_apellido"]}>
                  <Input
                    placeholder="Apellido 2"
                    type="text"
                    value={this.state.segundo_apellido !== null ? this.state.segundo_apellido : currentCustomer.segundo_apellido}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ segundo_apellido: newValue });
                      this.validateField("segundo_apellido", newValue);
                    }}
                  />
                </FormGroup>
              </Col>}
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Label>Dirección</Label>
                <FormGroup className={this.state.fieldStates["direccion"]}>
                  <Input
                    placeholder="Calle Manolito 123"
                    type="text"
                    value={this.state.direccion !== null ? this.state.direccion.replace("&#039;", "'") : currentCustomer.domicilio.replace("&#039;", "'")}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ direccion: newValue });
                      this.validateField("direccion", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={4}>
                <Label>Localidad</Label>
                <FormGroup className={this.state.fieldStates["localidad"]}>
                  <Input
                    placeholder="Tarancón"
                    type="text"
                    value={this.state.localidad !== null ? this.state.localidad : currentCustomer.localidad}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ localidad: newValue });
                      this.validateField("localidad", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={4}>
                <Label>Código postal</Label>
                <FormGroup className={this.state.fieldStates["codigo_postal"]}>
                  <Input
                    placeholder="123456"
                    type="number"
                    value={this.state.codigo_postal !== null ? this.state.codigo_postal : currentCustomer.codigo_postal}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ codigo_postal: newValue });
                      this.validateField("codigo_postal", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Label>Cuenta bancaria (IBAN)</Label>
                <FormGroup className={this.state.fieldStates["iban"]}>
                  <Input
                    type="text"
                    value={this.state.iban}
                    onChange={event => {
                      try {
                        const caret = event.target.selectionStart;
                        const element = event.target;
                        const realCaret = this.formatIBAN(event.target.value.substring(0,caret)).length;
                        window.requestAnimationFrame(() => {  
                          element.selectionStart = realCaret;
                          element.selectionEnd = realCaret;
                        });
                      } catch(e) {}

                      let newIBAN = this.formatIBAN(event.target.value);
                      this.setState({ iban: newIBAN });
                      this.validateField("iban", newIBAN);
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            {/*<FormInputs
              ncols={["col-md-12"]}
              proprieties={[
                {
                  label: "About Me",
                  inputProps: {
                    type: "textarea",
                    rows: "4",
                    cols: "80",
                    defaultValue:
                      "Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.",
                    placeholder: "Here can be your description"
                  }
                }
              ]}
            />*/}
            {managerData}
          </form>
        </CardBody>
      </Card>);
  }
  getExtraExpensesCount() {
    let result = null;

    if (this.state.customer.id in this.props.mainState.customerExtraExpenses) {
      let customerExtraExpenses = this.props.mainState.customerExtraExpenses[this.state.customer.id];
      if (!customerExtraExpenses) customerExtraExpenses = [];
      if (customerExtraExpenses.length > 0) {
        result = <span style={countStyle}>{customerExtraExpenses.length}</span>;
      }
    }
    return result;
  }
  getBillsCount() {
    let result = null;
    // let ordersToDisplay = [];
    let ordersToDisplay = this.props.mainState.ordersByCustomer && this.props.mainState.ordersByCustomer[this.state.customer.id] ? Object.keys(this.props.mainState.ordersByCustomer[this.state.customer.id]) : [];
    
    // // console.log("ordersLoaded", this.props.mainState.ordersLoaded);
    // // console.log("orders", this.props.mainState.orders);
    // if(this.props.mainState.ordersLoaded && this.state.customer.id in this.props.mainState.ordersByCustomer && this.props.mainState.ordersByCustomer[this.state.customer.id].length > 0) { 
    //   // const groupByID = groupBy('cliente_id');
    //   ordersToDisplay = this.props.mainState.ordersByCustomer[this.state.customer.id];
    // }

    if(ordersToDisplay && ordersToDisplay.length > 0) {
        result = <span style={countStyle}>{ordersToDisplay.length}</span>;
    }
    return result;
  }
  getCommunicationsCount() {
    let result = null;
    let communicationsToDisplay = null;
    if (this.props.mainState.customersCommunications && this.props.mainState.customersCommunications.length > 0) {
      if (this.state.customer.id in this.props.mainState.customersCommunications) { 
        communicationsToDisplay = this.props.mainState.customersCommunications[this.state.customer.id];  
      }
    }

    if (communicationsToDisplay && communicationsToDisplay.length > 0) {
        result = <span style={countStyle}>{communicationsToDisplay.length}</span>;
    }
    return result;
  }
  getTicketsCount() {
    let result = null;
    let ticketsToDisplay = null;
    if (this.props.mainState.customersTickets) {
      if (parseInt(this.state.customer.id) in this.props.mainState.customersTickets) {
        ticketsToDisplay = Object.keys(this.props.mainState.customersTickets[parseInt(this.state.customer.id)]);  
      }
    }

    if (ticketsToDisplay && ticketsToDisplay.length > 0) {
        result = <span style={countStyle}>{ticketsToDisplay.length}</span>;
    }
    return result;
  }
  getHomeVisitsCount() {
    let result = null;

    let homeVisitsToDisplay = null;
    if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.byCustomer) {
      if (parseInt(this.state.customer.id) in this.props.mainState.homeVisits.byCustomer) { 
        homeVisitsToDisplay = this.props.mainState.homeVisits.byCustomer[parseInt(this.state.customer.id)];  
      }
    }
    
    if(homeVisitsToDisplay && homeVisitsToDisplay.length > 0){
        result = <span style={countStyle}>{homeVisitsToDisplay.length}</span>;
    }
    return result;
  }
  getMobilesCount() {
    let result = null;
    if (this.props.mainState.customersMobilesLoaded) {
      let mobilesQuantity = 0;
      let mobileDanger = false;
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = 0;
        this.props.mainState.customersMobiles[this.state.customer.id]
          .map(currentMobile => {
            if(currentMobile.estado) {
              if (currentMobile.estado.toLowerCase() !== "terminado") ++mobilesQuantity;
              if (currentMobile.estado.toLowerCase() !== "terminado" && 
              currentMobile.estado.toLowerCase() !== "activado") mobileDanger = true;
            }
          });
        let localStyle = JSON.parse(JSON.stringify(countStyle));
        if (mobileDanger) localStyle.background = "rgba(255,0,0,0.25)";
        if (mobilesQuantity > 0) result = <span style={localStyle}>{mobilesQuantity}</span>;       
      }
    }
    return result;
  }
  getTvCount() {
    let result = null;
    let customer = this.state.customer;
    let subscriptionsQuantity = 0;
    
    if (customer.tv && customer.tv.subscriptions) {
      subscriptionsQuantity = customer.tv.subscriptions.length;
    }

    if (subscriptionsQuantity > 0) {
        result = <span style={countStyle}>{subscriptionsQuantity}</span>;
    }
    return result;
  }
  getContractsCount() {
    let result = null;
    let contractsToDisplay = null;
    let contentToDisplay = null;
    contractsToDisplay = this.props.mainState.customerContracts[parseInt(this.state.customer.id)];
    if (contractsToDisplay && contractsToDisplay.length > 0) {
      result = <span style={countStyle}>{contractsToDisplay.length}</span>;
    }
    return result;
  }
  createSIMDeliveriesTable() {
    let SIMDeliveriesToDisplay = [];
    // console.log("##### MAIN STATE IN PROFILE #####");
    // console.log(this.props.mainState.SIMDeliveries);

    if (this.state.customer.id in this.props.mainState.SIMDeliveries) {
      SIMDeliveriesToDisplay = this.props.mainState.SIMDeliveries[this.state.customer.id];
    }
    // console.log("##### SIMDeliveriesToDisplay #####");
    // console.log(SIMDeliveriesToDisplay);

    // console.log("##### CURRENT CUSTOMER ID PROFILE #####");
    // console.log(this.state.customer.id);
    let SIMDeliveriesCard = null;
    let SIMDeliveriesCardBody = null;
    let SIMDeliveriesCardHeader = (
      <CardHeader className="txt-black">
        <h5>
          <i className="now-ui-icons ui-1_send" /> Envíos de SIM{"  "}
          {/* <Button
            icon
            round
            key={"createNoteButton"}
            color="info"
            onClick={() => {
              this.showPopUp(NOTA);
            }}
            leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
          /> */}
        </h5>
      </CardHeader>
    );

    if (SIMDeliveriesToDisplay.length > 0) {
      SIMDeliveriesCardBody =
        <CardBody>
          <Table responsive>
            <thead>
              <tr className="text-primary">
                {theadsimdeliveriesmini.map((prop, key) => {
                  if (key === theadsimdeliveriesmini.length - 1)
                    return (
                      <th key={key} className="text-center">
                        {prop}
                      </th>
                    );
                  return (
                    <th key={key} className="text-center">
                      {prop}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {SIMDeliveriesToDisplay
                .map((SIMDelivery, key) => {
                  return (
                    <tr key={key}>
                      <td className="text-center">{SIMDelivery.fecha_envio/*this.createRequestStatus(webMobileRequest)*/}</td>
                      <td className="text-center">{SIMDelivery.fecha_entrega/*this.createRequestStatus(webMobileRequest)*/}</td>
                      <td className="text-center">{this.createCoverageNetworkButton(SIMDelivery.cobertura_sim)}</td>  
                      <td className="text-center">{SIMDelivery.icc}</td>
                      <td className="text-center">{SIMDelivery.numero_movil}</td>
                      <td className="text-center">{SIMDelivery.estado_envio.name}</td>
                      <td className="text-left">
                        {this.createConfirmDeliveryButton(SIMDelivery)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </CardBody>;
    } else {
      SIMDeliveriesCardBody =
        <CardBody>
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene ningún envío...</td>
              </tr>
            </tbody>
          </Table>
        </CardBody>;
    }

    SIMDeliveriesCard = (
      <Card key="SIMDeliveriesCard">
        {SIMDeliveriesCardHeader}
        {SIMDeliveriesCardBody}
      </Card>
    );
    if (SIMDeliveriesToDisplay.length > 0) return SIMDeliveriesCard;
  }
  createNavigationPills() {
    return (
      <div>
        <Button
          round
          key={"pill1"}
          color={this.state.currentPill === PILL_GASTOS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_GASTOS});
          }}
          leftLabel={"now-ui-icons business_money-coins"}
        >
          Gastos {this.getExtraExpensesCount()}
        </Button>
        {" "}
        <Button
          round
          key={"pill2"}
          color={this.state.currentPill === PILL_MOVILES ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_MOVILES});
          }}
          leftLabel={"now-ui-icons tech_mobile"}
        >
          Móviles {this.getMobilesCount()}
        </Button>
        {" "}
        <Button
          round
          key={"pillTV"}
          color={this.state.currentPill === PILL_TV ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_TV});
          }}
          leftLabel={"now-ui-icons tech_tv"}
        >
          TV {this.getTvCount()}
        </Button>
        {" "}
        <Button
          round
          key={"pill3"}
          color={this.state.currentPill === PILL_CONTRATOS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_CONTRATOS});
          }}
          leftLabel={"now-ui-icons files_paper"}
        >
          Contratos {this.getContractsCount()}
        </Button>
        {" "}
        {!isExterno && <Button
          round
          key={"pill4"}
          color={this.areReturnedBills() ? "danger" : (this.state.currentPill === PILL_FACTURAS ? "primary" : "default")}
          onClick={() => {
            this.setState({currentPill: PILL_FACTURAS});
          }}
          leftLabel={"now-ui-icons files_single-copy-04"}
        >
          Facturas {this.getBillsCount()}
        </Button>}
        {" "}
        {!isExterno && <Button
          round
          key={"pill5"}
          color={this.state.currentPill === PILL_CITAS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_CITAS});
          }}
          leftLabel={"now-ui-icons ui-1_calendar-60"}
        >
          Citas {this.getHomeVisitsCount()}
        </Button>}
        {" "}
        <Button
          round
          key={"pill6"}
          color={this.state.currentPill === PILL_COMUNICACIONES ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_COMUNICACIONES});
          }}
          leftLabel={"now-ui-icons ui-2_chat-round"}
        >
          Comunicaciones {this.getCommunicationsCount()}
        </Button>
        {" "}
        {!isExterno && <Button
          round
          key={"pill7"}
          color={this.state.currentPill === PILL_TICKETS ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_TICKETS});
          }}
          leftLabel={"now-ui-icons ui-2_chat-round"}
        >
          Tickets {this.getTicketsCount()}
        </Button>}
        {" "}
        {!isExterno && <Button
          round
          key={"pill8"}
          color={this.state.currentPill === PILL_SECRET ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_SECRET});
          }}
          leftLabel={"now-ui-icons business_globe"}
        >
          Secret
        </Button>}
      </div>
    );
  }
  getPaymentLink(short_url = false) {
    let state = this.state;
    state.isGettingPaymentLink = true;
    this.setState(state);

    this.props.getPaymentLink(this.props.match.params.customerID, short_url).then(result => {
        /* ////// console.log("################## RESPUESTA ################");
        ////// console.log(result); */
        let state = this.state;
        state.isGettingPaymentLink = false;
        let response = result;// result.data;
        if (response.result === "OK") {
          state.paymentLink = response.url;
        } else {
          // this.showError(response.error);
        }
        this.setState(state);
      })
      .catch((error) => {
        // Error 😨
        this.setState({
          isGettingPaymentLink: false
        });
        // this.showError("Error al obtener el enlace, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  validateBillItem(item) {
    if (!item) return false;
    if (!item.concept || item.concept.length < 2) return false;
    if (!item.price) return false;
    return true;
  }
  validateAllBillItems(items) {
    if (!items) return false;
    if (Object.keys(items).length < 1) return false;
    let result = true;
    Object.keys(items).map(itemId => {
      let item = items[itemId];
      result = result && this.validateBillItem(item);
    });
    return result;
  }
  formatPrice(price) {
    if (price.endsWith(".00")) price = price.replace(".00", "");
    if (price.endsWith(".0")) price = price.replace(".0", "");
    if (price.endsWith(",00")) price = price.replace(",00", "");
    if (price.endsWith(",0")) price = price.replace(",0", "");
    switch (Number(price).countDecimals()) {
      case 0:
        return price + "00";
      case 1:
        return price.replace(".", "") + "0";
      case 2:
        return price.replace(".", "");
      default:
    }
  }
  createCustomerBill() {
    let items = [];
    let billItems = this.state.billItems;
    items = Object.keys(billItems).map(itemId => {
      let item = billItems[itemId];
      return {
        related: item.extraInfo,
        name: item.concept,
        price: this.formatPrice(parseFloat(item.price).toString())
      };
    });
    if (this.state.creatingBill) return;
    this.setState({
      creatingBill: true
    });
    if (this.state.selectedBillType === 410) {
      let request = {
        items: items,
        order_ids: this.state.selectedRectificationBills,
        id: this.props.match.params.customerID
      };
      console.log("factura rectificativa", request);
      this.props.userData.createRectificationBill(request, this.props.match.params.customerID).then(result => {
        this.setState({
          creatingBill: false
        });
        if (result.ok) {
          // this.props.userData.setCustomerOrders(this.props.match.params.customerID, result.orders);
          this.props.userData.pushCustomerOrder(this.props.match.params.customerID, result.order);
          this.setState({
            billItems: []
          });
          let options = {
            place: "tr",
            message: "Factura creada correctamente",
            type: "danger",
            icon: "now-ui-icons users_single-02",
            autoDismiss: 3
          };
          this.props.userData.showNotification(options);
        } else {
          console.log("Something went wrong: " + result.error);
        }
      })
      .catch((error) => {
        this.setState({
          creatingBill: false
        });
        // Error 😨
        console.log("Error al crear la factura: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    } else if (this.state.selectedBillType === 412) {
      let request = {
        items: items,
        id: this.props.match.params.customerID
      };
      console.log("factura proforma", request);
      this.props.userData.createProformaBill(request, this.props.match.params.customerID).then(result => {
        this.setState({
          creatingBill: false
        });
        if (result.ok) {
          // this.props.userData.setCustomerOrders(this.props.match.params.customerID, result.orders);
          this.props.userData.pushCustomerOrder(this.props.match.params.customerID, result.order);
          this.setState({
            billItems: []
          });
          let options = {
            place: "tr",
            message: "Factura proforma creada correctamente",
            type: "danger",
            icon: "now-ui-icons users_single-02",
            autoDismiss: 3
          };
          this.props.userData.showNotification(options);
        } else {
          console.log("Something went wrong: " + result.error);
        }
      })
      .catch((error) => {
        this.setState({
          creatingBill: false
        });
        // Error 😨
        console.log("Error al crear la factura proforma: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    } else {
      this.props.userData.createBill(items, this.props.match.params.customerID).then(result => {
        this.setState({
          creatingBill: false
        });
        if (result.ok) {
          // this.props.userData.setCustomerOrders(this.props.match.params.customerID, result.orders);
          this.props.userData.pushCustomerOrder(this.props.match.params.customerID, result.order);
          this.setState({
            billItems: []
          });
          let options = {
            place: "tr",
            message: "Factura creada correctamente",
            type: "danger",
            icon: "now-ui-icons users_single-02",
            autoDismiss: 3
          };
          this.props.userData.showNotification(options);
        } else {
          console.log("Something went wrong: " + result.error);
        }
      })
      .catch((error) => {
        this.setState({
          creatingBill: false
        });
        // Error 😨
        console.log("Error al crear la factura: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    }
  }
  async generateRectificationBillItems() {
    if (!this.state.selectedRectificationBills || this.state.isGettingRectificationItems) return;
    this.setState({
      isGeneratingRectificationBillItems: true
    });
    this.props.userData.getRectificationBillItems(this.state.selectedRectificationBills).then(result => {
      this.setState({
        isGeneratingRectificationBillItems: false
      });
      if (result.ok) {
        let billItems = this.state.billItems;
        if (!billItems) billItems = [];
        result.items.map(item => {
          let newItem = {
            id: uuid(),
            extraInfo: item.related,
            concept: item.name,
            price: item.price
          }
          billItems[newItem.id] = newItem;
        });
        this.setState({ billItems: billItems });
        let options = {
          place: "tr",
          message: "Conceptos rectificativos cargados",
          type: "success",
          icon: "now-ui-icons users_single-02",
          autoDismiss: 3
        };
        this.props.userData.showNotification(options);
      } else {
        console.log("Something went wrong: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({
        isGeneratingRectificationBillItems: false
      });
      // Error 😨
      console.log("Error al crear la factura: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  getRectificationBillItems() {    
    let ordersToDisplay = this.props.mainState.ordersByCustomer && this.props.mainState.ordersByCustomer[this.state.customer.id] ? this.props.mainState.ordersByCustomer[this.state.customer.id] : [];
    if (!ordersToDisplay) return null;
    let result = [];
    Object.keys(ordersToDisplay).sort((a,b)=>b-a).map(order_id => {
      let order = ordersToDisplay[order_id];
      // let isThisSelectedOrder = (this.state.showItems === order_id) || (this.state.showNotes === order_id) || (this.state.registerPayment === order_id);
      let overcharge = "";
      // if (!Array.isArray(order.fecha_devolucion)) {
      //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
      // }
      // if (!Array.isArray(order.fecha_pago_devolucion)) {
      //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
      // }
      if (order.devuelta) overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
      let remaining = null;
      if (order.remaining_100 > 0 && order.remaining_amount !== "") {
        remaining = "debe " + order.remaining_amount;
      }
      let unpaid_date = "";
      // if (this.state.currentPill === PILL_DEVUELTAS) {
      try {
        unpaid_date = order.fecha_devolucion ? order.fecha_devolucion.replace(/-/g,'/').split(" ")[0] : "";
      } catch (error) {
        unpaid_date = JSON.stringify(order.fecha_devolucion);
      }
      let currentOrderTr = (
        <tr key={order.numero_pedido}>
          <td className="text-center">
            {order.fecha}
            {unpaid_date && unpaid_date !== "" && unpaid_date !== '[""]' ? (<span><br /><span className="item-related unpaid-date"><i className="now-ui-icons design_scissors" /> {unpaid_date}</span></span>) : null}
          </td>
          <td className="text-center">{order.numero_pedido}</td>
          <td className="text-center">{order.total}{overcharge}
            {remaining ? (<span><br /><span className="item-related"> {remaining}</span></span>) : null}
          </td>
          <td className="text-center">{this.paymentStatus(order)}</td>
        </tr>
      );
      let label = "[" + order.estado_pedido + "] " + order.numero_pedido + " - " + order.fecha + " - " + (unpaid_date && unpaid_date !== "" && unpaid_date !== '[""]' ? "Devuelto el " + unpaid_date : "") + " - " + order.total + (remaining || "");
      result.push({ label: label, value: order.order_id });
    });
    console.log("Rectification options", result);
    return result;
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    let isDisabled = false;
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }
    
    statusReady = (
      <Button
        color={statusButtonColor}
        size="sm"
      >
        <i className={statusButtonIcon} /> {payment}
      </Button>
    );

    return statusReady;
  }
  createNewBillForm() {
    let billItems = this.state.billItems;
    if (!billItems) billItems = [];
    let itemsTable = null;
    let itemsRows = null;
    if(Object.keys(billItems).length > 0) {
      itemsRows = Object.keys(billItems).map(itemId => {
        let item = billItems[itemId];
        return (
          <tr key={itemId}>
            <td>
              {this.validateBillItem(item) ? <i className="now-ui-icons ui-1_check color-primary" /> : <i className="now-ui-icons ui-1_bell-53 color-warning" />}
            </td>
            <td>
              <Input 
                type="text" 
                value={item.extraInfo || ""} 
                placeholder={"Periodo, línea asociada..."}
                onChange={(e) => {
                  let billItems = this.state.billItems;
                  item.extraInfo = e.target.value;
                  billItems[itemId] = item;
                  this.setState({ billItems: billItems });
                }}
              />
            </td>
            <td>
              <Input 
                type="text" 
                value={item.concept || ""} 
                placeholder={"Asistencia técnica, DECOs..."}
                onChange={(e) => {
                  let billItems = this.state.billItems;
                  item.concept = e.target.value;
                  billItems[itemId] = item;
                  this.setState({ billItems: billItems });
                }}
              />
            </td>
            <td>
              <Input 
                type="number" 
                value={item.price || ""} 
                onChange={(e) => {
                  let billItems = this.state.billItems;
                  item.price = e.target.value;
                  billItems[itemId] = item;
                  this.setState({ billItems: billItems });
                }}
              />
            </td>
            <td>
              <Button round icon color="danger"
                onClick={e => {
                    let billItems = this.state.billItems;
                    let newBillItems = [];
                    Object.keys(billItems).map(itemKey => {
                      if(itemKey !== itemId) newBillItems[itemKey] = billItems[itemKey];
                    });
                    this.setState({ billItems: newBillItems });
                  }}
                >
                <i className="now-ui-icons ui-1_simple-remove" />
              </Button>
            </td>
          </tr>
        );
      });
    } else {
      itemsRows = (
        <tr>
          <td className="text-center" colSpan={4}>
            Todavía no hay conceptos en la factura. Pulsa <b>añadir item</b>
          </td>
        </tr>
      );
      // itemsTable = <div className="text-center">Todavía no hay conceptos en la factura. Pulsa <b>añadir item</b></div>;
    }
    itemsTable = (
      <Table>
        <thead>
          <tr>
            <th></th>
            <th><span className="item-related table-header color-black">Opcional</span><br /><b>Info extra</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Concepto</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Importe <Label>IVA Incluido</Label></b></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {itemsRows}
          <tr>
            <td className="text-center" colSpan={4}>
              <Button round color="primary"
                onClick={e => {
                    let newItem = {
                      id: uuid(),
                      extraInfo: "",
                      concept: "",
                      price: 0
                    }
                    let billItems = this.state.billItems;
                    if (!billItems) billItems = [];
                    billItems[newItem.id] = newItem;
                    this.setState({ billItems: billItems });
                  }}
                >
                <i className="now-ui-icons ui-1_simple-add" />{" "} Añadir item
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    );
    let itemsReady = this.validateAllBillItems(billItems);
    return (
      <Card>
        <CardHeader>
          <h5>
            <i className="now-ui-icons files_paper" /> Nueva factura {" "}
            <AntdSelect
              // mode="multiple"
              // allowClear
              status={this.state.selectedBillType ? null : "error"}
              style={{
                width: "auto"
              }}
              // loading={!this.state.myTemplates}
              placeholder="Tipo de factura"
              value={this.state.selectedBillType}
              // defaultValue={['a10', 'c12']}
              onChange={value => this.handleSelectedBillTypeChange(value)}
              options={[{value: 409, label: "Normal"}, {value: 410, label: "Rectificativa"}, {value: 412, label: "Proforma"}]}
              suffixIcon={<i className="now-ui-icons design_bullet-list-67" />}
              size="large"
              // disabled={this.state.isAssigningSchedule}
            />
          </h5>
          {this.state.selectedBillType === 410 && <AntdSelect
            mode="multiple"
            allowClear
            style={{
              width: "100%"
            }}
            status={this.state.selectedRectificationBills ? null : "error"}
            // loading={!this.getRectificationBillItems()}
            placeholder="Selecciona las facturas"
            value={this.state.selectedRectificationBills}
            // defaultValue={['a10', 'c12']}
            onChange={value => this.selectedRectificationBills(value)}
            options={this.getRectificationBillItems()}
            suffixIcon={<i className="now-ui-icons files_single-copy-04" />}
            showArrow
            filterOption={(inputValue, option) =>{
              if (option && option.label) {
                return option.label
                  .toLowerCase()
                  .includes(inputValue.toLowerCase());
              }
            }}
            size="large"
            // disabled={this.state.isAssigningSchedule}
          />}
          {this.state.selectedBillType === 410 && (this.state.selectedRectificationBills && this.state.selectedRectificationBills.length > 0) && 
            <Button 
              round
              color={"warning"}
              disabled={this.state.isGeneratingRectificationBillItems}
              onClick={() => this.generateRectificationBillItems()}
              >
                {this.state.isGeneratingRectificationBillItems ? <span><i className="now-ui-icons  arrows-1_refresh-69 spin" /> Generando conceptos</span> : "Generar conceptos"}
            </Button>}
        </CardHeader>
        {((this.state.selectedBillType && this.state.selectedBillType !== 410) || (this.state.selectedBillType && this.state.selectedBillType === 410 && this.state.selectedRectificationBills  && this.state.selectedRectificationBills.length > 0)) && <CardBody>
          {itemsTable}
        </CardBody>}
        <CardFooter>
          <Button 
            round
            color={itemsReady ? "info" : "danger"}
            disabled={!itemsReady || this.state.creatingBill}
            onClick={e => {
                if (itemsReady) this.createCustomerBill();
              }}
            >
              {!this.state.creatingBill ? (itemsReady? <span><i className="now-ui-icons ui-1_check" /> Crear factura</span>: <span><i className="now-ui-icons ui-1_bell-53" /> Crear factura</span>) : null}
              {this.state.creatingBill ? <span><i className="now-ui-icons  arrows-1_refresh-69 spin" /> Creando factura</span> : null}
          </Button>
          {!itemsReady && <span style={{ paddingLeft: "10px"}}>{(Object.keys(billItems).length < 1) ? (this.state.selectedBillType ? "Añade algún item a la factura" : "Selecciona el tipo de factura") : "Hay items con error"}</span>}
        </CardFooter>
      </Card>
    );
  }
  selectedRectificationBills(value) {
    this.setState({ selectedRectificationBills: value });
  }
  createSelectedPillContent() {
    let result = null;
    let paydayOptions = [];
    let customer = this.state.customer;
    let payday = this.state.payday;
    if (!payday) {
      payday = customer.payday;
      if (payday) {
        payday = {
          value: payday,
          label: payday
        };
      }
    }
    for (let i = 1; i < 29; i++) {
      paydayOptions.push({
        value: i,
        label: i
      });
    }
    switch (this.state.currentPill) {
      case PILL_GASTOS:   
        result = this.createExtraExpenses();     
        break;
      case PILL_MOVILES:      
        result = (
          <div>
            <Card>
              <CardHeader>
                <h5>
                  <i className="now-ui-icons tech_mobile" /> Líneas móviles
                </h5>
              </CardHeader>
              <CardBody>{this.createMobiles()}</CardBody>
            </Card>
            {!isExterno && <Card>
              <CardHeader>
                <h5>
                  <i className="now-ui-icons tech_mobile" />
                  <i className="now-ui-icons files_paper" /> Trámites móviles
                </h5>
              </CardHeader>
              <CardBody>{this.createProcedures()}</CardBody>
            </Card>}
            {this.createSIMDeliveriesTable()}
          </div>
        );
        break;
      case PILL_TV:
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons files_single-copy-04" /> Subscripciones de TV
              </h5>
            </CardHeader>
            <CardBody>{this.createTvPill()}</CardBody>
          </Card>
        );        
        break;    
      case PILL_CONTRATOS: 
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons files_single-copy-04" /> Contratos
              </h5>
            </CardHeader>
            <CardBody>
              {/* <Link to={"/contratos/nuevo"}> */}
                <Button round color="info"
                  onClick={e =>
                    this.newContract()
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Nuevo contrato
                </Button>
                <Button round color="default"
                  onClick={e =>
                    this.setGeneratedProductsForNewContract()
                    // this.generateServicesContract()
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Generar desde servicios
                </Button>
              {/* </Link>    */}
              {this.createContractsPill()}</CardBody>
          </Card>
        );     
        break;    
      case PILL_FACTURAS:  
        result = (
          <div>
            {this.areReturnedBills() && this.calculateReturnedBills()}
            <Card>
              <CardHeader>
                <h5>
                  <i className="now-ui-icons business_money-coins" /> Facturas
                  {this.props.userData.isBillingDepartment() && 
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Día de cobro"
                      name="payday"
                      value={payday}
                      options={paydayOptions}
                      onChange={value =>{
                        this.setState({ payday: value });
                        this.setPayday(value.value);
                      }}
                    />
                  }
                </h5>
                <Button 
                  round 
                  disabled={this.state.isGettingPaymentLink}
                  color="primary"
                  onClick={() => {
                    this.getPaymentLink()
                  }}
                >
                  <i className={this.state.isGettingPaymentLink ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons business_money-coins"} /> Enlace de pago
                </Button>
                <Button 
                  round 
                  disabled={this.state.isGettingPaymentLink || !(this.state.paymentLink  && this.state.paymentLink.length > 0)}
                  color="warning"
                  onClick={() => {
                    this.getPaymentLink(true)
                  }}
                >
                  <i className={this.state.isGettingPaymentLink ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons business_money-coins"} /> Acortar enlace
                </Button>
                {this.props.userData.isBillingDepartmentN2() && <Button 
                  round 
                  // disabled={this.state.isGettingPaymentLink || !(this.state.paymentLink  && this.state.paymentLink.length > 0)}
                  color="info"
                  onClick={() => {
                    this.setState({ newBillForm: !this.state.newBillForm });
                  }}
                >
                  Crear factura
                </Button>}
                <Input type="text" disabled value={this.state.paymentLink}></Input>
              </CardHeader>
              <CardBody></CardBody>
            </Card>
            {this.state.newBillForm && this.createNewBillForm()}
            {this.createBills()}
          </div>
        );      
        break;     
      case PILL_CITAS:  
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons ui-1_calendar-60" /> Citas
              </h5>
            </CardHeader>
            <CardBody>
              {/* <Link to={"/contratos/nuevo"}> */}
                <Button round color="info"
                  onClick={e =>
                    this.newHomeVisit()
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Nueva cita
                </Button>
              {/* </Link>    */}
              {this.createHomeVisits()}</CardBody>
          </Card>
        );      
        break;    
      case PILL_COMUNICACIONES:  
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons ui-2_chat-round" /> Comunicaciones
              </h5>
            </CardHeader>
            <CardBody>
              {/* <Link to={"/contratos/nuevo"}> */}
                <Button round color="info"
                  onClick={e =>
                    this.newCommunicationToCustomer(EMAIL)
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Email
                </Button>
                <Button round color="primary"
                  onClick={e =>
                    this.newCommunicationToCustomer(CALL)
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Llamada
                </Button>
                <Button round color="warning"
                  onClick={e =>
                    this.newCommunicationToCustomer(SMS)
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> SMS
                </Button>
                <Button round color="default"
                  onClick={e =>
                    this.newCommunicationToCustomer(VISIT)
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Visita a oficina
                </Button>
              {/* </Link>    */}
              {this.createCommunications()}</CardBody>
          </Card>
        );      
        break; 
      case PILL_TICKETS:  
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons shopping_tag-content" /> Tickets
              </h5>
            </CardHeader>
            <CardBody>
                <Button 
                  round 
                  color="danger"
                  onClick={e =>
                    this.newTicket()
                    // console.log("Nuevo ticket desde ficha")
                    }
                  >
                  <i className="now-ui-icons ui-1_simple-add" /> Abrir ticket
                </Button>
              {/* </Link>    */}
              {this.createTickets()}</CardBody>
          </Card>
        );      
        break; 
      case PILL_SECRET:  
        result = (
          <Card>
            <CardHeader>
              <h5>
                <i className="now-ui-icons business_globe" /> Secret
              </h5>
            </CardHeader>
            <CardBody>
              <Button
                color="info"
                size="xs"
                disabled={this.props.mainState.isSearchingCustomerSecret}
                onClick={() => {
                  try {
                    if (!this.checkSecretSpeed) {
                      // console.log("Creating interval getSecretsTraffic");
                      this.checkSecretSpeed = setInterval(async () => {
                        this.getSecretsTraffic();
                      }, 500);
                    }
                  } catch (e) {
                    console.log(e);
                  }
                  this.props.searchCustomerSecret(this.props.match.params.customerID);
                }}
              >
                {this.props.mainState.isSearchingCustomerSecret ? [<i key="buscar-secret-icon" className="now-ui-icons arrows-1_refresh-69 spin" />, <span key="buscar-secret-text">{" Buscando secret"}</span>] : "Buscar secret"}
              </Button>
              {/* </Link>    */}
              {this.createSecrets()}</CardBody>
          </Card>
        );      
        break; 
      default:
        break;
    }
    return result;
  }
  getTvSubscriptionColor(status) {
    let color = "default";
    // Pre-Activada: 240
    // Activada: 219
    // Terminada: 220
    switch(status) {
      case 240:
        color = "warning";
        break;
      case 219:
        color = "primary";
        break;
      case 220:
        color = "default";
        break;
      default:
        color = "danger";
    }

    return color;
  }
  formatTvDate(date) {
    if (!date) return "";
    if (date == null) return "";
    date = date.split(" ")[0].split("-");
    date = date[2] + "/" + date[1] + "/" + date[0];

    return date;
  }
  createTvPill() {
    let tvSubscriptions = undefined;
    let customer = this.state.customer;
    let subscriptionsQuantity = 0;
    
    if (customer.tv && customer.tv.subscriptions) {
      subscriptionsQuantity = customer.tv.subscriptions.length;
    }

    if (subscriptionsQuantity > 0) {
      tvSubscriptions = (
        <Row>
          {customer.tv.subscriptions.map(
            (subscription, key) => {
              let packageName = "";
              if (subscription.package.title === "") subscription.plan = "Error tarifa";
              else packageName = subscription.package.title.replace("nadunet TV ", "");
              let fecha_activacion = this.formatTvDate(subscription.field_fecha_activacion.und[0].value);
              let fecha_fin = subscription.field_fecha_fin_subscripcion.und ? this.formatTvDate(subscription.field_fecha_fin_subscripcion.und[0].value) : "";

              let subscriptionCard = (
                <Card 
                  // onContextMenu={e => {
                  //   e.preventDefault();
                  //   this.handleDoubleClick(AGREGAR_MOVIL, subscription);
                  // }}  
                  color={this.getTvSubscriptionColor(parseInt(subscription.field_estado_subscripcion_tv.und[0].tid))} 
                  className="text-center">
                  <CardHeader className="txt-black">
                    {/* <i className="now-ui-icons tech_mobile" /> {packageName} */}
                    <Row>
                      <Col xs={6} className="text-left txt-black">
                        <span className="category txt-black">
                          <i class="now-ui-icons ui-1_calendar-60"></i>{" "}
                          {fecha_activacion}
                        </span>
                      </Col>
                      <Col xs={6} className="text-right txt-black">
                        <span className="category txt-black">
                          <i class="now-ui-icons ui-1_calendar-60"></i>{" "}
                          {fecha_fin}
                        </span>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody className="text-center txt-white h3 h-nomargin">
                    {packageName}
                  </CardBody>
                  <CardFooter className="text-right txt-black">
                    <Row>
                      <Col xs={8} className="text-left txt-black">
                        {subscription.status || "Sin estado"}
                      </Col>
                      <Col xs={4} className="text-right txt-black" style={{display:"contents"}}>
                        {this.calculateAndFormatTVPrice(subscription.package)}
                      </Col>
                    </Row>
                  </CardFooter>
                </Card>
              );
              return (
                <Col xs={12} sm={6} lg={3} key={key}>
                  {subscriptionCard}
                </Col>
              );
            }
          )}
        </Row>
      );
    } else {
      tvSubscriptions = (
        <Table responsive>
          <tbody>
            <tr>
              <td className="text-center">No tiene ninguna subscripción de TV...</td>
            </tr>
          </tbody>
        </Table>
      );
    }

    return tvSubscriptions;
  }
  buildContractState(contract) {
    let contractState = null;
    let stateText = "Error";
    let stateColor = "default";
    let stateIcon = "ui-1_simple-remove";
    if (contract.estado_id && parseInt(contract.estado_id.tid) > 0) {
      let state_id = parseInt(contract.estado_id.tid);
      switch (state_id) {
        case CONTRATO_ESPERANDO:
          stateText = contract.estado;
          stateColor = "danger";
          stateIcon = "ui-2_time-alarm";
          break;
        case CONTRATO_FICHA_LISTA:
          stateText = contract.estado;
          stateColor = "primary";
          stateIcon = "ui-2_favourite-28";
          break;
        case CONTRATO_FIRMADO:
          stateText = contract.estado;
          stateColor = "info";
          stateIcon = "ui-1_check";
          break;
        case CONTRATO_RELLENANDO:
          stateText = contract.estado;
          stateColor = "warning";
          stateIcon = "arrows-1_refresh-69 spin reposition-spin";
          break;
        default:
          stateText = "Error";
          stateColor = "default";
          stateIcon = "ui-1_simple-remove";
          break;
      }
    } else {
      stateText = "Error";
      stateColor = "default";
      stateIcon = "ui-1_simple-remove";
    }

    contractState = (
      <Button
        round
        color={stateColor}
        size="sm"
        // icon
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className={"now-ui-icons " + stateIcon} /> {stateText}
        </div>
      </Button>
    );
    return contractState;
  }
  buildContractActions(contract) {
    let contractActions = [];
    contractActions.push(
      <Link
        key={"viewContractButton" + contract.id} 
        to={"/contratos/".concat(contract.id)}>
        <Button
          round
          color="info"
          size="sm"
          // icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>
    );
    // Si todavía no está firmado el contrato
    // console.log("---------------- contrato estado firma -----------------");
    // console.log(contract);
    if (contract.estado_id && parseInt(contract.estado_id.tid) !== 230 && parseInt(contract.estado_id.tid) !== 231) {
      contractActions.push(<span key="separador-3">{" "}</span>);
      contractActions.push(
        <Link
          key={"editContractButton" + contract.id} 
          to={"/contratos/editar/".concat(contract.id)}>
          <Button
            round
            color="primary"
            size="sm"
            // icon
            /* onClick={e =>
              this.viewOrderArticles(order.numero_pedido, e)
            } */
          >
            <div>
              <i className="now-ui-icons loader_gear" /> Editar
            </div>
          </Button>
        </Link>
      );
    }
    if (contract.estado_id && parseInt(contract.estado_id.tid) === 231) {
    }
    return contractActions;
  }
  createContractsPill() {
    let contractsToDisplay = null;
    let contentToDisplay = null;
    contractsToDisplay = this.props.mainState.customerContracts[parseInt(this.state.customer.id)];
    // console.log("############# TEST CONTRATOS EN FICHA - this.props.mainState.customerContracts ##############");
    // console.log(this.props.mainState.customerContracts);
    // console.log("############# TEST CONTRATOS EN FICHA - contractsToDisplay ##############");
    // console.log(contractsToDisplay);
    if (contractsToDisplay) {
      if (contractsToDisplay.length > 0) {
        contentToDisplay = 
          <Table responsive>
            <thead>
              <tr className="text-primary">
                {theadcontracts.map((prop, key) => {
                  if (key === theadcontracts.length - 1)
                    return (
                      <th key={key} className="text-center">
                        {prop}
                      </th>
                    );
                  return <th key={key} className="text-center">{prop}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {contractsToDisplay.map((contract, key) => {
                return (
                  <tr key={contract.id}>
                    <td className="text-center">{contract.titulo}</td>
                    <td className="text-center">{contract.fecha}</td>
                    <td className="text-center">{contract.autor}</td>
                    <td className="text-center">{this.buildContractState(contract)}</td>
                    <td className="text-center">{contract.id}</td>
                    <td className="text-center">{contract.pin}</td>
                    <td className="text-center">{this.buildContractActions(contract)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>;
      } else {
        contentToDisplay = (
          <Row>
            {/*<Label sm={2}>Buscar</Label>*/}
            <Col xs={12} sm={10}>
              No hay contratos
            </Col>
          </Row>
        );
      }
    } else {
      contentToDisplay = (
        <Row>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando contratos...
          </div>
          <br />
        </Row>
      );
    }

    return contentToDisplay;
  }
  updateNewEmail(field, value) {
    let email = this.state.new_email;
    email[field] = value;
    this.setState({ new_email: email });
  }
  updateNewCommunication(type, field, value) {
    let communication_type = this.getCommunicationType(type);

    let communication = this.state[communication_type];
    if (!communication) communication = {};
    communication[field] = value;
    this.setState({ [communication_type]: communication });
  }
  getCommunicationType(type) {
    let communication_type = "";
    switch (type) {
      case EMAIL:
        communication_type = "new_email";
        break;
      case CALL:
        communication_type = "new_call";
        break;
      case SMS:
        communication_type = "new_sms";
        break;
      case VISIT:
        communication_type = "new_visit";
        break;    
      default:
        break;
    }
    return communication_type;
  }
  create_communication() {
    let type = this.state.communicationType;
    let communication_type = this.getCommunicationType(type);
    let communication = this.state[communication_type];
    communication.customer_id = this.state.customer.id;
    communication.type = type;
    if (type === VISIT) communication.title = communication.reason;

    console.log("Nueva comunicación [" + this.state.communicationType + "]", communication);
    this.setState({ writingCommunication: false });
    this.props.userData.create_communication(communication);
  }
  createWriteCommunication() {
    let result = null;
    let type = this.state.communicationType;
    let communication_type = this.getCommunicationType(type);

    switch (type) {
      case EMAIL:
        result = (
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h5>
                    <i className="now-ui-icons ui-1_email-85" /> Escribir email
                  </h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <span className="bg-warning text-center" style={{ 
                      display: "block", 
                      width: "100%", 
                      padding: "10px 20px", 
                      marginBottom: "20px",
                      fontWeight: "bold" }}>
                        El siguiente formulario enviará un email al cliente
                    </span>
                  </Row>
                  <Row>
                    <Col xs={9}>
                      <FormGroup>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Plantilla"
                          name="plantilla"
                          value={this.state.selectedCommunicationTemplate}
                          options={this.props.mainState.communicationTemplates.forOptions}
                          onChange={value =>
                            this.setState({ selectedCommunicationTemplate: value })
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={3}>
                      <Button 
                        round 
                        color="primary"
                        style={{ marginTop: "0" }}
                        onClick={e => {
                              // this.newEmailToCustomer()
                              console.log("Cargar plantilla", this.state.selectedCommunicationTemplate);
                              let templateId = this.state.selectedCommunicationTemplate ? this.state.selectedCommunicationTemplate.value : "0";
                              if (templateId in this.props.mainState.communicationTemplates.templates) {
                                let template = this.props.mainState.communicationTemplates.templates[templateId][0];
                                template = template.body.email;
                                console.log("Plantilla seleccionada", template);
                                this.updateNewEmail("subject", template.subject);
                                this.updateNewEmail("reply_to", template.reply_to);
                                this.updateNewEmail("from_email", template.from.email);
                                this.updateNewEmail("from_name", template.from.name);
                                this.updateNewEmail("body", template.message);
                              }
                              // this.setState({ writingEmail: false });
                            }
                          }
                        >
                        <i className="now-ui-icons arrows-1_cloud-upload-94" /> Cargar
                      </Button>
                    </Col>
                  </Row>
                  <Form className="form-horizontal">
                    <Row>
                      <Col xs={12}>
                        <FormGroup className={this.state.fieldStates["subject"]}>
                          <Label md={12} className="text-left">Asunto</Label>
                          <Input
                            type="text"
                            name="subject"
                            placeholder="Asunto"
                            value={this.state.new_email.subject || ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewEmail("subject", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <FormGroup className={this.state.fieldStates["from_email"]}>
                          <Label md={12} className="text-left">Remitente (email)</Label>
                          <Input
                            type="text"
                            name="from_email"
                            placeholder="Email remitente"
                            value={this.state.new_email.from_email || ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewEmail("from_email", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs={6}>
                        <FormGroup className={this.state.fieldStates["from_name"]}>
                          <Label md={12} className="text-left">Remitente (nombre)</Label>
                          <Input
                            type="text"
                            name="from_name"
                            placeholder="Nombre remitente"
                            value={this.state.new_email.from_name || ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewEmail("from_name", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <FormGroup className={this.state.fieldStates["reply_to"]}>
                          <Label md={12} className="text-left">Responder a (email)</Label>
                          <Input
                            type="text"
                            name="reply_to"
                            placeholder="Email al que responderán"
                            value={this.state.new_email.reply_to || ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewEmail("reply_to", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col size={12}>
                        <FormGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  {/* <Link to={"/contratos/nuevo"}> */}
                    <Button round color="info"
                      onClick={e => {
                            // this.newEmailToCustomer()
                            console.log("Enviar email", this.state);
                            this.setState({ writingEmail: false });
                            let email = this.state.new_email;
                            email.from = {
                              email: email.from_email,
                              name: email.from_name
                            };
                            email.message = email.body;
                            email.customer_id = this.state.customer.id;
                            console.log("Email a enviar", email);
                            this.props.userData.send_customer_email(email);
                          }
                        }
                      >
                      <i className="now-ui-icons ui-1_send" /> Enviar email
                    </Button>
                  {/* </Link>    */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
        break;
      case CALL:
        result = (
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h5>
                    <i className="now-ui-icons tech_mobile" /> Añadir llamada
                  </h5>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal">
                    <Row>
                      <Col xs={12}>
                        <FormGroup className={this.state.fieldStates["subject"]}>
                          <Label md={12} className="text-left">Título</Label>
                          <Input
                            type="text"
                            name="title"
                            placeholder="Llamada (hecha al/recibida del) cliente"
                            value={this.state[communication_type] && this.state[communication_type].title? this.state[communication_type].title : ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewCommunication(type, "title", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <FormGroup className={this.state.fieldStates["mobile"]}>
                          <Label md={12} className="text-left">Teléfono</Label>
                          <Input
                            type="number"
                            name="mobile"
                            placeholder="Destino/Origen de la llamada"
                            value={this.state[communication_type] && this.state[communication_type].mobile? this.state[communication_type].mobile : ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewCommunication(type, "mobile", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col size={12}>
                        <FormGroup>
                          <Label md={12} className="text-left">Descripción</Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  {/* <Link to={"/contratos/nuevo"}> */}
                    <Button round color="primary"
                      onClick={e => {
                            // this.newEmailToCustomer()
                            this.create_communication();
                          }
                        }
                      >
                      <i className="now-ui-icons tech_mobile" /> Añadir llamada
                    </Button>
                  {/* </Link>    */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
        break;
      case SMS:
        result = (
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h5>
                    <i className="now-ui-icons text_align-left" /> Añadir SMS
                  </h5>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal">
                    <Row>
                      <Col xs={12}>
                        <FormGroup className={this.state.fieldStates["subject"]}>
                          <Label md={12} className="text-left">Título</Label>
                          <Input
                            type="text"
                            name="title"
                            placeholder="SMS (enviado al/recibido del) cliente"
                            value={this.state[communication_type] && this.state[communication_type].title? this.state[communication_type].title : ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewCommunication(type, "title", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <FormGroup className={this.state.fieldStates["mobile"]}>
                          <Label md={12} className="text-left">Teléfono</Label>
                          <Input
                            type="number"
                            name="mobile"
                            placeholder="Destino/Origen del SMS"
                            value={this.state[communication_type] && this.state[communication_type].mobile? this.state[communication_type].mobile : ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewCommunication(type, "mobile", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col size={12}>
                        <FormGroup>
                          <Label md={12} className="text-left">Descripción</Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  {/* <Link to={"/contratos/nuevo"}> */}
                    <Button round color="warning"
                      onClick={e => {
                            // this.newEmailToCustomer()
                            this.create_communication();
                          }
                        }
                      >
                      <i className="now-ui-icons text_align-left" /> Añadir SMS
                    </Button>
                  {/* </Link>    */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
        break;
      case VISIT:
        result = (
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h5>
                    <i className="now-ui-icons shopping_shop" /> Añadir visita
                  </h5>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal">
                    <Row>
                      <Col xs={12}>
                        <FormGroup className={this.state.fieldStates["subject"]}>
                          <Label md={12} className="text-left">Motivo</Label>
                          <Input
                            type="text"
                            name="reason"
                            placeholder="Ha venido preguntando por la fibra"
                            value={this.state[communication_type] && this.state[communication_type].reason? this.state[communication_type].reason : ""}
                            onChange={event => {
                              let value = event.target.value;
                              this.updateNewCommunication(type, "reason", value);
                              // this.validateField("subject", event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col size={12}>
                        <FormGroup>
                          <Label md={12} className="text-left">Descripción</Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  {/* <Link to={"/contratos/nuevo"}> */}
                    <Button round color="default"
                      onClick={e => {
                            // this.newEmailToCustomer()
                            this.create_communication();
                          }
                        }
                      >
                      <i className="now-ui-icons shopping_shop" /> Añadir visita
                    </Button>
                  {/* </Link>    */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
        break;
    
      default:
        break;
    }

    return result;
  }
  showBalance(customer) {
    // console.log("Saldo cliente", customer);
    if (!customer) return null;
    if (customer.saldo > 0) {
      return (
        <span className="text-white money-header-profile">Saldo: <b>{formatterCurrency.format(customer.saldo)}</b> {" "}</span>
      );
      return (
        <div className="text-center text-white">
          <h3 style={{marginBottom: 0}}><b>{formatterCurrency.format(customer.saldo)}</b></h3>
          Saldo
        </div>
      );
    }
  }
  render() {
    if (this.state.redirectTo) {
      this.redirectTo(this.state.redirectTo);
      // return <Redirect to={this.state.redirectTo} />;
    }
    // console.log("###### MAINSTATE EN CUSTOMER PROFILE ######");
    // console.log(this.props.mainState);
    if (this.state.customer && (this.props.match.params.customerID in this.props.mainState.customers)) {
      if (this.state.customer.id !== this.props.mainState.customers[this.props.match.params.customerID][0].id) {
        this.setState({
          customer: this.props.mainState.customers[this.props.match.params.customerID][0]
        });
      }
      if (
        !(this.state.customer.id in this.props.mainState.mobileProcedures) &&
        !this.state.mobileProceduresAlreadySearched
      ) {
        this.setState({
          mobileProceduresAlreadySearched: true
        });
        this.props.searchMobileProcedures(this.state.customer.id);
      }
      if (
        !(this.state.customer.id in this.props.mainState.SIMDeliveries) &&
        !this.state.SIMDeliveriesAlreadySearched
      ) {
        this.setState({
          SIMDeliveriesAlreadySearched: true
        });
        this.props.searchSIMDeliveries(this.state.customer.id);
      }
      //console.log("######################## mobileProcedures: ###########################");
      //console.log(this.props.mainState.mobileProcedures);
      let currentCustomer = this.props.mainState.customers[
        this.props.match.params.customerID
      ][0];
      // let mobiles = this.createMobiles();
      // let mobileProcedures = this.createProcedures();
      // let bills = this.createBills();
      //console.log("################## DENTRO DE PERFIL CLIENTE ################");
      //console.log(this.props.mainState.customers);
      let rightColumn = this.createRightColumn();
      let internetAtHome = this.createInternetCard();
      // let extraExpensesColumn = this.createExtraExpenses();
      let navigationPills = this.createNavigationPills();
      let navigationPillContent = this.createSelectedPillContent();
      let formattedNumber = "";
      let writeCommunication = this.createWriteCommunication();
      if (currentCustomer.phone) {
        formattedNumber = currentCustomer.phone;
          // currentCustomer.phone.substring(0, 3) +
          // " " +
          // currentCustomer.phone.substring(3, 6) +
          // " " +
          // currentCustomer.phone.substring(6, 9);
      }
      let returnedBills = this.areReturnedBills();
      return (
        <div>
          <div id="user-services">
            {this.buildHeaderServices()}
          </div>
          <PanelHeader 
            size={returnedBills ? "md" : "sm"}   
            className={returnedBills ? "header-danger" : ""}         
            content={   
              <div>
                {returnedBills &&
                  <div className="text-center text-white">
                    <h3><b>Moroso</b></h3>
                    {this.calculateReturnedBills(true)}
                  </div>}
              </div>
            } 
          />
          <div className="content">
            {this.state.showPopUp && this.createPopUp()}
            {this.state.popUpConfirmation}
            <Row>
              <Col md={rightColumn ? 8 : 12} xs={12}>
                {this.devUser()}
                {internetAtHome}
                {navigationPills}
                {this.state.currentPill === PILL_COMUNICACIONES && this.state.writingCommunication && writeCommunication}
                {navigationPillContent}
                {/* {extraExpensesColumn} */}
              </Col>
              {rightColumn}
            </Row>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <PanelHeader size="sm" />
          <div className="content">
            <Row>
              <Col xs={12}>
                <Card>
                  <CardHeader>
                    <h5 className="title">
                      Perfil del cliente
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <div className="text-center">
                      <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos del cliente...
                    </div>
                    <br />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      );
    }
  }
}

const CustomTooltip = ({ active, payload, label }) => {
  // console.log("tooltip payload", payload);
  // console.log("tooltip label", label);
  // console.log("tooltip active", active);
  if (active && payload && payload.length) {
    let data = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p className="text-center">{data.date}</p>
        <p className="traffic">
          <span>Descarga:</span><span className="label traffic download">{"▼" + data.downloadString}</span>
          <br />
          <span>Subida:</span><span className="label traffic upload">{"▲" + data.uploadString}</span>
        </p>
        {/* <p className="label traffic upload">{"Subida: ▲" + data.uploadString}</p> */}
        {/* <p className="traffic download">▼{rawTraffic.download.string}</span>
        <span className="traffic upload">▲{rawTraffic.upload.string}</span> */}
        {/* <p className="intro">{getIntroOfPage(label)}</p>
        <p className="desc">Anything you want can be displayed here.</p> */}
      </div>
    );
  }

  return null;
};

Number.prototype.countDecimals = function() {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split(".")[1].length || 0;
};

export default CustomerProfile;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerProfile.jsx